import {
  init_sharpen_fragment
} from "./chunk-RKO4KMEN.mjs";
import {
  BindMorphTargetParameters,
  BindSceneUniformBuffer,
  PrepareAttributesForMorphTargetsInfluencers,
  PushAttributesForInstances,
  addClipPlaneUniforms,
  bindClipPlane,
  extractMinAndMaxIndexed,
  init_clipPlaneMaterialHelper,
  init_materialHelper_functions,
  init_math_functions,
  prepareStringDefinesForClipPlanes
} from "./chunk-VNR7RBTM.mjs";
import {
  DrawWrapper,
  PostProcess,
  RenderTargetTexture,
  Viewport,
  init_drawWrapper,
  init_math_viewport,
  init_postProcess,
  init_renderTargetTexture
} from "./chunk-MN6RHL7T.mjs";
import {
  Texture,
  init_texture
} from "./chunk-OTLDKKRS.mjs";
import {
  Node,
  init_node
} from "./chunk-KBPH2HXJ.mjs";
import {
  AbstractScene,
  ImageProcessingConfiguration,
  Scene,
  SceneComponentConstants,
  init_abstractScene,
  init_imageProcessingConfiguration,
  init_scene,
  init_sceneComponent
} from "./chunk-XEBZFSO2.mjs";
import {
  UniformBuffer,
  init_uniformBuffer
} from "./chunk-AUDUKNGA.mjs";
import {
  Frustum,
  SmartArray,
  init_math_frustum,
  init_smartArray
} from "./chunk-KU6MOYBB.mjs";
import {
  VertexBuffer,
  init_buffer
} from "./chunk-VK4AKGHS.mjs";
import {
  Plane,
  SerializationHelper,
  init_decorators_serialization,
  init_math_plane
} from "./chunk-2WRXXKPX.mjs";
import {
  Color4,
  __decorate,
  init_decorators,
  init_math_color,
  init_tslib_es6,
  serialize,
  serializeAsCameraReference,
  serializeAsColor4,
  serializeAsVector2,
  serializeAsVector3
} from "./chunk-LWSYNDGD.mjs";
import {
  GetExponentOfTwo,
  Tools,
  _WarnImport,
  init_devTools,
  init_tools,
  init_tools_functions
} from "./chunk-YVKSXECI.mjs";
import {
  Logger,
  init_logger
} from "./chunk-CGQJYOWJ.mjs";
import {
  BuildArray,
  Epsilon,
  Matrix,
  Quaternion,
  TmpVectors,
  ToGammaSpace,
  Vector2,
  Vector3,
  init_arrayTools,
  init_math_constants,
  init_math_vector
} from "./chunk-KXFHISWH.mjs";
import {
  EngineStore,
  GetClass,
  Observable,
  RegisterClass,
  init_engineStore,
  init_observable,
  init_typeStore
} from "./chunk-PMCXIDBB.mjs";
import {
  __async,
  __esm,
  __spreadValues,
  __superGet
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/Culling/boundingBox.js
var BoundingBox;
var init_boundingBox = __esm({
  "node_modules/@babylonjs/core/Culling/boundingBox.js"() {
    "use strict";
    init_arrayTools();
    init_math_vector();
    init_math_constants();
    BoundingBox = class _BoundingBox {
      /**
       * Creates a new bounding box
       * @param min defines the minimum vector (in local space)
       * @param max defines the maximum vector (in local space)
       * @param worldMatrix defines the new world matrix
       */
      constructor(min, max, worldMatrix) {
        this.vectors = BuildArray(8, Vector3.Zero);
        this.center = Vector3.Zero();
        this.centerWorld = Vector3.Zero();
        this.extendSize = Vector3.Zero();
        this.extendSizeWorld = Vector3.Zero();
        this.directions = BuildArray(3, Vector3.Zero);
        this.vectorsWorld = BuildArray(8, Vector3.Zero);
        this.minimumWorld = Vector3.Zero();
        this.maximumWorld = Vector3.Zero();
        this.minimum = Vector3.Zero();
        this.maximum = Vector3.Zero();
        this._drawWrapperFront = null;
        this._drawWrapperBack = null;
        this.reConstruct(min, max, worldMatrix);
      }
      // Methods
      /**
       * Recreates the entire bounding box from scratch as if we call the constructor in place
       * @param min defines the new minimum vector (in local space)
       * @param max defines the new maximum vector (in local space)
       * @param worldMatrix defines the new world matrix
       */
      reConstruct(min, max, worldMatrix) {
        const minX = min.x, minY = min.y, minZ = min.z, maxX = max.x, maxY = max.y, maxZ = max.z;
        const vectors = this.vectors;
        this.minimum.copyFromFloats(minX, minY, minZ);
        this.maximum.copyFromFloats(maxX, maxY, maxZ);
        vectors[0].copyFromFloats(minX, minY, minZ);
        vectors[1].copyFromFloats(maxX, maxY, maxZ);
        vectors[2].copyFromFloats(maxX, minY, minZ);
        vectors[3].copyFromFloats(minX, maxY, minZ);
        vectors[4].copyFromFloats(minX, minY, maxZ);
        vectors[5].copyFromFloats(maxX, maxY, minZ);
        vectors[6].copyFromFloats(minX, maxY, maxZ);
        vectors[7].copyFromFloats(maxX, minY, maxZ);
        max.addToRef(min, this.center).scaleInPlace(0.5);
        max.subtractToRef(min, this.extendSize).scaleInPlace(0.5);
        this._worldMatrix = worldMatrix || Matrix.IdentityReadOnly;
        this._update(this._worldMatrix);
      }
      /**
       * Scale the current bounding box by applying a scale factor
       * @param factor defines the scale factor to apply
       * @returns the current bounding box
       */
      scale(factor) {
        const tmpVectors = _BoundingBox._TmpVector3;
        const diff = this.maximum.subtractToRef(this.minimum, tmpVectors[0]);
        const len = diff.length();
        diff.normalizeFromLength(len);
        const distance = len * factor;
        const newRadius = diff.scaleInPlace(distance * 0.5);
        const min = this.center.subtractToRef(newRadius, tmpVectors[1]);
        const max = this.center.addToRef(newRadius, tmpVectors[2]);
        this.reConstruct(min, max, this._worldMatrix);
        return this;
      }
      /**
       * Gets the world matrix of the bounding box
       * @returns a matrix
       */
      getWorldMatrix() {
        return this._worldMatrix;
      }
      /**
       * @internal
       */
      _update(world) {
        const minWorld = this.minimumWorld;
        const maxWorld = this.maximumWorld;
        const directions = this.directions;
        const vectorsWorld = this.vectorsWorld;
        const vectors = this.vectors;
        if (!world.isIdentity()) {
          minWorld.setAll(Number.MAX_VALUE);
          maxWorld.setAll(-Number.MAX_VALUE);
          for (let index = 0; index < 8; ++index) {
            const v = vectorsWorld[index];
            Vector3.TransformCoordinatesToRef(vectors[index], world, v);
            minWorld.minimizeInPlace(v);
            maxWorld.maximizeInPlace(v);
          }
          maxWorld.subtractToRef(minWorld, this.extendSizeWorld).scaleInPlace(0.5);
          maxWorld.addToRef(minWorld, this.centerWorld).scaleInPlace(0.5);
        } else {
          minWorld.copyFrom(this.minimum);
          maxWorld.copyFrom(this.maximum);
          for (let index = 0; index < 8; ++index) {
            vectorsWorld[index].copyFrom(vectors[index]);
          }
          this.extendSizeWorld.copyFrom(this.extendSize);
          this.centerWorld.copyFrom(this.center);
        }
        Vector3.FromArrayToRef(world.m, 0, directions[0]);
        Vector3.FromArrayToRef(world.m, 4, directions[1]);
        Vector3.FromArrayToRef(world.m, 8, directions[2]);
        this._worldMatrix = world;
      }
      /**
       * Tests if the bounding box is intersecting the frustum planes
       * @param frustumPlanes defines the frustum planes to test
       * @returns true if there is an intersection
       */
      isInFrustum(frustumPlanes) {
        return _BoundingBox.IsInFrustum(this.vectorsWorld, frustumPlanes);
      }
      /**
       * Tests if the bounding box is entirely inside the frustum planes
       * @param frustumPlanes defines the frustum planes to test
       * @returns true if there is an inclusion
       */
      isCompletelyInFrustum(frustumPlanes) {
        return _BoundingBox.IsCompletelyInFrustum(this.vectorsWorld, frustumPlanes);
      }
      /**
       * Tests if a point is inside the bounding box
       * @param point defines the point to test
       * @returns true if the point is inside the bounding box
       */
      intersectsPoint(point) {
        const min = this.minimumWorld;
        const max = this.maximumWorld;
        const minX = min.x, minY = min.y, minZ = min.z, maxX = max.x, maxY = max.y, maxZ = max.z;
        const pointX = point.x, pointY = point.y, pointZ = point.z;
        const delta = -Epsilon;
        if (maxX - pointX < delta || delta > pointX - minX) {
          return false;
        }
        if (maxY - pointY < delta || delta > pointY - minY) {
          return false;
        }
        if (maxZ - pointZ < delta || delta > pointZ - minZ) {
          return false;
        }
        return true;
      }
      /**
       * Tests if the bounding box intersects with a bounding sphere
       * @param sphere defines the sphere to test
       * @returns true if there is an intersection
       */
      intersectsSphere(sphere) {
        return _BoundingBox.IntersectsSphere(this.minimumWorld, this.maximumWorld, sphere.centerWorld, sphere.radiusWorld);
      }
      /**
       * Tests if the bounding box intersects with a box defined by a min and max vectors
       * @param min defines the min vector to use
       * @param max defines the max vector to use
       * @returns true if there is an intersection
       */
      intersectsMinMax(min, max) {
        const myMin = this.minimumWorld;
        const myMax = this.maximumWorld;
        const myMinX = myMin.x, myMinY = myMin.y, myMinZ = myMin.z, myMaxX = myMax.x, myMaxY = myMax.y, myMaxZ = myMax.z;
        const minX = min.x, minY = min.y, minZ = min.z, maxX = max.x, maxY = max.y, maxZ = max.z;
        if (myMaxX < minX || myMinX > maxX) {
          return false;
        }
        if (myMaxY < minY || myMinY > maxY) {
          return false;
        }
        if (myMaxZ < minZ || myMinZ > maxZ) {
          return false;
        }
        return true;
      }
      /**
       * Disposes the resources of the class
       */
      dispose() {
        var _a, _b;
        (_a = this._drawWrapperFront) == null ? void 0 : _a.dispose();
        (_b = this._drawWrapperBack) == null ? void 0 : _b.dispose();
      }
      // Statics
      /**
       * Tests if two bounding boxes are intersections
       * @param box0 defines the first box to test
       * @param box1 defines the second box to test
       * @returns true if there is an intersection
       */
      static Intersects(box0, box1) {
        return box0.intersectsMinMax(box1.minimumWorld, box1.maximumWorld);
      }
      /**
       * Tests if a bounding box defines by a min/max vectors intersects a sphere
       * @param minPoint defines the minimum vector of the bounding box
       * @param maxPoint defines the maximum vector of the bounding box
       * @param sphereCenter defines the sphere center
       * @param sphereRadius defines the sphere radius
       * @returns true if there is an intersection
       */
      static IntersectsSphere(minPoint, maxPoint, sphereCenter, sphereRadius) {
        const vector = _BoundingBox._TmpVector3[0];
        Vector3.ClampToRef(sphereCenter, minPoint, maxPoint, vector);
        const num = Vector3.DistanceSquared(sphereCenter, vector);
        return num <= sphereRadius * sphereRadius;
      }
      /**
       * Tests if a bounding box defined with 8 vectors is entirely inside frustum planes
       * @param boundingVectors defines an array of 8 vectors representing a bounding box
       * @param frustumPlanes defines the frustum planes to test
       * @returns true if there is an inclusion
       */
      static IsCompletelyInFrustum(boundingVectors, frustumPlanes) {
        for (let p = 0; p < 6; ++p) {
          const frustumPlane = frustumPlanes[p];
          for (let i = 0; i < 8; ++i) {
            if (frustumPlane.dotCoordinate(boundingVectors[i]) < 0) {
              return false;
            }
          }
        }
        return true;
      }
      /**
       * Tests if a bounding box defined with 8 vectors intersects frustum planes
       * @param boundingVectors defines an array of 8 vectors representing a bounding box
       * @param frustumPlanes defines the frustum planes to test
       * @returns true if there is an intersection
       */
      static IsInFrustum(boundingVectors, frustumPlanes) {
        for (let p = 0; p < 6; ++p) {
          let canReturnFalse = true;
          const frustumPlane = frustumPlanes[p];
          for (let i = 0; i < 8; ++i) {
            if (frustumPlane.dotCoordinate(boundingVectors[i]) >= 0) {
              canReturnFalse = false;
              break;
            }
          }
          if (canReturnFalse) {
            return false;
          }
        }
        return true;
      }
    };
    BoundingBox._TmpVector3 = BuildArray(3, Vector3.Zero);
  }
});

// node_modules/@babylonjs/core/Culling/boundingSphere.js
var BoundingSphere;
var init_boundingSphere = __esm({
  "node_modules/@babylonjs/core/Culling/boundingSphere.js"() {
    "use strict";
    init_arrayTools();
    init_math_vector();
    BoundingSphere = class _BoundingSphere {
      /**
       * Creates a new bounding sphere
       * @param min defines the minimum vector (in local space)
       * @param max defines the maximum vector (in local space)
       * @param worldMatrix defines the new world matrix
       */
      constructor(min, max, worldMatrix) {
        this.center = Vector3.Zero();
        this.centerWorld = Vector3.Zero();
        this.minimum = Vector3.Zero();
        this.maximum = Vector3.Zero();
        this.reConstruct(min, max, worldMatrix);
      }
      /**
       * Recreates the entire bounding sphere from scratch as if we call the constructor in place
       * @param min defines the new minimum vector (in local space)
       * @param max defines the new maximum vector (in local space)
       * @param worldMatrix defines the new world matrix
       */
      reConstruct(min, max, worldMatrix) {
        this.minimum.copyFrom(min);
        this.maximum.copyFrom(max);
        const distance = Vector3.Distance(min, max);
        max.addToRef(min, this.center).scaleInPlace(0.5);
        this.radius = distance * 0.5;
        this._update(worldMatrix || Matrix.IdentityReadOnly);
      }
      /**
       * Scale the current bounding sphere by applying a scale factor
       * @param factor defines the scale factor to apply
       * @returns the current bounding box
       */
      scale(factor) {
        const newRadius = this.radius * factor;
        const tmpVectors = _BoundingSphere._TmpVector3;
        const tempRadiusVector = tmpVectors[0].setAll(newRadius);
        const min = this.center.subtractToRef(tempRadiusVector, tmpVectors[1]);
        const max = this.center.addToRef(tempRadiusVector, tmpVectors[2]);
        this.reConstruct(min, max, this._worldMatrix);
        return this;
      }
      /**
       * Gets the world matrix of the bounding box
       * @returns a matrix
       */
      getWorldMatrix() {
        return this._worldMatrix;
      }
      // Methods
      /**
       * @internal
       */
      _update(worldMatrix) {
        if (!worldMatrix.isIdentity()) {
          Vector3.TransformCoordinatesToRef(this.center, worldMatrix, this.centerWorld);
          const tempVector = _BoundingSphere._TmpVector3[0];
          Vector3.TransformNormalFromFloatsToRef(1, 1, 1, worldMatrix, tempVector);
          this.radiusWorld = Math.max(Math.abs(tempVector.x), Math.abs(tempVector.y), Math.abs(tempVector.z)) * this.radius;
        } else {
          this.centerWorld.copyFrom(this.center);
          this.radiusWorld = this.radius;
        }
      }
      /**
       * Tests if the bounding sphere is intersecting the frustum planes
       * @param frustumPlanes defines the frustum planes to test
       * @returns true if there is an intersection
       */
      isInFrustum(frustumPlanes) {
        const center = this.centerWorld;
        const radius = this.radiusWorld;
        for (let i = 0; i < 6; i++) {
          if (frustumPlanes[i].dotCoordinate(center) <= -radius) {
            return false;
          }
        }
        return true;
      }
      /**
       * Tests if the bounding sphere center is in between the frustum planes.
       * Used for optimistic fast inclusion.
       * @param frustumPlanes defines the frustum planes to test
       * @returns true if the sphere center is in between the frustum planes
       */
      isCenterInFrustum(frustumPlanes) {
        const center = this.centerWorld;
        for (let i = 0; i < 6; i++) {
          if (frustumPlanes[i].dotCoordinate(center) < 0) {
            return false;
          }
        }
        return true;
      }
      /**
       * Tests if a point is inside the bounding sphere
       * @param point defines the point to test
       * @returns true if the point is inside the bounding sphere
       */
      intersectsPoint(point) {
        const squareDistance = Vector3.DistanceSquared(this.centerWorld, point);
        if (this.radiusWorld * this.radiusWorld < squareDistance) {
          return false;
        }
        return true;
      }
      // Statics
      /**
       * Checks if two sphere intersect
       * @param sphere0 sphere 0
       * @param sphere1 sphere 1
       * @returns true if the spheres intersect
       */
      static Intersects(sphere0, sphere1) {
        const squareDistance = Vector3.DistanceSquared(sphere0.centerWorld, sphere1.centerWorld);
        const radiusSum = sphere0.radiusWorld + sphere1.radiusWorld;
        if (radiusSum * radiusSum < squareDistance) {
          return false;
        }
        return true;
      }
      /**
       * Creates a sphere from a center and a radius
       * @param center The center
       * @param radius radius
       * @param matrix Optional worldMatrix
       * @returns The sphere
       */
      static CreateFromCenterAndRadius(center, radius, matrix) {
        this._TmpVector3[0].copyFrom(center);
        this._TmpVector3[1].copyFromFloats(0, 0, radius);
        this._TmpVector3[2].copyFrom(center);
        this._TmpVector3[0].addInPlace(this._TmpVector3[1]);
        this._TmpVector3[2].subtractInPlace(this._TmpVector3[1]);
        const sphere = new _BoundingSphere(this._TmpVector3[0], this._TmpVector3[2]);
        if (matrix) {
          sphere._worldMatrix = matrix;
        } else {
          sphere._worldMatrix = Matrix.Identity();
        }
        return sphere;
      }
    };
    BoundingSphere._TmpVector3 = BuildArray(3, Vector3.Zero);
  }
});

// node_modules/@babylonjs/core/Culling/boundingInfo.js
var _result0, _result1, computeBoxExtents, axisOverlap, BoundingInfo;
var init_boundingInfo = __esm({
  "node_modules/@babylonjs/core/Culling/boundingInfo.js"() {
    "use strict";
    init_arrayTools();
    init_math_vector();
    init_math_vector();
    init_boundingBox();
    init_boundingSphere();
    _result0 = { min: 0, max: 0 };
    _result1 = { min: 0, max: 0 };
    computeBoxExtents = (axis, box, result) => {
      const p = Vector3.Dot(box.centerWorld, axis);
      const r0 = Math.abs(Vector3.Dot(box.directions[0], axis)) * box.extendSize.x;
      const r1 = Math.abs(Vector3.Dot(box.directions[1], axis)) * box.extendSize.y;
      const r2 = Math.abs(Vector3.Dot(box.directions[2], axis)) * box.extendSize.z;
      const r = r0 + r1 + r2;
      result.min = p - r;
      result.max = p + r;
    };
    axisOverlap = (axis, box0, box1) => {
      computeBoxExtents(axis, box0, _result0);
      computeBoxExtents(axis, box1, _result1);
      return !(_result0.min > _result1.max || _result1.min > _result0.max);
    };
    BoundingInfo = class _BoundingInfo {
      /**
       * Constructs bounding info
       * @param minimum min vector of the bounding box/sphere
       * @param maximum max vector of the bounding box/sphere
       * @param worldMatrix defines the new world matrix
       */
      constructor(minimum, maximum, worldMatrix) {
        this._isLocked = false;
        this.boundingBox = new BoundingBox(minimum, maximum, worldMatrix);
        this.boundingSphere = new BoundingSphere(minimum, maximum, worldMatrix);
      }
      /**
       * Recreates the entire bounding info from scratch as if we call the constructor in place
       * @param min defines the new minimum vector (in local space)
       * @param max defines the new maximum vector (in local space)
       * @param worldMatrix defines the new world matrix
       */
      reConstruct(min, max, worldMatrix) {
        this.boundingBox.reConstruct(min, max, worldMatrix);
        this.boundingSphere.reConstruct(min, max, worldMatrix);
      }
      /**
       * min vector of the bounding box/sphere
       */
      get minimum() {
        return this.boundingBox.minimum;
      }
      /**
       * max vector of the bounding box/sphere
       */
      get maximum() {
        return this.boundingBox.maximum;
      }
      /**
       * If the info is locked and won't be updated to avoid perf overhead
       */
      get isLocked() {
        return this._isLocked;
      }
      set isLocked(value) {
        this._isLocked = value;
      }
      // Methods
      /**
       * Updates the bounding sphere and box
       * @param world world matrix to be used to update
       */
      update(world) {
        if (this._isLocked) {
          return;
        }
        this.boundingBox._update(world);
        this.boundingSphere._update(world);
      }
      /**
       * Recreate the bounding info to be centered around a specific point given a specific extend.
       * @param center New center of the bounding info
       * @param extend New extend of the bounding info
       * @returns the current bounding info
       */
      centerOn(center, extend) {
        const minimum = _BoundingInfo._TmpVector3[0].copyFrom(center).subtractInPlace(extend);
        const maximum = _BoundingInfo._TmpVector3[1].copyFrom(center).addInPlace(extend);
        this.boundingBox.reConstruct(minimum, maximum, this.boundingBox.getWorldMatrix());
        this.boundingSphere.reConstruct(minimum, maximum, this.boundingBox.getWorldMatrix());
        return this;
      }
      /**
       * Grows the bounding info to include the given point.
       * @param point The point that will be included in the current bounding info (in local space)
       * @returns the current bounding info
       */
      encapsulate(point) {
        const minimum = Vector3.Minimize(this.minimum, point);
        const maximum = Vector3.Maximize(this.maximum, point);
        this.reConstruct(minimum, maximum, this.boundingBox.getWorldMatrix());
        return this;
      }
      /**
       * Grows the bounding info to encapsulate the given bounding info.
       * @param toEncapsulate The bounding info that will be encapsulated in the current bounding info
       * @returns the current bounding info
       */
      encapsulateBoundingInfo(toEncapsulate) {
        const invw = TmpVectors.Matrix[0];
        this.boundingBox.getWorldMatrix().invertToRef(invw);
        const v = TmpVectors.Vector3[0];
        Vector3.TransformCoordinatesToRef(toEncapsulate.boundingBox.minimumWorld, invw, v);
        this.encapsulate(v);
        Vector3.TransformCoordinatesToRef(toEncapsulate.boundingBox.maximumWorld, invw, v);
        this.encapsulate(v);
        return this;
      }
      /**
       * Scale the current bounding info by applying a scale factor
       * @param factor defines the scale factor to apply
       * @returns the current bounding info
       */
      scale(factor) {
        this.boundingBox.scale(factor);
        this.boundingSphere.scale(factor);
        return this;
      }
      /**
       * Returns `true` if the bounding info is within the frustum defined by the passed array of planes.
       * @param frustumPlanes defines the frustum to test
       * @param strategy defines the strategy to use for the culling (default is BABYLON.AbstractMesh.CULLINGSTRATEGY_STANDARD)
       * The different strategies available are:
       * * BABYLON.AbstractMesh.CULLINGSTRATEGY_STANDARD most accurate but slower @see https://doc.babylonjs.com/typedoc/classes/BABYLON.AbstractMesh#CULLINGSTRATEGY_STANDARD
       * * BABYLON.AbstractMesh.CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY faster but less accurate @see https://doc.babylonjs.com/typedoc/classes/BABYLON.AbstractMesh#CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY
       * * BABYLON.AbstractMesh.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION can be faster if always visible @see https://doc.babylonjs.com/typedoc/classes/BABYLON.AbstractMesh#CULLINGSTRATEGY_OPTIMISTIC_INCLUSION
       * * BABYLON.AbstractMesh.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION_THEN_BSPHERE_ONLY can be faster if always visible @see https://doc.babylonjs.com/typedoc/classes/BABYLON.AbstractMesh#CULLINGSTRATEGY_OPTIMISTIC_INCLUSION_THEN_BSPHERE_ONLY
       * @returns true if the bounding info is in the frustum planes
       */
      isInFrustum(frustumPlanes, strategy = 0) {
        const inclusionTest = strategy === 2 || strategy === 3;
        if (inclusionTest) {
          if (this.boundingSphere.isCenterInFrustum(frustumPlanes)) {
            return true;
          }
        }
        if (!this.boundingSphere.isInFrustum(frustumPlanes)) {
          return false;
        }
        const bSphereOnlyTest = strategy === 1 || strategy === 3;
        if (bSphereOnlyTest) {
          return true;
        }
        return this.boundingBox.isInFrustum(frustumPlanes);
      }
      /**
       * Gets the world distance between the min and max points of the bounding box
       */
      get diagonalLength() {
        const boundingBox = this.boundingBox;
        const diag = boundingBox.maximumWorld.subtractToRef(boundingBox.minimumWorld, _BoundingInfo._TmpVector3[0]);
        return diag.length();
      }
      /**
       * Checks if a cullable object (mesh...) is in the camera frustum
       * Unlike isInFrustum this checks the full bounding box
       * @param frustumPlanes Camera near/planes
       * @returns true if the object is in frustum otherwise false
       */
      isCompletelyInFrustum(frustumPlanes) {
        return this.boundingBox.isCompletelyInFrustum(frustumPlanes);
      }
      /**
       * @internal
       */
      _checkCollision(collider) {
        return collider._canDoCollision(this.boundingSphere.centerWorld, this.boundingSphere.radiusWorld, this.boundingBox.minimumWorld, this.boundingBox.maximumWorld);
      }
      /**
       * Checks if a point is inside the bounding box and bounding sphere or the mesh
       * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/interactions/mesh_intersect
       * @param point the point to check intersection with
       * @returns if the point intersects
       */
      intersectsPoint(point) {
        if (!this.boundingSphere.centerWorld) {
          return false;
        }
        if (!this.boundingSphere.intersectsPoint(point)) {
          return false;
        }
        if (!this.boundingBox.intersectsPoint(point)) {
          return false;
        }
        return true;
      }
      /**
       * Checks if another bounding info intersects the bounding box and bounding sphere or the mesh
       * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/interactions/mesh_intersect
       * @param boundingInfo the bounding info to check intersection with
       * @param precise if the intersection should be done using OBB
       * @returns if the bounding info intersects
       */
      intersects(boundingInfo, precise) {
        if (!BoundingSphere.Intersects(this.boundingSphere, boundingInfo.boundingSphere)) {
          return false;
        }
        if (!BoundingBox.Intersects(this.boundingBox, boundingInfo.boundingBox)) {
          return false;
        }
        if (!precise) {
          return true;
        }
        const box0 = this.boundingBox;
        const box1 = boundingInfo.boundingBox;
        if (!axisOverlap(box0.directions[0], box0, box1)) {
          return false;
        }
        if (!axisOverlap(box0.directions[1], box0, box1)) {
          return false;
        }
        if (!axisOverlap(box0.directions[2], box0, box1)) {
          return false;
        }
        if (!axisOverlap(box1.directions[0], box0, box1)) {
          return false;
        }
        if (!axisOverlap(box1.directions[1], box0, box1)) {
          return false;
        }
        if (!axisOverlap(box1.directions[2], box0, box1)) {
          return false;
        }
        if (!axisOverlap(Vector3.Cross(box0.directions[0], box1.directions[0]), box0, box1)) {
          return false;
        }
        if (!axisOverlap(Vector3.Cross(box0.directions[0], box1.directions[1]), box0, box1)) {
          return false;
        }
        if (!axisOverlap(Vector3.Cross(box0.directions[0], box1.directions[2]), box0, box1)) {
          return false;
        }
        if (!axisOverlap(Vector3.Cross(box0.directions[1], box1.directions[0]), box0, box1)) {
          return false;
        }
        if (!axisOverlap(Vector3.Cross(box0.directions[1], box1.directions[1]), box0, box1)) {
          return false;
        }
        if (!axisOverlap(Vector3.Cross(box0.directions[1], box1.directions[2]), box0, box1)) {
          return false;
        }
        if (!axisOverlap(Vector3.Cross(box0.directions[2], box1.directions[0]), box0, box1)) {
          return false;
        }
        if (!axisOverlap(Vector3.Cross(box0.directions[2], box1.directions[1]), box0, box1)) {
          return false;
        }
        if (!axisOverlap(Vector3.Cross(box0.directions[2], box1.directions[2]), box0, box1)) {
          return false;
        }
        return true;
      }
    };
    BoundingInfo._TmpVector3 = BuildArray(2, Vector3.Zero);
  }
});

// node_modules/@babylonjs/core/Cameras/camera.js
var Camera;
var init_camera = __esm({
  "node_modules/@babylonjs/core/Cameras/camera.js"() {
    "use strict";
    init_tslib_es6();
    init_decorators();
    init_smartArray();
    init_tools();
    init_observable();
    init_math_vector();
    init_node();
    init_logger();
    init_typeStore();
    init_devTools();
    init_math_viewport();
    init_math_frustum();
    init_decorators_serialization();
    Camera = class _Camera extends Node {
      /**
       * Define the current local position of the camera in the scene
       */
      get position() {
        return this._position;
      }
      set position(newPosition) {
        this._position = newPosition;
      }
      /**
       * The vector the camera should consider as up.
       * (default is Vector3(0, 1, 0) aka Vector3.Up())
       */
      set upVector(vec) {
        this._upVector = vec;
      }
      get upVector() {
        return this._upVector;
      }
      /**
       * The screen area in scene units squared
       */
      get screenArea() {
        var _a, _b, _c, _d;
        let x = 0;
        let y = 0;
        if (this.mode === _Camera.PERSPECTIVE_CAMERA) {
          if (this.fovMode === _Camera.FOVMODE_VERTICAL_FIXED) {
            y = this.minZ * 2 * Math.tan(this.fov / 2);
            x = this.getEngine().getAspectRatio(this) * y;
          } else {
            x = this.minZ * 2 * Math.tan(this.fov / 2);
            y = x / this.getEngine().getAspectRatio(this);
          }
        } else {
          const halfWidth = this.getEngine().getRenderWidth() / 2;
          const halfHeight = this.getEngine().getRenderHeight() / 2;
          x = ((_a = this.orthoRight) != null ? _a : halfWidth) - ((_b = this.orthoLeft) != null ? _b : -halfWidth);
          y = ((_c = this.orthoTop) != null ? _c : halfHeight) - ((_d = this.orthoBottom) != null ? _d : -halfHeight);
        }
        return x * y;
      }
      /**
       * Define the current limit on the left side for an orthographic camera
       * In scene unit
       */
      set orthoLeft(value) {
        this._orthoLeft = value;
        for (const rigCamera of this._rigCameras) {
          rigCamera.orthoLeft = value;
        }
      }
      get orthoLeft() {
        return this._orthoLeft;
      }
      /**
       * Define the current limit on the right side for an orthographic camera
       * In scene unit
       */
      set orthoRight(value) {
        this._orthoRight = value;
        for (const rigCamera of this._rigCameras) {
          rigCamera.orthoRight = value;
        }
      }
      get orthoRight() {
        return this._orthoRight;
      }
      /**
       * Define the current limit on the bottom side for an orthographic camera
       * In scene unit
       */
      set orthoBottom(value) {
        this._orthoBottom = value;
        for (const rigCamera of this._rigCameras) {
          rigCamera.orthoBottom = value;
        }
      }
      get orthoBottom() {
        return this._orthoBottom;
      }
      /**
       * Define the current limit on the top side for an orthographic camera
       * In scene unit
       */
      set orthoTop(value) {
        this._orthoTop = value;
        for (const rigCamera of this._rigCameras) {
          rigCamera.orthoTop = value;
        }
      }
      get orthoTop() {
        return this._orthoTop;
      }
      /**
       * Define the mode of the camera (Camera.PERSPECTIVE_CAMERA or Camera.ORTHOGRAPHIC_CAMERA)
       */
      set mode(mode) {
        this._mode = mode;
        for (const rigCamera of this._rigCameras) {
          rigCamera.mode = mode;
        }
      }
      get mode() {
        return this._mode;
      }
      /**
       * Gets a flag indicating that the camera has moved in some way since the last call to Camera.update()
       */
      get hasMoved() {
        return this._hasMoved;
      }
      /**
       * Instantiates a new camera object.
       * This should not be used directly but through the inherited cameras: ArcRotate, Free...
       * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras
       * @param name Defines the name of the camera in the scene
       * @param position Defines the position of the camera
       * @param scene Defines the scene the camera belongs too
       * @param setActiveOnSceneIfNoneActive Defines if the camera should be set as active after creation if no other camera have been defined in the scene
       */
      constructor(name, position, scene, setActiveOnSceneIfNoneActive = true) {
        super(name, scene, false);
        this._position = Vector3.Zero();
        this._upVector = Vector3.Up();
        this.oblique = null;
        this._orthoLeft = null;
        this._orthoRight = null;
        this._orthoBottom = null;
        this._orthoTop = null;
        this.fov = 0.8;
        this.projectionPlaneTilt = 0;
        this.minZ = 1;
        this.maxZ = 1e4;
        this.inertia = 0.9;
        this._mode = _Camera.PERSPECTIVE_CAMERA;
        this.isIntermediate = false;
        this.viewport = new Viewport(0, 0, 1, 1);
        this.layerMask = 268435455;
        this.fovMode = _Camera.FOVMODE_VERTICAL_FIXED;
        this.cameraRigMode = _Camera.RIG_MODE_NONE;
        this.customRenderTargets = [];
        this.outputRenderTarget = null;
        this.onViewMatrixChangedObservable = new Observable();
        this.onProjectionMatrixChangedObservable = new Observable();
        this.onAfterCheckInputsObservable = new Observable();
        this.onRestoreStateObservable = new Observable();
        this.isRigCamera = false;
        this._hasMoved = false;
        this._rigCameras = new Array();
        this._skipRendering = false;
        this._projectionMatrix = new Matrix();
        this._postProcesses = new Array();
        this._activeMeshes = new SmartArray(256);
        this._globalPosition = Vector3.Zero();
        this._computedViewMatrix = Matrix.Identity();
        this._doNotComputeProjectionMatrix = false;
        this._transformMatrix = Matrix.Zero();
        this._refreshFrustumPlanes = true;
        this._absoluteRotation = Quaternion.Identity();
        this._isCamera = true;
        this._isLeftCamera = false;
        this._isRightCamera = false;
        this.getScene().addCamera(this);
        if (setActiveOnSceneIfNoneActive && !this.getScene().activeCamera) {
          this.getScene().activeCamera = this;
        }
        this.position = position;
        this.renderPassId = this.getScene().getEngine().createRenderPassId(`Camera ${name}`);
      }
      /**
       * Store current camera state (fov, position, etc..)
       * @returns the camera
       */
      storeState() {
        this._stateStored = true;
        this._storedFov = this.fov;
        return this;
      }
      /**
       * Returns true if a state has been stored by calling storeState method.
       * @returns true if state has been stored.
       */
      hasStateStored() {
        return !!this._stateStored;
      }
      /**
       * Restores the camera state values if it has been stored. You must call storeState() first
       * @returns true if restored and false otherwise
       */
      _restoreStateValues() {
        if (!this._stateStored) {
          return false;
        }
        this.fov = this._storedFov;
        return true;
      }
      /**
       * Restored camera state. You must call storeState() first.
       * @returns true if restored and false otherwise
       */
      restoreState() {
        if (this._restoreStateValues()) {
          this.onRestoreStateObservable.notifyObservers(this);
          return true;
        }
        return false;
      }
      /**
       * Gets the class name of the camera.
       * @returns the class name
       */
      getClassName() {
        return "Camera";
      }
      /**
       * Gets a string representation of the camera useful for debug purpose.
       * @param fullDetails Defines that a more verbose level of logging is required
       * @returns the string representation
       */
      toString(fullDetails) {
        let ret = "Name: " + this.name;
        ret += ", type: " + this.getClassName();
        if (this.animations) {
          for (let i = 0; i < this.animations.length; i++) {
            ret += ", animation[0]: " + this.animations[i].toString(fullDetails);
          }
        }
        return ret;
      }
      /**
       * Automatically tilts the projection plane, using `projectionPlaneTilt`, to correct the perspective effect on vertical lines.
       */
      applyVerticalCorrection() {
        const rot = this.absoluteRotation.toEulerAngles();
        this.projectionPlaneTilt = this._scene.useRightHandedSystem ? -rot.x : rot.x;
      }
      /**
       * Gets the current world space position of the camera.
       */
      get globalPosition() {
        return this._globalPosition;
      }
      /**
       * Gets the list of active meshes this frame (meshes no culled or excluded by lod s in the frame)
       * @returns the active meshe list
       */
      getActiveMeshes() {
        return this._activeMeshes;
      }
      /**
       * Check whether a mesh is part of the current active mesh list of the camera
       * @param mesh Defines the mesh to check
       * @returns true if active, false otherwise
       */
      isActiveMesh(mesh) {
        return this._activeMeshes.indexOf(mesh) !== -1;
      }
      /**
       * Is this camera ready to be used/rendered
       * @param completeCheck defines if a complete check (including post processes) has to be done (false by default)
       * @returns true if the camera is ready
       */
      isReady(completeCheck = false) {
        if (completeCheck) {
          for (const pp of this._postProcesses) {
            if (pp && !pp.isReady()) {
              return false;
            }
          }
        }
        return super.isReady(completeCheck);
      }
      /** @internal */
      _initCache() {
        super._initCache();
        this._cache.position = new Vector3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        this._cache.upVector = new Vector3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        this._cache.mode = void 0;
        this._cache.minZ = void 0;
        this._cache.maxZ = void 0;
        this._cache.fov = void 0;
        this._cache.fovMode = void 0;
        this._cache.aspectRatio = void 0;
        this._cache.orthoLeft = void 0;
        this._cache.orthoRight = void 0;
        this._cache.orthoBottom = void 0;
        this._cache.orthoTop = void 0;
        this._cache.obliqueAngle = void 0;
        this._cache.obliqueLength = void 0;
        this._cache.obliqueOffset = void 0;
        this._cache.renderWidth = void 0;
        this._cache.renderHeight = void 0;
      }
      /**
       * @internal
       */
      _updateCache(ignoreParentClass) {
        if (!ignoreParentClass) {
          super._updateCache();
        }
        this._cache.position.copyFrom(this.position);
        this._cache.upVector.copyFrom(this.upVector);
      }
      /** @internal */
      _isSynchronized() {
        return this._isSynchronizedViewMatrix() && this._isSynchronizedProjectionMatrix();
      }
      /** @internal */
      _isSynchronizedViewMatrix() {
        if (!super._isSynchronized()) {
          return false;
        }
        return this._cache.position.equals(this.position) && this._cache.upVector.equals(this.upVector) && this.isSynchronizedWithParent();
      }
      /** @internal */
      _isSynchronizedProjectionMatrix() {
        let isSynchronized = this._cache.mode === this.mode && this._cache.minZ === this.minZ && this._cache.maxZ === this.maxZ;
        if (!isSynchronized) {
          return false;
        }
        const engine = this.getEngine();
        if (this.mode === _Camera.PERSPECTIVE_CAMERA) {
          isSynchronized = this._cache.fov === this.fov && this._cache.fovMode === this.fovMode && this._cache.aspectRatio === engine.getAspectRatio(this) && this._cache.projectionPlaneTilt === this.projectionPlaneTilt;
        } else {
          isSynchronized = this._cache.orthoLeft === this.orthoLeft && this._cache.orthoRight === this.orthoRight && this._cache.orthoBottom === this.orthoBottom && this._cache.orthoTop === this.orthoTop && this._cache.renderWidth === engine.getRenderWidth() && this._cache.renderHeight === engine.getRenderHeight();
          if (this.oblique) {
            isSynchronized = isSynchronized && this._cache.obliqueAngle === this.oblique.angle && this._cache.obliqueLength === this.oblique.length && this._cache.obliqueOffset === this.oblique.offset;
          }
        }
        return isSynchronized;
      }
      /**
       * Attach the input controls to a specific dom element to get the input from.
       * This function is here because typescript removes the typing of the last function.
       * @param _ignored defines an ignored parameter kept for backward compatibility.
       * @param _noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
       */
      attachControl(_ignored, _noPreventDefault) {
      }
      /**
       * Detach the current controls from the specified dom element.
       * This function is here because typescript removes the typing of the last function.
       * @param _ignored defines an ignored parameter kept for backward compatibility.
       */
      detachControl(_ignored) {
      }
      /**
       * Update the camera state according to the different inputs gathered during the frame.
       */
      update() {
        this._hasMoved = false;
        this._checkInputs();
        if (this.cameraRigMode !== _Camera.RIG_MODE_NONE) {
          this._updateRigCameras();
        }
        this.getViewMatrix();
        this.getProjectionMatrix();
      }
      /** @internal */
      _checkInputs() {
        this.onAfterCheckInputsObservable.notifyObservers(this);
      }
      /** @internal */
      get rigCameras() {
        return this._rigCameras;
      }
      /**
       * Gets the post process used by the rig cameras
       */
      get rigPostProcess() {
        return this._rigPostProcess;
      }
      /**
       * Internal, gets the first post process.
       * @returns the first post process to be run on this camera.
       */
      _getFirstPostProcess() {
        for (let ppIndex = 0; ppIndex < this._postProcesses.length; ppIndex++) {
          if (this._postProcesses[ppIndex] !== null) {
            return this._postProcesses[ppIndex];
          }
        }
        return null;
      }
      _cascadePostProcessesToRigCams() {
        const firstPostProcess = this._getFirstPostProcess();
        if (firstPostProcess) {
          firstPostProcess.markTextureDirty();
        }
        for (let i = 0, len = this._rigCameras.length; i < len; i++) {
          const cam = this._rigCameras[i];
          const rigPostProcess = cam._rigPostProcess;
          if (rigPostProcess) {
            const isPass = rigPostProcess.getEffectName() === "pass";
            if (isPass) {
              cam.isIntermediate = this._postProcesses.length === 0;
            }
            cam._postProcesses = this._postProcesses.slice(0).concat(rigPostProcess);
            rigPostProcess.markTextureDirty();
          } else {
            cam._postProcesses = this._postProcesses.slice(0);
          }
        }
      }
      /**
       * Attach a post process to the camera.
       * @see https://doc.babylonjs.com/features/featuresDeepDive/postProcesses/usePostProcesses#attach-postprocess
       * @param postProcess The post process to attach to the camera
       * @param insertAt The position of the post process in case several of them are in use in the scene
       * @returns the position the post process has been inserted at
       */
      attachPostProcess(postProcess, insertAt = null) {
        if (!postProcess.isReusable() && this._postProcesses.indexOf(postProcess) > -1) {
          Logger.Error("You're trying to reuse a post process not defined as reusable.");
          return 0;
        }
        if (insertAt == null || insertAt < 0) {
          this._postProcesses.push(postProcess);
        } else if (this._postProcesses[insertAt] === null) {
          this._postProcesses[insertAt] = postProcess;
        } else {
          this._postProcesses.splice(insertAt, 0, postProcess);
        }
        this._cascadePostProcessesToRigCams();
        if (this._scene.prePassRenderer) {
          this._scene.prePassRenderer.markAsDirty();
        }
        return this._postProcesses.indexOf(postProcess);
      }
      /**
       * Detach a post process to the camera.
       * @see https://doc.babylonjs.com/features/featuresDeepDive/postProcesses/usePostProcesses#attach-postprocess
       * @param postProcess The post process to detach from the camera
       */
      detachPostProcess(postProcess) {
        const idx = this._postProcesses.indexOf(postProcess);
        if (idx !== -1) {
          this._postProcesses[idx] = null;
        }
        if (this._scene.prePassRenderer) {
          this._scene.prePassRenderer.markAsDirty();
        }
        this._cascadePostProcessesToRigCams();
      }
      /**
       * Gets the current world matrix of the camera
       * @returns the world matrix
       */
      getWorldMatrix() {
        if (this._isSynchronizedViewMatrix()) {
          return this._worldMatrix;
        }
        this.getViewMatrix();
        return this._worldMatrix;
      }
      /** @internal */
      _getViewMatrix() {
        return Matrix.Identity();
      }
      /**
       * Gets the current view matrix of the camera.
       * @param force forces the camera to recompute the matrix without looking at the cached state
       * @returns the view matrix
       */
      getViewMatrix(force) {
        if (!force && this._isSynchronizedViewMatrix()) {
          return this._computedViewMatrix;
        }
        this._hasMoved = true;
        this.updateCache();
        this._computedViewMatrix = this._getViewMatrix();
        this._currentRenderId = this.getScene().getRenderId();
        this._childUpdateId++;
        this._refreshFrustumPlanes = true;
        if (this._cameraRigParams && this._cameraRigParams.vrPreViewMatrix) {
          this._computedViewMatrix.multiplyToRef(this._cameraRigParams.vrPreViewMatrix, this._computedViewMatrix);
        }
        if (this.parent && this.parent.onViewMatrixChangedObservable) {
          this.parent.onViewMatrixChangedObservable.notifyObservers(this.parent);
        }
        this.onViewMatrixChangedObservable.notifyObservers(this);
        this._computedViewMatrix.invertToRef(this._worldMatrix);
        return this._computedViewMatrix;
      }
      /**
       * Freeze the projection matrix.
       * It will prevent the cache check of the camera projection compute and can speed up perf
       * if no parameter of the camera are meant to change
       * @param projection Defines manually a projection if necessary
       */
      freezeProjectionMatrix(projection) {
        this._doNotComputeProjectionMatrix = true;
        if (projection !== void 0) {
          this._projectionMatrix = projection;
        }
      }
      /**
       * Unfreeze the projection matrix if it has previously been freezed by freezeProjectionMatrix.
       */
      unfreezeProjectionMatrix() {
        this._doNotComputeProjectionMatrix = false;
      }
      /**
       * Gets the current projection matrix of the camera.
       * @param force forces the camera to recompute the matrix without looking at the cached state
       * @returns the projection matrix
       */
      getProjectionMatrix(force) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s;
        if (this._doNotComputeProjectionMatrix || !force && this._isSynchronizedProjectionMatrix()) {
          return this._projectionMatrix;
        }
        this._cache.mode = this.mode;
        this._cache.minZ = this.minZ;
        this._cache.maxZ = this.maxZ;
        this._refreshFrustumPlanes = true;
        const engine = this.getEngine();
        const scene = this.getScene();
        const reverseDepth = engine.useReverseDepthBuffer;
        if (this.mode === _Camera.PERSPECTIVE_CAMERA) {
          this._cache.fov = this.fov;
          this._cache.fovMode = this.fovMode;
          this._cache.aspectRatio = engine.getAspectRatio(this);
          this._cache.projectionPlaneTilt = this.projectionPlaneTilt;
          if (this.minZ <= 0) {
            this.minZ = 0.1;
          }
          let getProjectionMatrix;
          if (scene.useRightHandedSystem) {
            getProjectionMatrix = Matrix.PerspectiveFovRHToRef;
          } else {
            getProjectionMatrix = Matrix.PerspectiveFovLHToRef;
          }
          getProjectionMatrix(this.fov, engine.getAspectRatio(this), reverseDepth ? this.maxZ : this.minZ, reverseDepth ? this.minZ : this.maxZ, this._projectionMatrix, this.fovMode === _Camera.FOVMODE_VERTICAL_FIXED, engine.isNDCHalfZRange, this.projectionPlaneTilt, reverseDepth);
        } else {
          const halfWidth = engine.getRenderWidth() / 2;
          const halfHeight = engine.getRenderHeight() / 2;
          if (scene.useRightHandedSystem) {
            if (this.oblique) {
              Matrix.ObliqueOffCenterRHToRef((_a = this.orthoLeft) != null ? _a : -halfWidth, (_b = this.orthoRight) != null ? _b : halfWidth, (_c = this.orthoBottom) != null ? _c : -halfHeight, (_d = this.orthoTop) != null ? _d : halfHeight, reverseDepth ? this.maxZ : this.minZ, reverseDepth ? this.minZ : this.maxZ, this.oblique.length, this.oblique.angle, this._computeObliqueDistance(this.oblique.offset), this._projectionMatrix, engine.isNDCHalfZRange);
            } else {
              Matrix.OrthoOffCenterRHToRef((_e = this.orthoLeft) != null ? _e : -halfWidth, (_f = this.orthoRight) != null ? _f : halfWidth, (_g = this.orthoBottom) != null ? _g : -halfHeight, (_h = this.orthoTop) != null ? _h : halfHeight, reverseDepth ? this.maxZ : this.minZ, reverseDepth ? this.minZ : this.maxZ, this._projectionMatrix, engine.isNDCHalfZRange);
            }
          } else {
            if (this.oblique) {
              Matrix.ObliqueOffCenterLHToRef((_i = this.orthoLeft) != null ? _i : -halfWidth, (_j = this.orthoRight) != null ? _j : halfWidth, (_k = this.orthoBottom) != null ? _k : -halfHeight, (_l = this.orthoTop) != null ? _l : halfHeight, reverseDepth ? this.maxZ : this.minZ, reverseDepth ? this.minZ : this.maxZ, this.oblique.length, this.oblique.angle, this._computeObliqueDistance(this.oblique.offset), this._projectionMatrix, engine.isNDCHalfZRange);
            } else {
              Matrix.OrthoOffCenterLHToRef((_m = this.orthoLeft) != null ? _m : -halfWidth, (_n = this.orthoRight) != null ? _n : halfWidth, (_o = this.orthoBottom) != null ? _o : -halfHeight, (_p = this.orthoTop) != null ? _p : halfHeight, reverseDepth ? this.maxZ : this.minZ, reverseDepth ? this.minZ : this.maxZ, this._projectionMatrix, engine.isNDCHalfZRange);
            }
          }
          this._cache.orthoLeft = this.orthoLeft;
          this._cache.orthoRight = this.orthoRight;
          this._cache.orthoBottom = this.orthoBottom;
          this._cache.orthoTop = this.orthoTop;
          this._cache.obliqueAngle = (_q = this.oblique) == null ? void 0 : _q.angle;
          this._cache.obliqueLength = (_r = this.oblique) == null ? void 0 : _r.length;
          this._cache.obliqueOffset = (_s = this.oblique) == null ? void 0 : _s.offset;
          this._cache.renderWidth = engine.getRenderWidth();
          this._cache.renderHeight = engine.getRenderHeight();
        }
        this.onProjectionMatrixChangedObservable.notifyObservers(this);
        return this._projectionMatrix;
      }
      /**
       * Gets the transformation matrix (ie. the multiplication of view by projection matrices)
       * @returns a Matrix
       */
      getTransformationMatrix() {
        this._computedViewMatrix.multiplyToRef(this._projectionMatrix, this._transformMatrix);
        return this._transformMatrix;
      }
      _computeObliqueDistance(offset) {
        const arcRotateCamera = this;
        const targetCamera = this;
        return (arcRotateCamera.radius || (targetCamera.target ? Vector3.Distance(this.position, targetCamera.target) : this.position.length())) + offset;
      }
      _updateFrustumPlanes() {
        if (!this._refreshFrustumPlanes) {
          return;
        }
        this.getTransformationMatrix();
        if (!this._frustumPlanes) {
          this._frustumPlanes = Frustum.GetPlanes(this._transformMatrix);
        } else {
          Frustum.GetPlanesToRef(this._transformMatrix, this._frustumPlanes);
        }
        this._refreshFrustumPlanes = false;
      }
      /**
       * Checks if a cullable object (mesh...) is in the camera frustum
       * This checks the bounding box center. See isCompletelyInFrustum for a full bounding check
       * @param target The object to check
       * @param checkRigCameras If the rig cameras should be checked (eg. with VR camera both eyes should be checked) (Default: false)
       * @returns true if the object is in frustum otherwise false
       */
      isInFrustum(target, checkRigCameras = false) {
        this._updateFrustumPlanes();
        if (checkRigCameras && this.rigCameras.length > 0) {
          let result = false;
          this.rigCameras.forEach((cam) => {
            cam._updateFrustumPlanes();
            result = result || target.isInFrustum(cam._frustumPlanes);
          });
          return result;
        } else {
          return target.isInFrustum(this._frustumPlanes);
        }
      }
      /**
       * Checks if a cullable object (mesh...) is in the camera frustum
       * Unlike isInFrustum this checks the full bounding box
       * @param target The object to check
       * @returns true if the object is in frustum otherwise false
       */
      isCompletelyInFrustum(target) {
        this._updateFrustumPlanes();
        return target.isCompletelyInFrustum(this._frustumPlanes);
      }
      // eslint-disable-next-line jsdoc/require-returns-check
      /**
       * Gets a ray in the forward direction from the camera.
       * @param length Defines the length of the ray to create
       * @param transform Defines the transform to apply to the ray, by default the world matrix is used to create a workd space ray
       * @param origin Defines the start point of the ray which defaults to the camera position
       * @returns the forward ray
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      getForwardRay(length = 100, transform, origin) {
        throw _WarnImport("Ray");
      }
      // eslint-disable-next-line jsdoc/require-returns-check
      /**
       * Gets a ray in the forward direction from the camera.
       * @param refRay the ray to (re)use when setting the values
       * @param length Defines the length of the ray to create
       * @param transform Defines the transform to apply to the ray, by default the world matrx is used to create a workd space ray
       * @param origin Defines the start point of the ray which defaults to the camera position
       * @returns the forward ray
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      getForwardRayToRef(refRay, length = 100, transform, origin) {
        throw _WarnImport("Ray");
      }
      /**
       * Releases resources associated with this node.
       * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
       * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
       */
      dispose(doNotRecurse, disposeMaterialAndTextures = false) {
        this.onViewMatrixChangedObservable.clear();
        this.onProjectionMatrixChangedObservable.clear();
        this.onAfterCheckInputsObservable.clear();
        this.onRestoreStateObservable.clear();
        if (this.inputs) {
          this.inputs.clear();
        }
        this.getScene().stopAnimation(this);
        this.getScene().removeCamera(this);
        while (this._rigCameras.length > 0) {
          const camera = this._rigCameras.pop();
          if (camera) {
            camera.dispose();
          }
        }
        if (this._parentContainer) {
          const index = this._parentContainer.cameras.indexOf(this);
          if (index > -1) {
            this._parentContainer.cameras.splice(index, 1);
          }
          this._parentContainer = null;
        }
        if (this._rigPostProcess) {
          this._rigPostProcess.dispose(this);
          this._rigPostProcess = null;
          this._postProcesses.length = 0;
        } else if (this.cameraRigMode !== _Camera.RIG_MODE_NONE) {
          this._rigPostProcess = null;
          this._postProcesses.length = 0;
        } else {
          let i2 = this._postProcesses.length;
          while (--i2 >= 0) {
            const postProcess = this._postProcesses[i2];
            if (postProcess) {
              postProcess.dispose(this);
            }
          }
        }
        let i = this.customRenderTargets.length;
        while (--i >= 0) {
          this.customRenderTargets[i].dispose();
        }
        this.customRenderTargets.length = 0;
        this._activeMeshes.dispose();
        this.getScene().getEngine().releaseRenderPassId(this.renderPassId);
        super.dispose(doNotRecurse, disposeMaterialAndTextures);
      }
      /**
       * Gets the left camera of a rig setup in case of Rigged Camera
       */
      get isLeftCamera() {
        return this._isLeftCamera;
      }
      /**
       * Gets the right camera of a rig setup in case of Rigged Camera
       */
      get isRightCamera() {
        return this._isRightCamera;
      }
      /**
       * Gets the left camera of a rig setup in case of Rigged Camera
       */
      get leftCamera() {
        if (this._rigCameras.length < 1) {
          return null;
        }
        return this._rigCameras[0];
      }
      /**
       * Gets the right camera of a rig setup in case of Rigged Camera
       */
      get rightCamera() {
        if (this._rigCameras.length < 2) {
          return null;
        }
        return this._rigCameras[1];
      }
      /**
       * Gets the left camera target of a rig setup in case of Rigged Camera
       * @returns the target position
       */
      getLeftTarget() {
        if (this._rigCameras.length < 1) {
          return null;
        }
        return this._rigCameras[0].getTarget();
      }
      /**
       * Gets the right camera target of a rig setup in case of Rigged Camera
       * @returns the target position
       */
      getRightTarget() {
        if (this._rigCameras.length < 2) {
          return null;
        }
        return this._rigCameras[1].getTarget();
      }
      /**
       * @internal
       */
      setCameraRigMode(mode, rigParams) {
        if (this.cameraRigMode === mode) {
          return;
        }
        while (this._rigCameras.length > 0) {
          const camera = this._rigCameras.pop();
          if (camera) {
            camera.dispose();
          }
        }
        this.cameraRigMode = mode;
        this._cameraRigParams = {};
        this._cameraRigParams.interaxialDistance = rigParams.interaxialDistance || 0.0637;
        this._cameraRigParams.stereoHalfAngle = Tools.ToRadians(this._cameraRigParams.interaxialDistance / 0.0637);
        if (this.cameraRigMode !== _Camera.RIG_MODE_NONE) {
          const leftCamera = this.createRigCamera(this.name + "_L", 0);
          if (leftCamera) {
            leftCamera._isLeftCamera = true;
          }
          const rightCamera = this.createRigCamera(this.name + "_R", 1);
          if (rightCamera) {
            rightCamera._isRightCamera = true;
          }
          if (leftCamera && rightCamera) {
            this._rigCameras.push(leftCamera);
            this._rigCameras.push(rightCamera);
          }
        }
        this._setRigMode(rigParams);
        this._cascadePostProcessesToRigCams();
        this.update();
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      _setRigMode(rigParams) {
      }
      /** @internal */
      _getVRProjectionMatrix() {
        Matrix.PerspectiveFovLHToRef(this._cameraRigParams.vrMetrics.aspectRatioFov, this._cameraRigParams.vrMetrics.aspectRatio, this.minZ, this.maxZ, this._cameraRigParams.vrWorkMatrix, true, this.getEngine().isNDCHalfZRange);
        this._cameraRigParams.vrWorkMatrix.multiplyToRef(this._cameraRigParams.vrHMatrix, this._projectionMatrix);
        return this._projectionMatrix;
      }
      /**
       * @internal
       */
      setCameraRigParameter(name, value) {
        if (!this._cameraRigParams) {
          this._cameraRigParams = {};
        }
        this._cameraRigParams[name] = value;
        if (name === "interaxialDistance") {
          this._cameraRigParams.stereoHalfAngle = Tools.ToRadians(value / 0.0637);
        }
      }
      /**
       * needs to be overridden by children so sub has required properties to be copied
       * @internal
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      createRigCamera(name, cameraIndex) {
        return null;
      }
      /**
       * May need to be overridden by children
       * @internal
       */
      _updateRigCameras() {
        for (let i = 0; i < this._rigCameras.length; i++) {
          this._rigCameras[i].minZ = this.minZ;
          this._rigCameras[i].maxZ = this.maxZ;
          this._rigCameras[i].fov = this.fov;
          this._rigCameras[i].upVector.copyFrom(this.upVector);
        }
        if (this.cameraRigMode === _Camera.RIG_MODE_STEREOSCOPIC_ANAGLYPH) {
          this._rigCameras[0].viewport = this._rigCameras[1].viewport = this.viewport;
        }
      }
      /** @internal */
      _setupInputs() {
      }
      /**
       * Serialiaze the camera setup to a json representation
       * @returns the JSON representation
       */
      serialize() {
        const serializationObject = SerializationHelper.Serialize(this);
        serializationObject.uniqueId = this.uniqueId;
        serializationObject.type = this.getClassName();
        if (this.parent) {
          this.parent._serializeAsParent(serializationObject);
        }
        if (this.inputs) {
          this.inputs.serialize(serializationObject);
        }
        SerializationHelper.AppendSerializedAnimations(this, serializationObject);
        serializationObject.ranges = this.serializeAnimationRanges();
        serializationObject.isEnabled = this.isEnabled();
        return serializationObject;
      }
      /**
       * Clones the current camera.
       * @param name The cloned camera name
       * @param newParent The cloned camera's new parent (none by default)
       * @returns the cloned camera
       */
      clone(name, newParent = null) {
        const camera = SerializationHelper.Clone(_Camera.GetConstructorFromName(this.getClassName(), name, this.getScene(), this.interaxialDistance, this.isStereoscopicSideBySide), this);
        camera.name = name;
        camera.parent = newParent;
        this.onClonedObservable.notifyObservers(camera);
        return camera;
      }
      /**
       * Gets the direction of the camera relative to a given local axis.
       * @param localAxis Defines the reference axis to provide a relative direction.
       * @returns the direction
       */
      getDirection(localAxis) {
        const result = Vector3.Zero();
        this.getDirectionToRef(localAxis, result);
        return result;
      }
      /**
       * Returns the current camera absolute rotation
       */
      get absoluteRotation() {
        this.getWorldMatrix().decompose(void 0, this._absoluteRotation);
        return this._absoluteRotation;
      }
      /**
       * Gets the direction of the camera relative to a given local axis into a passed vector.
       * @param localAxis Defines the reference axis to provide a relative direction.
       * @param result Defines the vector to store the result in
       */
      getDirectionToRef(localAxis, result) {
        Vector3.TransformNormalToRef(localAxis, this.getWorldMatrix(), result);
      }
      /**
       * Gets a camera constructor for a given camera type
       * @param type The type of the camera to construct (should be equal to one of the camera class name)
       * @param name The name of the camera the result will be able to instantiate
       * @param scene The scene the result will construct the camera in
       * @param interaxial_distance In case of stereoscopic setup, the distance between both eyes
       * @param isStereoscopicSideBySide In case of stereoscopic setup, should the sereo be side b side
       * @returns a factory method to construct the camera
       */
      // eslint-disable-next-line @typescript-eslint/naming-convention
      static GetConstructorFromName(type, name, scene, interaxial_distance = 0, isStereoscopicSideBySide = true) {
        const constructorFunc = Node.Construct(type, name, scene, {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          interaxial_distance,
          isStereoscopicSideBySide
        });
        if (constructorFunc) {
          return constructorFunc;
        }
        return () => _Camera._CreateDefaultParsedCamera(name, scene);
      }
      /**
       * Compute the world  matrix of the camera.
       * @returns the camera world matrix
       */
      computeWorldMatrix() {
        return this.getWorldMatrix();
      }
      /**
       * Parse a JSON and creates the camera from the parsed information
       * @param parsedCamera The JSON to parse
       * @param scene The scene to instantiate the camera in
       * @returns the newly constructed camera
       */
      static Parse(parsedCamera, scene) {
        const type = parsedCamera.type;
        const construct = _Camera.GetConstructorFromName(type, parsedCamera.name, scene, parsedCamera.interaxial_distance, parsedCamera.isStereoscopicSideBySide);
        const camera = SerializationHelper.Parse(construct, parsedCamera, scene);
        if (parsedCamera.parentId !== void 0) {
          camera._waitingParentId = parsedCamera.parentId;
        }
        if (parsedCamera.parentInstanceIndex !== void 0) {
          camera._waitingParentInstanceIndex = parsedCamera.parentInstanceIndex;
        }
        if (camera.inputs) {
          camera.inputs.parse(parsedCamera);
          camera._setupInputs();
        }
        if (parsedCamera.upVector) {
          camera.upVector = Vector3.FromArray(parsedCamera.upVector);
        }
        if (camera.setPosition) {
          camera.position.copyFromFloats(0, 0, 0);
          camera.setPosition(Vector3.FromArray(parsedCamera.position));
        }
        if (parsedCamera.target) {
          if (camera.setTarget) {
            camera.setTarget(Vector3.FromArray(parsedCamera.target));
          }
        }
        if (parsedCamera.cameraRigMode) {
          const rigParams = parsedCamera.interaxial_distance ? { interaxialDistance: parsedCamera.interaxial_distance } : {};
          camera.setCameraRigMode(parsedCamera.cameraRigMode, rigParams);
        }
        if (parsedCamera.animations) {
          for (let animationIndex = 0; animationIndex < parsedCamera.animations.length; animationIndex++) {
            const parsedAnimation = parsedCamera.animations[animationIndex];
            const internalClass = GetClass("BABYLON.Animation");
            if (internalClass) {
              camera.animations.push(internalClass.Parse(parsedAnimation));
            }
          }
          Node.ParseAnimationRanges(camera, parsedCamera, scene);
        }
        if (parsedCamera.autoAnimate) {
          scene.beginAnimation(camera, parsedCamera.autoAnimateFrom, parsedCamera.autoAnimateTo, parsedCamera.autoAnimateLoop, parsedCamera.autoAnimateSpeed || 1);
        }
        if (parsedCamera.isEnabled !== void 0) {
          camera.setEnabled(parsedCamera.isEnabled);
        }
        return camera;
      }
      /** @internal */
      _calculateHandednessMultiplier() {
        let handednessMultiplier = this.getScene().useRightHandedSystem ? -1 : 1;
        if (this.parent && this.parent._getWorldMatrixDeterminant() < 0) {
          handednessMultiplier *= -1;
        }
        return handednessMultiplier;
      }
    };
    Camera._CreateDefaultParsedCamera = (name, scene) => {
      throw _WarnImport("UniversalCamera");
    };
    Camera.PERSPECTIVE_CAMERA = 0;
    Camera.ORTHOGRAPHIC_CAMERA = 1;
    Camera.FOVMODE_VERTICAL_FIXED = 0;
    Camera.FOVMODE_HORIZONTAL_FIXED = 1;
    Camera.RIG_MODE_NONE = 0;
    Camera.RIG_MODE_STEREOSCOPIC_ANAGLYPH = 10;
    Camera.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL = 11;
    Camera.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED = 12;
    Camera.RIG_MODE_STEREOSCOPIC_OVERUNDER = 13;
    Camera.RIG_MODE_STEREOSCOPIC_INTERLACED = 14;
    Camera.RIG_MODE_VR = 20;
    Camera.RIG_MODE_CUSTOM = 22;
    Camera.ForceAttachControlToAlwaysPreventDefault = false;
    __decorate([
      serializeAsVector3("position")
    ], Camera.prototype, "_position", void 0);
    __decorate([
      serializeAsVector3("upVector")
    ], Camera.prototype, "_upVector", void 0);
    __decorate([
      serialize()
    ], Camera.prototype, "orthoLeft", null);
    __decorate([
      serialize()
    ], Camera.prototype, "orthoRight", null);
    __decorate([
      serialize()
    ], Camera.prototype, "orthoBottom", null);
    __decorate([
      serialize()
    ], Camera.prototype, "orthoTop", null);
    __decorate([
      serialize()
    ], Camera.prototype, "fov", void 0);
    __decorate([
      serialize()
    ], Camera.prototype, "projectionPlaneTilt", void 0);
    __decorate([
      serialize()
    ], Camera.prototype, "minZ", void 0);
    __decorate([
      serialize()
    ], Camera.prototype, "maxZ", void 0);
    __decorate([
      serialize()
    ], Camera.prototype, "inertia", void 0);
    __decorate([
      serialize()
    ], Camera.prototype, "mode", null);
    __decorate([
      serialize()
    ], Camera.prototype, "layerMask", void 0);
    __decorate([
      serialize()
    ], Camera.prototype, "fovMode", void 0);
    __decorate([
      serialize()
    ], Camera.prototype, "cameraRigMode", void 0);
    __decorate([
      serialize()
    ], Camera.prototype, "interaxialDistance", void 0);
    __decorate([
      serialize()
    ], Camera.prototype, "isStereoscopicSideBySide", void 0);
  }
});

// node_modules/@babylonjs/core/Collisions/intersectionInfo.js
var IntersectionInfo;
var init_intersectionInfo = __esm({
  "node_modules/@babylonjs/core/Collisions/intersectionInfo.js"() {
    "use strict";
    IntersectionInfo = class {
      constructor(bu, bv, distance) {
        this.bu = bu;
        this.bv = bv;
        this.distance = distance;
        this.faceId = 0;
        this.subMeshId = 0;
      }
    };
  }
});

// node_modules/@babylonjs/core/Meshes/subMesh.js
var SubMesh;
var init_subMesh = __esm({
  "node_modules/@babylonjs/core/Meshes/subMesh.js"() {
    "use strict";
    init_buffer();
    init_intersectionInfo();
    init_boundingInfo();
    init_math_functions();
    init_drawWrapper();
    SubMesh = class _SubMesh {
      /**
       * Gets material defines used by the effect associated to the sub mesh
       */
      get materialDefines() {
        var _a;
        return this._mainDrawWrapperOverride ? this._mainDrawWrapperOverride.defines : (_a = this._getDrawWrapper()) == null ? void 0 : _a.defines;
      }
      /**
       * Sets material defines used by the effect associated to the sub mesh
       */
      set materialDefines(defines) {
        var _a;
        const drawWrapper = (_a = this._mainDrawWrapperOverride) != null ? _a : this._getDrawWrapper(void 0, true);
        drawWrapper.defines = defines;
      }
      /**
       * @internal
       */
      _getDrawWrapper(passId, createIfNotExisting = false) {
        passId = passId != null ? passId : this._engine.currentRenderPassId;
        let drawWrapper = this._drawWrappers[passId];
        if (!drawWrapper && createIfNotExisting) {
          this._drawWrappers[passId] = drawWrapper = new DrawWrapper(this._mesh.getScene().getEngine());
        }
        return drawWrapper;
      }
      /**
       * @internal
       */
      _removeDrawWrapper(passId, disposeWrapper = true) {
        var _a;
        if (disposeWrapper) {
          (_a = this._drawWrappers[passId]) == null ? void 0 : _a.dispose();
        }
        this._drawWrappers[passId] = void 0;
      }
      /**
       * Gets associated (main) effect (possibly the effect override if defined)
       */
      get effect() {
        var _a, _b;
        return this._mainDrawWrapperOverride ? this._mainDrawWrapperOverride.effect : (_b = (_a = this._getDrawWrapper()) == null ? void 0 : _a.effect) != null ? _b : null;
      }
      /** @internal */
      get _drawWrapper() {
        var _a;
        return (_a = this._mainDrawWrapperOverride) != null ? _a : this._getDrawWrapper(void 0, true);
      }
      /** @internal */
      get _drawWrapperOverride() {
        return this._mainDrawWrapperOverride;
      }
      /**
       * @internal
       */
      _setMainDrawWrapperOverride(wrapper) {
        this._mainDrawWrapperOverride = wrapper;
      }
      /**
       * Sets associated effect (effect used to render this submesh)
       * @param effect defines the effect to associate with
       * @param defines defines the set of defines used to compile this effect
       * @param materialContext material context associated to the effect
       * @param resetContext true to reset the draw context
       */
      setEffect(effect, defines = null, materialContext, resetContext = true) {
        const drawWrapper = this._drawWrapper;
        drawWrapper.setEffect(effect, defines, resetContext);
        if (materialContext !== void 0) {
          drawWrapper.materialContext = materialContext;
        }
        if (!effect) {
          drawWrapper.defines = null;
          drawWrapper.materialContext = void 0;
        }
      }
      /**
       * Resets the draw wrappers cache
       * @param passId If provided, releases only the draw wrapper corresponding to this render pass id
       */
      resetDrawCache(passId) {
        if (this._drawWrappers) {
          if (passId !== void 0) {
            this._removeDrawWrapper(passId);
            return;
          } else {
            for (const drawWrapper of this._drawWrappers) {
              drawWrapper == null ? void 0 : drawWrapper.dispose();
            }
          }
        }
        this._drawWrappers = [];
      }
      /**
       * Add a new submesh to a mesh
       * @param materialIndex defines the material index to use
       * @param verticesStart defines vertex index start
       * @param verticesCount defines vertices count
       * @param indexStart defines index start
       * @param indexCount defines indices count
       * @param mesh defines the parent mesh
       * @param renderingMesh defines an optional rendering mesh
       * @param createBoundingBox defines if bounding box should be created for this submesh
       * @returns the new submesh
       */
      static AddToMesh(materialIndex, verticesStart, verticesCount, indexStart, indexCount, mesh, renderingMesh, createBoundingBox = true) {
        return new _SubMesh(materialIndex, verticesStart, verticesCount, indexStart, indexCount, mesh, renderingMesh, createBoundingBox);
      }
      /**
       * Creates a new submesh
       * @param materialIndex defines the material index to use
       * @param verticesStart defines vertex index start
       * @param verticesCount defines vertices count
       * @param indexStart defines index start
       * @param indexCount defines indices count
       * @param mesh defines the parent mesh
       * @param renderingMesh defines an optional rendering mesh
       * @param createBoundingBox defines if bounding box should be created for this submesh
       * @param addToMesh defines a boolean indicating that the submesh must be added to the mesh.subMeshes array (true by default)
       */
      constructor(materialIndex, verticesStart, verticesCount, indexStart, indexCount, mesh, renderingMesh, createBoundingBox = true, addToMesh = true) {
        this.materialIndex = materialIndex;
        this.verticesStart = verticesStart;
        this.verticesCount = verticesCount;
        this.indexStart = indexStart;
        this.indexCount = indexCount;
        this._mainDrawWrapperOverride = null;
        this._linesIndexCount = 0;
        this._linesIndexBuffer = null;
        this._lastColliderWorldVertices = null;
        this._lastColliderTransformMatrix = null;
        this._wasDispatched = false;
        this._renderId = 0;
        this._alphaIndex = 0;
        this._distanceToCamera = 0;
        this._currentMaterial = null;
        this._mesh = mesh;
        this._renderingMesh = renderingMesh || mesh;
        if (addToMesh) {
          mesh.subMeshes.push(this);
        }
        this._engine = this._mesh.getScene().getEngine();
        this.resetDrawCache();
        this._trianglePlanes = [];
        this._id = mesh.subMeshes.length - 1;
        if (createBoundingBox) {
          this.refreshBoundingInfo();
          mesh.computeWorldMatrix(true);
        }
      }
      /**
       * Returns true if this submesh covers the entire parent mesh
       * @ignorenaming
       */
      // eslint-disable-next-line @typescript-eslint/naming-convention
      get IsGlobal() {
        return this.verticesStart === 0 && this.verticesCount === this._mesh.getTotalVertices() && this.indexStart === 0 && this.indexCount === this._mesh.getTotalIndices();
      }
      /**
       * Returns the submesh BoundingInfo object
       * @returns current bounding info (or mesh's one if the submesh is global)
       */
      getBoundingInfo() {
        if (this.IsGlobal || this._mesh.hasThinInstances) {
          return this._mesh.getBoundingInfo();
        }
        return this._boundingInfo;
      }
      /**
       * Sets the submesh BoundingInfo
       * @param boundingInfo defines the new bounding info to use
       * @returns the SubMesh
       */
      setBoundingInfo(boundingInfo) {
        this._boundingInfo = boundingInfo;
        return this;
      }
      /**
       * Returns the mesh of the current submesh
       * @returns the parent mesh
       */
      getMesh() {
        return this._mesh;
      }
      /**
       * Returns the rendering mesh of the submesh
       * @returns the rendering mesh (could be different from parent mesh)
       */
      getRenderingMesh() {
        return this._renderingMesh;
      }
      /**
       * Returns the replacement mesh of the submesh
       * @returns the replacement mesh (could be different from parent mesh)
       */
      getReplacementMesh() {
        return this._mesh._internalAbstractMeshDataInfo._actAsRegularMesh ? this._mesh : null;
      }
      /**
       * Returns the effective mesh of the submesh
       * @returns the effective mesh (could be different from parent mesh)
       */
      getEffectiveMesh() {
        const replacementMesh = this._mesh._internalAbstractMeshDataInfo._actAsRegularMesh ? this._mesh : null;
        return replacementMesh ? replacementMesh : this._renderingMesh;
      }
      /**
       * Returns the submesh material
       * @param getDefaultMaterial Defines whether or not to get the default material if nothing has been defined.
       * @returns null or the current material
       */
      getMaterial(getDefaultMaterial = true) {
        var _a;
        const rootMaterial = (_a = this._renderingMesh.getMaterialForRenderPass(this._engine.currentRenderPassId)) != null ? _a : this._renderingMesh.material;
        if (!rootMaterial) {
          return getDefaultMaterial ? this._mesh.getScene().defaultMaterial : null;
        } else if (this._isMultiMaterial(rootMaterial)) {
          const effectiveMaterial = rootMaterial.getSubMaterial(this.materialIndex);
          if (this._currentMaterial !== effectiveMaterial) {
            this._currentMaterial = effectiveMaterial;
            this.resetDrawCache();
          }
          return effectiveMaterial;
        }
        return rootMaterial;
      }
      _isMultiMaterial(material) {
        return material.getSubMaterial !== void 0;
      }
      // Methods
      /**
       * Sets a new updated BoundingInfo object to the submesh
       * @param data defines an optional position array to use to determine the bounding info
       * @returns the SubMesh
       */
      refreshBoundingInfo(data = null) {
        this._lastColliderWorldVertices = null;
        if (this.IsGlobal || !this._renderingMesh || !this._renderingMesh.geometry) {
          return this;
        }
        if (!data) {
          data = this._renderingMesh.getVerticesData(VertexBuffer.PositionKind);
        }
        if (!data) {
          this._boundingInfo = this._mesh.getBoundingInfo();
          return this;
        }
        const indices = this._renderingMesh.getIndices();
        let extend;
        if (this.indexStart === 0 && this.indexCount === indices.length) {
          const boundingInfo = this._renderingMesh.getBoundingInfo();
          extend = { minimum: boundingInfo.minimum.clone(), maximum: boundingInfo.maximum.clone() };
        } else {
          extend = extractMinAndMaxIndexed(data, indices, this.indexStart, this.indexCount, this._renderingMesh.geometry.boundingBias);
        }
        if (this._boundingInfo) {
          this._boundingInfo.reConstruct(extend.minimum, extend.maximum);
        } else {
          this._boundingInfo = new BoundingInfo(extend.minimum, extend.maximum);
        }
        return this;
      }
      /**
       * @internal
       */
      _checkCollision(collider) {
        const boundingInfo = this.getBoundingInfo();
        return boundingInfo._checkCollision(collider);
      }
      /**
       * Updates the submesh BoundingInfo
       * @param world defines the world matrix to use to update the bounding info
       * @returns the submesh
       */
      updateBoundingInfo(world) {
        let boundingInfo = this.getBoundingInfo();
        if (!boundingInfo) {
          this.refreshBoundingInfo();
          boundingInfo = this.getBoundingInfo();
        }
        if (boundingInfo) {
          boundingInfo.update(world);
        }
        return this;
      }
      /**
       * True is the submesh bounding box intersects the frustum defined by the passed array of planes.
       * @param frustumPlanes defines the frustum planes
       * @returns true if the submesh is intersecting with the frustum
       */
      isInFrustum(frustumPlanes) {
        const boundingInfo = this.getBoundingInfo();
        if (!boundingInfo) {
          return false;
        }
        return boundingInfo.isInFrustum(frustumPlanes, this._mesh.cullingStrategy);
      }
      /**
       * True is the submesh bounding box is completely inside the frustum defined by the passed array of planes
       * @param frustumPlanes defines the frustum planes
       * @returns true if the submesh is inside the frustum
       */
      isCompletelyInFrustum(frustumPlanes) {
        const boundingInfo = this.getBoundingInfo();
        if (!boundingInfo) {
          return false;
        }
        return boundingInfo.isCompletelyInFrustum(frustumPlanes);
      }
      /**
       * Renders the submesh
       * @param enableAlphaMode defines if alpha needs to be used
       * @returns the submesh
       */
      render(enableAlphaMode) {
        this._renderingMesh.render(this, enableAlphaMode, this._mesh._internalAbstractMeshDataInfo._actAsRegularMesh ? this._mesh : void 0);
        return this;
      }
      /**
       * @internal
       */
      _getLinesIndexBuffer(indices, engine) {
        if (!this._linesIndexBuffer) {
          const linesIndices = [];
          for (let index = this.indexStart; index < this.indexStart + this.indexCount; index += 3) {
            linesIndices.push(indices[index], indices[index + 1], indices[index + 1], indices[index + 2], indices[index + 2], indices[index]);
          }
          this._linesIndexBuffer = engine.createIndexBuffer(linesIndices);
          this._linesIndexCount = linesIndices.length;
        }
        return this._linesIndexBuffer;
      }
      /**
       * Checks if the submesh intersects with a ray
       * @param ray defines the ray to test
       * @returns true is the passed ray intersects the submesh bounding box
       */
      canIntersects(ray) {
        const boundingInfo = this.getBoundingInfo();
        if (!boundingInfo) {
          return false;
        }
        return ray.intersectsBox(boundingInfo.boundingBox);
      }
      /**
       * Intersects current submesh with a ray
       * @param ray defines the ray to test
       * @param positions defines mesh's positions array
       * @param indices defines mesh's indices array
       * @param fastCheck defines if the first intersection will be used (and not the closest)
       * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
       * @returns intersection info or null if no intersection
       */
      intersects(ray, positions, indices, fastCheck, trianglePredicate) {
        const material = this.getMaterial();
        if (!material) {
          return null;
        }
        let step = 3;
        let checkStopper = false;
        switch (material.fillMode) {
          case 3:
          case 5:
          case 6:
          case 8:
            return null;
          case 7:
            step = 1;
            checkStopper = true;
            break;
          default:
            break;
        }
        if (material.fillMode === 4) {
          if (!indices.length) {
            return this._intersectUnIndexedLines(ray, positions, indices, this._mesh.intersectionThreshold, fastCheck);
          }
          return this._intersectLines(ray, positions, indices, this._mesh.intersectionThreshold, fastCheck);
        } else {
          if (!indices.length && this._mesh._unIndexed) {
            return this._intersectUnIndexedTriangles(ray, positions, indices, fastCheck, trianglePredicate);
          }
          return this._intersectTriangles(ray, positions, indices, step, checkStopper, fastCheck, trianglePredicate);
        }
      }
      /**
       * @internal
       */
      _intersectLines(ray, positions, indices, intersectionThreshold, fastCheck) {
        let intersectInfo = null;
        for (let index = this.indexStart; index < this.indexStart + this.indexCount; index += 2) {
          const p0 = positions[indices[index]];
          const p1 = positions[indices[index + 1]];
          const length = ray.intersectionSegment(p0, p1, intersectionThreshold);
          if (length < 0) {
            continue;
          }
          if (fastCheck || !intersectInfo || length < intersectInfo.distance) {
            intersectInfo = new IntersectionInfo(null, null, length);
            intersectInfo.faceId = index / 2;
            if (fastCheck) {
              break;
            }
          }
        }
        return intersectInfo;
      }
      /**
       * @internal
       */
      _intersectUnIndexedLines(ray, positions, indices, intersectionThreshold, fastCheck) {
        let intersectInfo = null;
        for (let index = this.verticesStart; index < this.verticesStart + this.verticesCount; index += 2) {
          const p0 = positions[index];
          const p1 = positions[index + 1];
          const length = ray.intersectionSegment(p0, p1, intersectionThreshold);
          if (length < 0) {
            continue;
          }
          if (fastCheck || !intersectInfo || length < intersectInfo.distance) {
            intersectInfo = new IntersectionInfo(null, null, length);
            intersectInfo.faceId = index / 2;
            if (fastCheck) {
              break;
            }
          }
        }
        return intersectInfo;
      }
      /**
       * @internal
       */
      _intersectTriangles(ray, positions, indices, step, checkStopper, fastCheck, trianglePredicate) {
        let intersectInfo = null;
        let faceId = -1;
        for (let index = this.indexStart; index < this.indexStart + this.indexCount - (3 - step); index += step) {
          faceId++;
          const indexA = indices[index];
          const indexB = indices[index + 1];
          const indexC = indices[index + 2];
          if (checkStopper && indexC === 4294967295) {
            index += 2;
            continue;
          }
          const p0 = positions[indexA];
          const p1 = positions[indexB];
          const p2 = positions[indexC];
          if (!p0 || !p1 || !p2) {
            continue;
          }
          if (trianglePredicate && !trianglePredicate(p0, p1, p2, ray, indexA, indexB, indexC)) {
            continue;
          }
          const currentIntersectInfo = ray.intersectsTriangle(p0, p1, p2);
          if (currentIntersectInfo) {
            if (currentIntersectInfo.distance < 0) {
              continue;
            }
            if (fastCheck || !intersectInfo || currentIntersectInfo.distance < intersectInfo.distance) {
              intersectInfo = currentIntersectInfo;
              intersectInfo.faceId = faceId;
              if (fastCheck) {
                break;
              }
            }
          }
        }
        return intersectInfo;
      }
      /**
       * @internal
       */
      _intersectUnIndexedTriangles(ray, positions, indices, fastCheck, trianglePredicate) {
        let intersectInfo = null;
        for (let index = this.verticesStart; index < this.verticesStart + this.verticesCount; index += 3) {
          const p0 = positions[index];
          const p1 = positions[index + 1];
          const p2 = positions[index + 2];
          if (trianglePredicate && !trianglePredicate(p0, p1, p2, ray, -1, -1, -1)) {
            continue;
          }
          const currentIntersectInfo = ray.intersectsTriangle(p0, p1, p2);
          if (currentIntersectInfo) {
            if (currentIntersectInfo.distance < 0) {
              continue;
            }
            if (fastCheck || !intersectInfo || currentIntersectInfo.distance < intersectInfo.distance) {
              intersectInfo = currentIntersectInfo;
              intersectInfo.faceId = index / 3;
              if (fastCheck) {
                break;
              }
            }
          }
        }
        return intersectInfo;
      }
      /** @internal */
      _rebuild() {
        if (this._linesIndexBuffer) {
          this._linesIndexBuffer = null;
        }
      }
      // Clone
      /**
       * Creates a new submesh from the passed mesh
       * @param newMesh defines the new hosting mesh
       * @param newRenderingMesh defines an optional rendering mesh
       * @returns the new submesh
       */
      clone(newMesh, newRenderingMesh) {
        const result = new _SubMesh(this.materialIndex, this.verticesStart, this.verticesCount, this.indexStart, this.indexCount, newMesh, newRenderingMesh, false);
        if (!this.IsGlobal) {
          const boundingInfo = this.getBoundingInfo();
          if (!boundingInfo) {
            return result;
          }
          result._boundingInfo = new BoundingInfo(boundingInfo.minimum, boundingInfo.maximum);
        }
        return result;
      }
      // Dispose
      /**
       * Release associated resources
       */
      dispose() {
        if (this._linesIndexBuffer) {
          this._mesh.getScene().getEngine()._releaseBuffer(this._linesIndexBuffer);
          this._linesIndexBuffer = null;
        }
        const index = this._mesh.subMeshes.indexOf(this);
        this._mesh.subMeshes.splice(index, 1);
        this.resetDrawCache();
      }
      /**
       * Gets the class name
       * @returns the string "SubMesh".
       */
      getClassName() {
        return "SubMesh";
      }
      // Statics
      /**
       * Creates a new submesh from indices data
       * @param materialIndex the index of the main mesh material
       * @param startIndex the index where to start the copy in the mesh indices array
       * @param indexCount the number of indices to copy then from the startIndex
       * @param mesh the main mesh to create the submesh from
       * @param renderingMesh the optional rendering mesh
       * @param createBoundingBox defines if bounding box should be created for this submesh
       * @returns a new submesh
       */
      static CreateFromIndices(materialIndex, startIndex, indexCount, mesh, renderingMesh, createBoundingBox = true) {
        let minVertexIndex = Number.MAX_VALUE;
        let maxVertexIndex = -Number.MAX_VALUE;
        const whatWillRender = renderingMesh || mesh;
        const indices = whatWillRender.getIndices();
        for (let index = startIndex; index < startIndex + indexCount; index++) {
          const vertexIndex = indices[index];
          if (vertexIndex < minVertexIndex) {
            minVertexIndex = vertexIndex;
          }
          if (vertexIndex > maxVertexIndex) {
            maxVertexIndex = vertexIndex;
          }
        }
        return new _SubMesh(materialIndex, minVertexIndex, maxVertexIndex - minVertexIndex + 1, startIndex, indexCount, mesh, renderingMesh, createBoundingBox);
      }
    };
  }
});

// node_modules/@babylonjs/core/Materials/materialStencilState.js
var MaterialStencilState;
var init_materialStencilState = __esm({
  "node_modules/@babylonjs/core/Materials/materialStencilState.js"() {
    "use strict";
    init_tslib_es6();
    init_decorators_serialization();
    init_decorators();
    MaterialStencilState = class {
      /**
       * Creates a material stencil state instance
       */
      constructor() {
        this.reset();
      }
      /**
       * Resets all the stencil states to default values
       */
      reset() {
        this.enabled = false;
        this.mask = 255;
        this.func = 519;
        this.funcRef = 1;
        this.funcMask = 255;
        this.opStencilFail = 7680;
        this.opDepthFail = 7680;
        this.opStencilDepthPass = 7681;
      }
      /**
       * Gets or sets the stencil function
       */
      get func() {
        return this._func;
      }
      set func(value) {
        this._func = value;
      }
      /**
       * Gets or sets the stencil function reference
       */
      get funcRef() {
        return this._funcRef;
      }
      set funcRef(value) {
        this._funcRef = value;
      }
      /**
       * Gets or sets the stencil function mask
       */
      get funcMask() {
        return this._funcMask;
      }
      set funcMask(value) {
        this._funcMask = value;
      }
      /**
       * Gets or sets the operation when the stencil test fails
       */
      get opStencilFail() {
        return this._opStencilFail;
      }
      set opStencilFail(value) {
        this._opStencilFail = value;
      }
      /**
       * Gets or sets the operation when the depth test fails
       */
      get opDepthFail() {
        return this._opDepthFail;
      }
      set opDepthFail(value) {
        this._opDepthFail = value;
      }
      /**
       * Gets or sets the operation when the stencil+depth test succeeds
       */
      get opStencilDepthPass() {
        return this._opStencilDepthPass;
      }
      set opStencilDepthPass(value) {
        this._opStencilDepthPass = value;
      }
      /**
       * Gets or sets the stencil mask
       */
      get mask() {
        return this._mask;
      }
      set mask(value) {
        this._mask = value;
      }
      /**
       * Enables or disables the stencil test
       */
      get enabled() {
        return this._enabled;
      }
      set enabled(value) {
        this._enabled = value;
      }
      /**
       * Get the current class name, useful for serialization or dynamic coding.
       * @returns "MaterialStencilState"
       */
      getClassName() {
        return "MaterialStencilState";
      }
      /**
       * Makes a duplicate of the current configuration into another one.
       * @param stencilState defines stencil state where to copy the info
       */
      copyTo(stencilState) {
        SerializationHelper.Clone(() => stencilState, this);
      }
      /**
       * Serializes this stencil configuration.
       * @returns - An object with the serialized config.
       */
      serialize() {
        return SerializationHelper.Serialize(this);
      }
      /**
       * Parses a stencil state configuration from a serialized object.
       * @param source - Serialized object.
       * @param scene Defines the scene we are parsing for
       * @param rootUrl Defines the rootUrl to load from
       */
      parse(source, scene, rootUrl) {
        SerializationHelper.Parse(() => this, source, scene, rootUrl);
      }
    };
    __decorate([
      serialize()
    ], MaterialStencilState.prototype, "func", null);
    __decorate([
      serialize()
    ], MaterialStencilState.prototype, "funcRef", null);
    __decorate([
      serialize()
    ], MaterialStencilState.prototype, "funcMask", null);
    __decorate([
      serialize()
    ], MaterialStencilState.prototype, "opStencilFail", null);
    __decorate([
      serialize()
    ], MaterialStencilState.prototype, "opDepthFail", null);
    __decorate([
      serialize()
    ], MaterialStencilState.prototype, "opStencilDepthPass", null);
    __decorate([
      serialize()
    ], MaterialStencilState.prototype, "mask", null);
    __decorate([
      serialize()
    ], MaterialStencilState.prototype, "enabled", null);
  }
});

// node_modules/@babylonjs/core/Materials/material.js
var Material;
var init_material = __esm({
  "node_modules/@babylonjs/core/Materials/material.js"() {
    "use strict";
    init_tslib_es6();
    init_decorators();
    init_tools();
    init_observable();
    init_engineStore();
    init_subMesh();
    init_uniformBuffer();
    init_logger();
    init_math_plane();
    init_drawWrapper();
    init_materialStencilState();
    init_materialHelper_functions();
    init_decorators_serialization();
    Material = class _Material {
      /**
       * Gets the shader language used in this material.
       */
      get shaderLanguage() {
        return this._shaderLanguage;
      }
      /**
       * If the material can be rendered to several textures with MRT extension
       */
      get canRenderToMRT() {
        return false;
      }
      /**
       * Sets the alpha value of the material
       */
      set alpha(value) {
        if (this._alpha === value) {
          return;
        }
        const oldValue = this._alpha;
        this._alpha = value;
        if (oldValue === 1 || value === 1) {
          this.markAsDirty(_Material.MiscDirtyFlag + _Material.PrePassDirtyFlag);
        }
      }
      /**
       * Gets the alpha value of the material
       */
      get alpha() {
        return this._alpha;
      }
      /**
       * Sets the culling state (true to enable culling, false to disable)
       */
      set backFaceCulling(value) {
        if (this._backFaceCulling === value) {
          return;
        }
        this._backFaceCulling = value;
        this.markAsDirty(_Material.TextureDirtyFlag);
      }
      /**
       * Gets the culling state
       */
      get backFaceCulling() {
        return this._backFaceCulling;
      }
      /**
       * Sets the type of faces that should be culled (true for back faces, false for front faces)
       */
      set cullBackFaces(value) {
        if (this._cullBackFaces === value) {
          return;
        }
        this._cullBackFaces = value;
        this.markAsDirty(_Material.TextureDirtyFlag);
      }
      /**
       * Gets the type of faces that should be culled
       */
      get cullBackFaces() {
        return this._cullBackFaces;
      }
      /**
       * Block the dirty-mechanism for this specific material
       * When set to false after being true the material will be marked as dirty.
       */
      get blockDirtyMechanism() {
        return this._blockDirtyMechanism;
      }
      set blockDirtyMechanism(value) {
        if (this._blockDirtyMechanism === value) {
          return;
        }
        this._blockDirtyMechanism = value;
        if (!value) {
          this.markDirty();
        }
      }
      /**
       * This allows you to modify the material without marking it as dirty after every change.
       * This function should be used if you need to make more than one dirty-enabling change to the material - adding a texture, setting a new fill mode and so on.
       * The callback will pass the material as an argument, so you can make your changes to it.
       * @param callback the callback to be executed that will update the material
       */
      atomicMaterialsUpdate(callback) {
        this.blockDirtyMechanism = true;
        try {
          callback(this);
        } finally {
          this.blockDirtyMechanism = false;
        }
      }
      /**
       * Gets a boolean indicating that current material needs to register RTT
       */
      get hasRenderTargetTextures() {
        this._eventInfo.hasRenderTargetTextures = false;
        this._callbackPluginEventHasRenderTargetTextures(this._eventInfo);
        return this._eventInfo.hasRenderTargetTextures;
      }
      /**
       * Called during a dispose event
       */
      set onDispose(callback) {
        if (this._onDisposeObserver) {
          this.onDisposeObservable.remove(this._onDisposeObserver);
        }
        this._onDisposeObserver = this.onDisposeObservable.add(callback);
      }
      /**
       * An event triggered when the material is bound
       */
      get onBindObservable() {
        if (!this._onBindObservable) {
          this._onBindObservable = new Observable();
        }
        return this._onBindObservable;
      }
      /**
       * Called during a bind event
       */
      set onBind(callback) {
        if (this._onBindObserver) {
          this.onBindObservable.remove(this._onBindObserver);
        }
        this._onBindObserver = this.onBindObservable.add(callback);
      }
      /**
       * An event triggered when the material is unbound
       */
      get onUnBindObservable() {
        if (!this._onUnBindObservable) {
          this._onUnBindObservable = new Observable();
        }
        return this._onUnBindObservable;
      }
      /**
       * An event triggered when the effect is (re)created
       */
      get onEffectCreatedObservable() {
        if (!this._onEffectCreatedObservable) {
          this._onEffectCreatedObservable = new Observable();
        }
        return this._onEffectCreatedObservable;
      }
      /**
       * Sets the value of the alpha mode.
       *
       * | Value | Type | Description |
       * | --- | --- | --- |
       * | 0 | ALPHA_DISABLE |   |
       * | 1 | ALPHA_ADD |   |
       * | 2 | ALPHA_COMBINE |   |
       * | 3 | ALPHA_SUBTRACT |   |
       * | 4 | ALPHA_MULTIPLY |   |
       * | 5 | ALPHA_MAXIMIZED |   |
       * | 6 | ALPHA_ONEONE |   |
       * | 7 | ALPHA_PREMULTIPLIED |   |
       * | 8 | ALPHA_PREMULTIPLIED_PORTERDUFF |   |
       * | 9 | ALPHA_INTERPOLATE |   |
       * | 10 | ALPHA_SCREENMODE |   |
       *
       */
      set alphaMode(value) {
        if (this._alphaMode === value) {
          return;
        }
        this._alphaMode = value;
        this.markAsDirty(_Material.TextureDirtyFlag);
      }
      /**
       * Gets the value of the alpha mode
       */
      get alphaMode() {
        return this._alphaMode;
      }
      /**
       * Sets the need depth pre-pass value
       */
      set needDepthPrePass(value) {
        if (this._needDepthPrePass === value) {
          return;
        }
        this._needDepthPrePass = value;
        if (this._needDepthPrePass) {
          this.checkReadyOnEveryCall = true;
        }
      }
      /**
       * Gets the depth pre-pass value
       */
      get needDepthPrePass() {
        return this._needDepthPrePass;
      }
      /**
       * Can this material render to prepass
       */
      get isPrePassCapable() {
        return false;
      }
      /**
       * Sets the state for enabling fog
       */
      set fogEnabled(value) {
        if (this._fogEnabled === value) {
          return;
        }
        this._fogEnabled = value;
        this.markAsDirty(_Material.MiscDirtyFlag);
      }
      /**
       * Gets the value of the fog enabled state
       */
      get fogEnabled() {
        return this._fogEnabled;
      }
      get wireframe() {
        switch (this._fillMode) {
          case _Material.WireFrameFillMode:
          case _Material.LineListDrawMode:
          case _Material.LineLoopDrawMode:
          case _Material.LineStripDrawMode:
            return true;
        }
        return this._scene.forceWireframe;
      }
      /**
       * Sets the state of wireframe mode
       */
      set wireframe(value) {
        this.fillMode = value ? _Material.WireFrameFillMode : _Material.TriangleFillMode;
      }
      /**
       * Gets the value specifying if point clouds are enabled
       */
      get pointsCloud() {
        switch (this._fillMode) {
          case _Material.PointFillMode:
          case _Material.PointListDrawMode:
            return true;
        }
        return this._scene.forcePointsCloud;
      }
      /**
       * Sets the state of point cloud mode
       */
      set pointsCloud(value) {
        this.fillMode = value ? _Material.PointFillMode : _Material.TriangleFillMode;
      }
      /**
       * Gets the material fill mode
       */
      get fillMode() {
        return this._fillMode;
      }
      /**
       * Sets the material fill mode
       */
      set fillMode(value) {
        if (this._fillMode === value) {
          return;
        }
        this._fillMode = value;
        this.markAsDirty(_Material.MiscDirtyFlag);
      }
      /**
       * In case the depth buffer does not allow enough depth precision for your scene (might be the case in large scenes)
       * You can try switching to logarithmic depth.
       * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/advanced/logarithmicDepthBuffer
       */
      get useLogarithmicDepth() {
        return this._useLogarithmicDepth;
      }
      set useLogarithmicDepth(value) {
        const fragmentDepthSupported = this.getScene().getEngine().getCaps().fragmentDepthSupported;
        if (value && !fragmentDepthSupported) {
          Logger.Warn("Logarithmic depth has been requested for a material on a device that doesn't support it.");
        }
        this._useLogarithmicDepth = value && fragmentDepthSupported;
        this._markAllSubMeshesAsMiscDirty();
      }
      /** @internal */
      _getDrawWrapper() {
        return this._drawWrapper;
      }
      /**
       * @internal
       */
      _setDrawWrapper(drawWrapper) {
        this._drawWrapper = drawWrapper;
      }
      /**
       * Creates a material instance
       * @param name defines the name of the material
       * @param scene defines the scene to reference
       * @param doNotAdd specifies if the material should be added to the scene
       */
      constructor(name, scene, doNotAdd) {
        this.shadowDepthWrapper = null;
        this.allowShaderHotSwapping = true;
        this._shaderLanguage = 0;
        this.metadata = null;
        this.reservedDataStore = null;
        this.checkReadyOnEveryCall = false;
        this.checkReadyOnlyOnce = false;
        this.state = "";
        this._alpha = 1;
        this._backFaceCulling = true;
        this._cullBackFaces = true;
        this._blockDirtyMechanism = false;
        this.sideOrientation = null;
        this.onCompiled = null;
        this.onError = null;
        this.getRenderTargetTextures = null;
        this.doNotSerialize = false;
        this._storeEffectOnSubMeshes = false;
        this.animations = null;
        this.onDisposeObservable = new Observable();
        this._onDisposeObserver = null;
        this._onUnBindObservable = null;
        this._onBindObserver = null;
        this._alphaMode = 2;
        this._needDepthPrePass = false;
        this.disableDepthWrite = false;
        this.disableColorWrite = false;
        this.forceDepthWrite = false;
        this.depthFunction = 0;
        this.separateCullingPass = false;
        this._fogEnabled = true;
        this.pointSize = 1;
        this.zOffset = 0;
        this.zOffsetUnits = 0;
        this.stencil = new MaterialStencilState();
        this._useUBO = false;
        this._fillMode = _Material.TriangleFillMode;
        this._cachedDepthWriteState = false;
        this._cachedColorWriteState = false;
        this._cachedDepthFunctionState = 0;
        this._indexInSceneMaterialArray = -1;
        this.meshMap = null;
        this._parentContainer = null;
        this._uniformBufferLayoutBuilt = false;
        this._eventInfo = {};
        this._callbackPluginEventGeneric = () => void 0;
        this._callbackPluginEventIsReadyForSubMesh = () => void 0;
        this._callbackPluginEventPrepareDefines = () => void 0;
        this._callbackPluginEventPrepareDefinesBeforeAttributes = () => void 0;
        this._callbackPluginEventHardBindForSubMesh = () => void 0;
        this._callbackPluginEventBindForSubMesh = () => void 0;
        this._callbackPluginEventHasRenderTargetTextures = () => void 0;
        this._callbackPluginEventFillRenderTargetTextures = () => void 0;
        this._forceAlphaTest = false;
        this._transparencyMode = null;
        this.name = name;
        const setScene = scene || EngineStore.LastCreatedScene;
        if (!setScene) {
          return;
        }
        this._scene = setScene;
        this._dirtyCallbacks = {};
        this._dirtyCallbacks[1] = this._markAllSubMeshesAsTexturesDirty.bind(this);
        this._dirtyCallbacks[2] = this._markAllSubMeshesAsLightsDirty.bind(this);
        this._dirtyCallbacks[4] = this._markAllSubMeshesAsFresnelDirty.bind(this);
        this._dirtyCallbacks[8] = this._markAllSubMeshesAsAttributesDirty.bind(this);
        this._dirtyCallbacks[16] = this._markAllSubMeshesAsMiscDirty.bind(this);
        this._dirtyCallbacks[32] = this._markAllSubMeshesAsPrePassDirty.bind(this);
        this._dirtyCallbacks[63] = this._markAllSubMeshesAsAllDirty.bind(this);
        this.id = name || Tools.RandomId();
        this.uniqueId = this._scene.getUniqueId();
        this._materialContext = this._scene.getEngine().createMaterialContext();
        this._drawWrapper = new DrawWrapper(this._scene.getEngine(), false);
        this._drawWrapper.materialContext = this._materialContext;
        this._uniformBuffer = new UniformBuffer(this._scene.getEngine(), void 0, void 0, name);
        this._useUBO = this.getScene().getEngine().supportsUniformBuffers;
        if (!doNotAdd) {
          this._scene.addMaterial(this);
        }
        if (this._scene.useMaterialMeshMap) {
          this.meshMap = {};
        }
        _Material.OnEventObservable.notifyObservers(
          this,
          1
          /* MaterialPluginEvent.Created */
        );
      }
      /**
       * Returns a string representation of the current material
       * @param fullDetails defines a boolean indicating which levels of logging is desired
       * @returns a string with material information
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      toString(fullDetails) {
        const ret = "Name: " + this.name;
        return ret;
      }
      /**
       * Gets the class name of the material
       * @returns a string with the class name of the material
       */
      getClassName() {
        return "Material";
      }
      /** @internal */
      get _isMaterial() {
        return true;
      }
      /**
       * Specifies if updates for the material been locked
       */
      get isFrozen() {
        return this.checkReadyOnlyOnce;
      }
      /**
       * Locks updates for the material
       */
      freeze() {
        this.markDirty();
        this.checkReadyOnlyOnce = true;
      }
      /**
       * Unlocks updates for the material
       */
      unfreeze() {
        this.markDirty();
        this.checkReadyOnlyOnce = false;
      }
      /**
       * Specifies if the material is ready to be used
       * @param mesh defines the mesh to check
       * @param useInstances specifies if instances should be used
       * @returns a boolean indicating if the material is ready to be used
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      isReady(mesh, useInstances) {
        return true;
      }
      /**
       * Specifies that the submesh is ready to be used
       * @param mesh defines the mesh to check
       * @param subMesh defines which submesh to check
       * @param useInstances specifies that instances should be used
       * @returns a boolean indicating that the submesh is ready or not
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      isReadyForSubMesh(mesh, subMesh, useInstances) {
        const defines = subMesh.materialDefines;
        if (!defines) {
          return false;
        }
        this._eventInfo.isReadyForSubMesh = true;
        this._eventInfo.defines = defines;
        this._callbackPluginEventIsReadyForSubMesh(this._eventInfo);
        return this._eventInfo.isReadyForSubMesh;
      }
      /**
       * Returns the material effect
       * @returns the effect associated with the material
       */
      getEffect() {
        return this._drawWrapper.effect;
      }
      /**
       * Returns the current scene
       * @returns a Scene
       */
      getScene() {
        return this._scene;
      }
      /** @internal */
      _getEffectiveOrientation(mesh) {
        return this.sideOrientation !== null ? this.sideOrientation : mesh.sideOrientation;
      }
      /**
       * Gets the current transparency mode.
       */
      get transparencyMode() {
        return this._transparencyMode;
      }
      /**
       * Sets the transparency mode of the material.
       *
       * | Value | Type                                | Description |
       * | ----- | ----------------------------------- | ----------- |
       * | 0     | OPAQUE                              |             |
       * | 1     | ALPHATEST                           |             |
       * | 2     | ALPHABLEND                          |             |
       * | 3     | ALPHATESTANDBLEND                   |             |
       *
       */
      set transparencyMode(value) {
        if (this._transparencyMode === value) {
          return;
        }
        this._transparencyMode = value;
        this._forceAlphaTest = value === _Material.MATERIAL_ALPHATESTANDBLEND;
        this._markAllSubMeshesAsTexturesAndMiscDirty();
      }
      /**
       * Returns true if alpha blending should be disabled.
       */
      get _disableAlphaBlending() {
        return this._transparencyMode === _Material.MATERIAL_OPAQUE || this._transparencyMode === _Material.MATERIAL_ALPHATEST;
      }
      /**
       * Specifies whether or not this material should be rendered in alpha blend mode.
       * @returns a boolean specifying if alpha blending is needed
       */
      needAlphaBlending() {
        if (this._disableAlphaBlending) {
          return false;
        }
        return this.alpha < 1;
      }
      /**
       * Specifies if the mesh will require alpha blending
       * @param mesh defines the mesh to check
       * @returns a boolean specifying if alpha blending is needed for the mesh
       */
      needAlphaBlendingForMesh(mesh) {
        if (mesh.visibility < 1) {
          return true;
        }
        if (this._disableAlphaBlending) {
          return false;
        }
        return mesh.hasVertexAlpha || this.needAlphaBlending();
      }
      /**
       * Specifies whether or not this material should be rendered in alpha test mode.
       * @returns a boolean specifying if an alpha test is needed.
       */
      needAlphaTesting() {
        if (this._forceAlphaTest) {
          return true;
        }
        return false;
      }
      /**
       * Specifies if material alpha testing should be turned on for the mesh
       * @param mesh defines the mesh to check
       * @returns a boolean specifying if alpha testing should be turned on for the mesh
       */
      _shouldTurnAlphaTestOn(mesh) {
        return !this.needAlphaBlendingForMesh(mesh) && this.needAlphaTesting();
      }
      /**
       * Gets the texture used for the alpha test
       * @returns the texture to use for alpha testing
       */
      getAlphaTestTexture() {
        return null;
      }
      /**
       * Marks the material to indicate that it needs to be re-calculated
       * @param forceMaterialDirty - Forces the material to be marked as dirty for all components (same as this.markAsDirty(Material.AllDirtyFlag)). You should use this flag if the material is frozen and you want to force a recompilation.
       */
      markDirty(forceMaterialDirty = false) {
        const meshes = this.getScene().meshes;
        for (const mesh of meshes) {
          if (!mesh.subMeshes) {
            continue;
          }
          for (const subMesh of mesh.subMeshes) {
            if (subMesh.getMaterial() !== this) {
              continue;
            }
            for (const drawWrapper of subMesh._drawWrappers) {
              if (!drawWrapper) {
                continue;
              }
              if (this._materialContext === drawWrapper.materialContext) {
                drawWrapper._wasPreviouslyReady = false;
                drawWrapper._wasPreviouslyUsingInstances = null;
                drawWrapper._forceRebindOnNextCall = forceMaterialDirty;
              }
            }
          }
        }
        if (forceMaterialDirty) {
          this.markAsDirty(_Material.AllDirtyFlag);
        }
      }
      /**
       * @internal
       */
      _preBind(effect, overrideOrientation = null) {
        const engine = this._scene.getEngine();
        const orientation = overrideOrientation == null ? this.sideOrientation : overrideOrientation;
        const reverse = orientation === _Material.ClockWiseSideOrientation;
        engine.enableEffect(effect ? effect : this._getDrawWrapper());
        engine.setState(this.backFaceCulling, this.zOffset, false, reverse, this._scene._mirroredCameraPosition ? !this.cullBackFaces : this.cullBackFaces, this.stencil, this.zOffsetUnits);
        return reverse;
      }
      /**
       * Binds the material to the mesh
       * @param world defines the world transformation matrix
       * @param mesh defines the mesh to bind the material to
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      bind(world, mesh) {
      }
      /**
       * Initializes the uniform buffer layout for the shader.
       */
      buildUniformLayout() {
        const ubo = this._uniformBuffer;
        this._eventInfo.ubo = ubo;
        this._callbackPluginEventGeneric(8, this._eventInfo);
        ubo.create();
        this._uniformBufferLayoutBuilt = true;
      }
      /**
       * Binds the submesh to the material
       * @param world defines the world transformation matrix
       * @param mesh defines the mesh containing the submesh
       * @param subMesh defines the submesh to bind the material to
       */
      bindForSubMesh(world, mesh, subMesh) {
        const drawWrapper = subMesh._drawWrapper;
        this._eventInfo.subMesh = subMesh;
        this._callbackPluginEventBindForSubMesh(this._eventInfo);
        drawWrapper._forceRebindOnNextCall = false;
      }
      /**
       * Binds the world matrix to the material
       * @param world defines the world transformation matrix
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      bindOnlyWorldMatrix(world) {
      }
      /**
       * Binds the view matrix to the effect
       * @param effect defines the effect to bind the view matrix to
       */
      bindView(effect) {
        if (!this._useUBO) {
          effect.setMatrix("view", this.getScene().getViewMatrix());
        } else {
          this._needToBindSceneUbo = true;
        }
      }
      /**
       * Binds the view projection and projection matrices to the effect
       * @param effect defines the effect to bind the view projection and projection matrices to
       */
      bindViewProjection(effect) {
        if (!this._useUBO) {
          effect.setMatrix("viewProjection", this.getScene().getTransformMatrix());
          effect.setMatrix("projection", this.getScene().getProjectionMatrix());
        } else {
          this._needToBindSceneUbo = true;
        }
      }
      /**
       * Binds the view matrix to the effect
       * @param effect defines the effect to bind the view matrix to
       * @param variableName name of the shader variable that will hold the eye position
       */
      bindEyePosition(effect, variableName) {
        if (!this._useUBO) {
          this._scene.bindEyePosition(effect, variableName);
        } else {
          this._needToBindSceneUbo = true;
        }
      }
      /**
       * Processes to execute after binding the material to a mesh
       * @param mesh defines the rendered mesh
       * @param effect defines the effect used to bind the material
       * @param _subMesh defines the subMesh that the material has been bound for
       */
      _afterBind(mesh, effect = null, _subMesh) {
        this._scene._cachedMaterial = this;
        if (this._needToBindSceneUbo) {
          if (effect) {
            this._needToBindSceneUbo = false;
            BindSceneUniformBuffer(effect, this.getScene().getSceneUniformBuffer());
            this._scene.finalizeSceneUbo();
          }
        }
        if (mesh) {
          this._scene._cachedVisibility = mesh.visibility;
        } else {
          this._scene._cachedVisibility = 1;
        }
        if (this._onBindObservable && mesh) {
          this._onBindObservable.notifyObservers(mesh);
        }
        if (this.disableDepthWrite) {
          const engine = this._scene.getEngine();
          this._cachedDepthWriteState = engine.getDepthWrite();
          engine.setDepthWrite(false);
        }
        if (this.disableColorWrite) {
          const engine = this._scene.getEngine();
          this._cachedColorWriteState = engine.getColorWrite();
          engine.setColorWrite(false);
        }
        if (this.depthFunction !== 0) {
          const engine = this._scene.getEngine();
          this._cachedDepthFunctionState = engine.getDepthFunction() || 0;
          engine.setDepthFunction(this.depthFunction);
        }
      }
      /**
       * Unbinds the material from the mesh
       */
      unbind() {
        if (this._onUnBindObservable) {
          this._onUnBindObservable.notifyObservers(this);
        }
        if (this.depthFunction !== 0) {
          const engine = this._scene.getEngine();
          engine.setDepthFunction(this._cachedDepthFunctionState);
        }
        if (this.disableDepthWrite) {
          const engine = this._scene.getEngine();
          engine.setDepthWrite(this._cachedDepthWriteState);
        }
        if (this.disableColorWrite) {
          const engine = this._scene.getEngine();
          engine.setColorWrite(this._cachedColorWriteState);
        }
      }
      /**
       * Returns the animatable textures.
       * @returns - Array of animatable textures.
       */
      getAnimatables() {
        this._eventInfo.animatables = [];
        this._callbackPluginEventGeneric(256, this._eventInfo);
        return this._eventInfo.animatables;
      }
      /**
       * Gets the active textures from the material
       * @returns an array of textures
       */
      getActiveTextures() {
        this._eventInfo.activeTextures = [];
        this._callbackPluginEventGeneric(512, this._eventInfo);
        return this._eventInfo.activeTextures;
      }
      /**
       * Specifies if the material uses a texture
       * @param texture defines the texture to check against the material
       * @returns a boolean specifying if the material uses the texture
       */
      hasTexture(texture) {
        this._eventInfo.hasTexture = false;
        this._eventInfo.texture = texture;
        this._callbackPluginEventGeneric(1024, this._eventInfo);
        return this._eventInfo.hasTexture;
      }
      /**
       * Makes a duplicate of the material, and gives it a new name
       * @param name defines the new name for the duplicated material
       * @returns the cloned material
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      clone(name) {
        return null;
      }
      _clonePlugins(targetMaterial, rootUrl) {
        const serializationObject = {};
        this._serializePlugins(serializationObject);
        _Material._ParsePlugins(serializationObject, targetMaterial, this._scene, rootUrl);
        if (this.pluginManager) {
          for (const plugin of this.pluginManager._plugins) {
            const targetPlugin = targetMaterial.pluginManager.getPlugin(plugin.name);
            if (targetPlugin) {
              plugin.copyTo(targetPlugin);
            }
          }
        }
      }
      /**
       * Gets the meshes bound to the material
       * @returns an array of meshes bound to the material
       */
      getBindedMeshes() {
        if (this.meshMap) {
          const result = [];
          for (const meshId in this.meshMap) {
            const mesh = this.meshMap[meshId];
            if (mesh) {
              result.push(mesh);
            }
          }
          return result;
        } else {
          const meshes = this._scene.meshes;
          return meshes.filter((mesh) => mesh.material === this);
        }
      }
      /**
       * Force shader compilation
       * @param mesh defines the mesh associated with this material
       * @param onCompiled defines a function to execute once the material is compiled
       * @param options defines the options to configure the compilation
       * @param onError defines a function to execute if the material fails compiling
       */
      forceCompilation(mesh, onCompiled, options, onError) {
        const localOptions = __spreadValues({
          clipPlane: false,
          useInstances: false
        }, options);
        const scene = this.getScene();
        const currentHotSwapingState = this.allowShaderHotSwapping;
        this.allowShaderHotSwapping = false;
        const checkReady = () => {
          if (!this._scene || !this._scene.getEngine()) {
            return;
          }
          const clipPlaneState = scene.clipPlane;
          if (localOptions.clipPlane) {
            scene.clipPlane = new Plane(0, 0, 0, 1);
          }
          if (this._storeEffectOnSubMeshes) {
            let allDone = true, lastError = null;
            if (mesh.subMeshes) {
              const tempSubMesh = new SubMesh(0, 0, 0, 0, 0, mesh, void 0, false, false);
              if (tempSubMesh.materialDefines) {
                tempSubMesh.materialDefines._renderId = -1;
              }
              if (!this.isReadyForSubMesh(mesh, tempSubMesh, localOptions.useInstances)) {
                if (tempSubMesh.effect && tempSubMesh.effect.getCompilationError() && tempSubMesh.effect.allFallbacksProcessed()) {
                  lastError = tempSubMesh.effect.getCompilationError();
                } else {
                  allDone = false;
                  setTimeout(checkReady, 16);
                }
              }
            }
            if (allDone) {
              this.allowShaderHotSwapping = currentHotSwapingState;
              if (lastError) {
                if (onError) {
                  onError(lastError);
                }
              }
              if (onCompiled) {
                onCompiled(this);
              }
            }
          } else {
            if (this.isReady()) {
              this.allowShaderHotSwapping = currentHotSwapingState;
              if (onCompiled) {
                onCompiled(this);
              }
            } else {
              setTimeout(checkReady, 16);
            }
          }
          if (localOptions.clipPlane) {
            scene.clipPlane = clipPlaneState;
          }
        };
        checkReady();
      }
      /**
       * Force shader compilation
       * @param mesh defines the mesh that will use this material
       * @param options defines additional options for compiling the shaders
       * @returns a promise that resolves when the compilation completes
       */
      forceCompilationAsync(mesh, options) {
        return new Promise((resolve, reject) => {
          this.forceCompilation(mesh, () => {
            resolve();
          }, options, (reason) => {
            reject(reason);
          });
        });
      }
      /**
       * Marks a define in the material to indicate that it needs to be re-computed
       * @param flag defines a flag used to determine which parts of the material have to be marked as dirty
       */
      markAsDirty(flag) {
        if (this.getScene().blockMaterialDirtyMechanism || this._blockDirtyMechanism) {
          return;
        }
        _Material._DirtyCallbackArray.length = 0;
        if (flag & _Material.TextureDirtyFlag) {
          _Material._DirtyCallbackArray.push(_Material._TextureDirtyCallBack);
        }
        if (flag & _Material.LightDirtyFlag) {
          _Material._DirtyCallbackArray.push(_Material._LightsDirtyCallBack);
        }
        if (flag & _Material.FresnelDirtyFlag) {
          _Material._DirtyCallbackArray.push(_Material._FresnelDirtyCallBack);
        }
        if (flag & _Material.AttributesDirtyFlag) {
          _Material._DirtyCallbackArray.push(_Material._AttributeDirtyCallBack);
        }
        if (flag & _Material.MiscDirtyFlag) {
          _Material._DirtyCallbackArray.push(_Material._MiscDirtyCallBack);
        }
        if (flag & _Material.PrePassDirtyFlag) {
          _Material._DirtyCallbackArray.push(_Material._PrePassDirtyCallBack);
        }
        if (_Material._DirtyCallbackArray.length) {
          this._markAllSubMeshesAsDirty(_Material._RunDirtyCallBacks);
        }
        this.getScene().resetCachedMaterial();
      }
      /**
       * Resets the draw wrappers cache for all submeshes that are using this material
       */
      resetDrawCache() {
        const meshes = this.getScene().meshes;
        for (const mesh of meshes) {
          if (!mesh.subMeshes) {
            continue;
          }
          for (const subMesh of mesh.subMeshes) {
            if (subMesh.getMaterial() !== this) {
              continue;
            }
            subMesh.resetDrawCache();
          }
        }
      }
      /**
       * Marks all submeshes of a material to indicate that their material defines need to be re-calculated
       * @param func defines a function which checks material defines against the submeshes
       */
      _markAllSubMeshesAsDirty(func) {
        if (this.getScene().blockMaterialDirtyMechanism || this._blockDirtyMechanism) {
          return;
        }
        const meshes = this.getScene().meshes;
        for (const mesh of meshes) {
          if (!mesh.subMeshes) {
            continue;
          }
          for (const subMesh of mesh.subMeshes) {
            if (subMesh.getMaterial(false) !== this) {
              continue;
            }
            for (const drawWrapper of subMesh._drawWrappers) {
              if (!drawWrapper || !drawWrapper.defines || !drawWrapper.defines.markAllAsDirty) {
                continue;
              }
              if (this._materialContext === drawWrapper.materialContext) {
                func(drawWrapper.defines);
              }
            }
          }
        }
      }
      /**
       * Indicates that the scene should check if the rendering now needs a prepass
       */
      _markScenePrePassDirty() {
        if (this.getScene().blockMaterialDirtyMechanism || this._blockDirtyMechanism) {
          return;
        }
        const prePassRenderer = this.getScene().enablePrePassRenderer();
        if (prePassRenderer) {
          prePassRenderer.markAsDirty();
        }
      }
      /**
       * Indicates that we need to re-calculated for all submeshes
       */
      _markAllSubMeshesAsAllDirty() {
        this._markAllSubMeshesAsDirty(_Material._AllDirtyCallBack);
      }
      /**
       * Indicates that image processing needs to be re-calculated for all submeshes
       */
      _markAllSubMeshesAsImageProcessingDirty() {
        this._markAllSubMeshesAsDirty(_Material._ImageProcessingDirtyCallBack);
      }
      /**
       * Indicates that textures need to be re-calculated for all submeshes
       */
      _markAllSubMeshesAsTexturesDirty() {
        this._markAllSubMeshesAsDirty(_Material._TextureDirtyCallBack);
      }
      /**
       * Indicates that fresnel needs to be re-calculated for all submeshes
       */
      _markAllSubMeshesAsFresnelDirty() {
        this._markAllSubMeshesAsDirty(_Material._FresnelDirtyCallBack);
      }
      /**
       * Indicates that fresnel and misc need to be re-calculated for all submeshes
       */
      _markAllSubMeshesAsFresnelAndMiscDirty() {
        this._markAllSubMeshesAsDirty(_Material._FresnelAndMiscDirtyCallBack);
      }
      /**
       * Indicates that lights need to be re-calculated for all submeshes
       */
      _markAllSubMeshesAsLightsDirty() {
        this._markAllSubMeshesAsDirty(_Material._LightsDirtyCallBack);
      }
      /**
       * Indicates that attributes need to be re-calculated for all submeshes
       */
      _markAllSubMeshesAsAttributesDirty() {
        this._markAllSubMeshesAsDirty(_Material._AttributeDirtyCallBack);
      }
      /**
       * Indicates that misc needs to be re-calculated for all submeshes
       */
      _markAllSubMeshesAsMiscDirty() {
        this._markAllSubMeshesAsDirty(_Material._MiscDirtyCallBack);
      }
      /**
       * Indicates that prepass needs to be re-calculated for all submeshes
       */
      _markAllSubMeshesAsPrePassDirty() {
        this._markAllSubMeshesAsDirty(_Material._MiscDirtyCallBack);
      }
      /**
       * Indicates that textures and misc need to be re-calculated for all submeshes
       */
      _markAllSubMeshesAsTexturesAndMiscDirty() {
        this._markAllSubMeshesAsDirty(_Material._TextureAndMiscDirtyCallBack);
      }
      _checkScenePerformancePriority() {
        if (this._scene.performancePriority !== 0) {
          this.checkReadyOnlyOnce = true;
          const observer = this._scene.onScenePerformancePriorityChangedObservable.addOnce(() => {
            this.checkReadyOnlyOnce = false;
          });
          this.onDisposeObservable.add(() => {
            this._scene.onScenePerformancePriorityChangedObservable.remove(observer);
          });
        }
      }
      /**
       * Sets the required values to the prepass renderer.
       * @param prePassRenderer defines the prepass renderer to setup.
       * @returns true if the pre pass is needed.
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      setPrePassRenderer(prePassRenderer) {
        return false;
      }
      /**
       * Disposes the material
       * @param forceDisposeEffect specifies if effects should be forcefully disposed
       * @param forceDisposeTextures specifies if textures should be forcefully disposed
       * @param notBoundToMesh specifies if the material that is being disposed is known to be not bound to any mesh
       */
      dispose(forceDisposeEffect, forceDisposeTextures, notBoundToMesh) {
        const scene = this.getScene();
        scene.stopAnimation(this);
        scene.freeProcessedMaterials();
        scene.removeMaterial(this);
        this._eventInfo.forceDisposeTextures = forceDisposeTextures;
        this._callbackPluginEventGeneric(2, this._eventInfo);
        if (this._parentContainer) {
          const index = this._parentContainer.materials.indexOf(this);
          if (index > -1) {
            this._parentContainer.materials.splice(index, 1);
          }
          this._parentContainer = null;
        }
        if (notBoundToMesh !== true) {
          if (this.meshMap) {
            for (const meshId in this.meshMap) {
              const mesh = this.meshMap[meshId];
              if (mesh) {
                mesh.material = null;
                this.releaseVertexArrayObject(mesh, forceDisposeEffect);
              }
            }
          } else {
            const meshes = scene.meshes;
            for (const mesh of meshes) {
              if (mesh.material === this && !mesh.sourceMesh) {
                mesh.material = null;
                this.releaseVertexArrayObject(mesh, forceDisposeEffect);
              }
            }
          }
        }
        this._uniformBuffer.dispose();
        if (forceDisposeEffect && this._drawWrapper.effect) {
          if (!this._storeEffectOnSubMeshes) {
            this._drawWrapper.effect.dispose();
          }
          this._drawWrapper.effect = null;
        }
        this.metadata = null;
        this.onDisposeObservable.notifyObservers(this);
        this.onDisposeObservable.clear();
        if (this._onBindObservable) {
          this._onBindObservable.clear();
        }
        if (this._onUnBindObservable) {
          this._onUnBindObservable.clear();
        }
        if (this._onEffectCreatedObservable) {
          this._onEffectCreatedObservable.clear();
        }
        if (this._eventInfo) {
          this._eventInfo = {};
        }
      }
      /**
       * @internal
       */
      // eslint-disable-next-line @typescript-eslint/naming-convention
      releaseVertexArrayObject(mesh, forceDisposeEffect) {
        const geometry = mesh.geometry;
        if (geometry) {
          if (this._storeEffectOnSubMeshes) {
            if (mesh.subMeshes) {
              for (const subMesh of mesh.subMeshes) {
                geometry._releaseVertexArrayObject(subMesh.effect);
                if (forceDisposeEffect && subMesh.effect) {
                  subMesh.effect.dispose();
                }
              }
            }
          } else {
            geometry._releaseVertexArrayObject(this._drawWrapper.effect);
          }
        }
      }
      /**
       * Serializes this material
       * @returns the serialized material object
       */
      serialize() {
        const serializationObject = SerializationHelper.Serialize(this);
        serializationObject.stencil = this.stencil.serialize();
        serializationObject.uniqueId = this.uniqueId;
        this._serializePlugins(serializationObject);
        return serializationObject;
      }
      _serializePlugins(serializationObject) {
        serializationObject.plugins = {};
        if (this.pluginManager) {
          for (const plugin of this.pluginManager._plugins) {
            serializationObject.plugins[plugin.getClassName()] = plugin.serialize();
          }
        }
      }
      /**
       * Creates a material from parsed material data
       * @param parsedMaterial defines parsed material data
       * @param scene defines the hosting scene
       * @param rootUrl defines the root URL to use to load textures
       * @returns a new material
       */
      static Parse(parsedMaterial, scene, rootUrl) {
        if (!parsedMaterial.customType) {
          parsedMaterial.customType = "BABYLON.StandardMaterial";
        } else if (parsedMaterial.customType === "BABYLON.PBRMaterial" && parsedMaterial.overloadedAlbedo) {
          parsedMaterial.customType = "BABYLON.LegacyPBRMaterial";
          if (!BABYLON.LegacyPBRMaterial) {
            Logger.Error("Your scene is trying to load a legacy version of the PBRMaterial, please, include it from the materials library.");
            return null;
          }
        }
        const materialType = Tools.Instantiate(parsedMaterial.customType);
        const material = materialType.Parse(parsedMaterial, scene, rootUrl);
        material._loadedUniqueId = parsedMaterial.uniqueId;
        return material;
      }
      static _ParsePlugins(serializationObject, material, scene, rootUrl) {
        var _a;
        if (!serializationObject.plugins) {
          return;
        }
        for (const pluginClassName in serializationObject.plugins) {
          const pluginData = serializationObject.plugins[pluginClassName];
          let plugin = (_a = material.pluginManager) == null ? void 0 : _a.getPlugin(pluginData.name);
          if (!plugin) {
            const pluginClassType = Tools.Instantiate("BABYLON." + pluginClassName);
            if (pluginClassType) {
              plugin = new pluginClassType(material);
            }
          }
          plugin == null ? void 0 : plugin.parse(pluginData, scene, rootUrl);
        }
      }
    };
    Material.TriangleFillMode = 0;
    Material.WireFrameFillMode = 1;
    Material.PointFillMode = 2;
    Material.PointListDrawMode = 3;
    Material.LineListDrawMode = 4;
    Material.LineLoopDrawMode = 5;
    Material.LineStripDrawMode = 6;
    Material.TriangleStripDrawMode = 7;
    Material.TriangleFanDrawMode = 8;
    Material.ClockWiseSideOrientation = 0;
    Material.CounterClockWiseSideOrientation = 1;
    Material.TextureDirtyFlag = 1;
    Material.LightDirtyFlag = 2;
    Material.FresnelDirtyFlag = 4;
    Material.AttributesDirtyFlag = 8;
    Material.MiscDirtyFlag = 16;
    Material.PrePassDirtyFlag = 32;
    Material.AllDirtyFlag = 63;
    Material.MATERIAL_OPAQUE = 0;
    Material.MATERIAL_ALPHATEST = 1;
    Material.MATERIAL_ALPHABLEND = 2;
    Material.MATERIAL_ALPHATESTANDBLEND = 3;
    Material.MATERIAL_NORMALBLENDMETHOD_WHITEOUT = 0;
    Material.MATERIAL_NORMALBLENDMETHOD_RNM = 1;
    Material.OnEventObservable = new Observable();
    Material._AllDirtyCallBack = (defines) => defines.markAllAsDirty();
    Material._ImageProcessingDirtyCallBack = (defines) => defines.markAsImageProcessingDirty();
    Material._TextureDirtyCallBack = (defines) => defines.markAsTexturesDirty();
    Material._FresnelDirtyCallBack = (defines) => defines.markAsFresnelDirty();
    Material._MiscDirtyCallBack = (defines) => defines.markAsMiscDirty();
    Material._PrePassDirtyCallBack = (defines) => defines.markAsPrePassDirty();
    Material._LightsDirtyCallBack = (defines) => defines.markAsLightDirty();
    Material._AttributeDirtyCallBack = (defines) => defines.markAsAttributesDirty();
    Material._FresnelAndMiscDirtyCallBack = (defines) => {
      Material._FresnelDirtyCallBack(defines);
      Material._MiscDirtyCallBack(defines);
    };
    Material._TextureAndMiscDirtyCallBack = (defines) => {
      Material._TextureDirtyCallBack(defines);
      Material._MiscDirtyCallBack(defines);
    };
    Material._DirtyCallbackArray = [];
    Material._RunDirtyCallBacks = (defines) => {
      for (const cb of Material._DirtyCallbackArray) {
        cb(defines);
      }
    };
    __decorate([
      serialize()
    ], Material.prototype, "id", void 0);
    __decorate([
      serialize()
    ], Material.prototype, "uniqueId", void 0);
    __decorate([
      serialize()
    ], Material.prototype, "name", void 0);
    __decorate([
      serialize()
    ], Material.prototype, "metadata", void 0);
    __decorate([
      serialize()
    ], Material.prototype, "checkReadyOnEveryCall", void 0);
    __decorate([
      serialize()
    ], Material.prototype, "checkReadyOnlyOnce", void 0);
    __decorate([
      serialize()
    ], Material.prototype, "state", void 0);
    __decorate([
      serialize("alpha")
    ], Material.prototype, "_alpha", void 0);
    __decorate([
      serialize("backFaceCulling")
    ], Material.prototype, "_backFaceCulling", void 0);
    __decorate([
      serialize("cullBackFaces")
    ], Material.prototype, "_cullBackFaces", void 0);
    __decorate([
      serialize()
    ], Material.prototype, "sideOrientation", void 0);
    __decorate([
      serialize("alphaMode")
    ], Material.prototype, "_alphaMode", void 0);
    __decorate([
      serialize()
    ], Material.prototype, "_needDepthPrePass", void 0);
    __decorate([
      serialize()
    ], Material.prototype, "disableDepthWrite", void 0);
    __decorate([
      serialize()
    ], Material.prototype, "disableColorWrite", void 0);
    __decorate([
      serialize()
    ], Material.prototype, "forceDepthWrite", void 0);
    __decorate([
      serialize()
    ], Material.prototype, "depthFunction", void 0);
    __decorate([
      serialize()
    ], Material.prototype, "separateCullingPass", void 0);
    __decorate([
      serialize("fogEnabled")
    ], Material.prototype, "_fogEnabled", void 0);
    __decorate([
      serialize()
    ], Material.prototype, "pointSize", void 0);
    __decorate([
      serialize()
    ], Material.prototype, "zOffset", void 0);
    __decorate([
      serialize()
    ], Material.prototype, "zOffsetUnits", void 0);
    __decorate([
      serialize()
    ], Material.prototype, "pointsCloud", null);
    __decorate([
      serialize()
    ], Material.prototype, "fillMode", null);
    __decorate([
      serialize()
    ], Material.prototype, "useLogarithmicDepth", null);
    __decorate([
      serialize()
    ], Material.prototype, "transparencyMode", null);
  }
});

// node_modules/@babylonjs/core/PostProcesses/blurPostProcess.js
var BlurPostProcess;
var init_blurPostProcess = __esm({
  "node_modules/@babylonjs/core/PostProcesses/blurPostProcess.js"() {
    "use strict";
    init_tslib_es6();
    init_postProcess();
    init_texture();
    init_typeStore();
    init_decorators();
    init_decorators_serialization();
    BlurPostProcess = class _BlurPostProcess extends PostProcess {
      /**
       * Sets the length in pixels of the blur sample region
       */
      set kernel(v) {
        if (this._idealKernel === v) {
          return;
        }
        v = Math.max(v, 1);
        this._idealKernel = v;
        this._kernel = this._nearestBestKernel(v);
        if (!this._blockCompilation) {
          this._updateParameters();
        }
      }
      /**
       * Gets the length in pixels of the blur sample region
       */
      get kernel() {
        return this._idealKernel;
      }
      /**
       * Sets whether or not the blur needs to unpack/repack floats
       */
      set packedFloat(v) {
        if (this._packedFloat === v) {
          return;
        }
        this._packedFloat = v;
        if (!this._blockCompilation) {
          this._updateParameters();
        }
      }
      /**
       * Gets whether or not the blur is unpacking/repacking floats
       */
      get packedFloat() {
        return this._packedFloat;
      }
      /**
       * Gets a string identifying the name of the class
       * @returns "BlurPostProcess" string
       */
      getClassName() {
        return "BlurPostProcess";
      }
      /**
       * Creates a new instance BlurPostProcess
       * @param name The name of the effect.
       * @param direction The direction in which to blur the image.
       * @param kernel The size of the kernel to be used when computing the blur. eg. Size of 3 will blur the center pixel by 2 pixels surrounding it.
       * @param options The required width/height ratio to downsize to before computing the render pass. (Use 1.0 for full size)
       * @param camera The camera to apply the render pass to.
       * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
       * @param engine The engine which the post process will be applied. (default: current engine)
       * @param reusable If the post process can be reused on the same frame. (default: false)
       * @param textureType Type of textures used when performing the post process. (default: 0)
       * @param defines
       * @param _blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
       * @param textureFormat Format of textures used when performing the post process. (default: TEXTUREFORMAT_RGBA)
       */
      constructor(name, direction, kernel, options, camera, samplingMode = Texture.BILINEAR_SAMPLINGMODE, engine, reusable, textureType = 0, defines = "", _blockCompilation = false, textureFormat = 5) {
        super(name, "kernelBlur", ["delta", "direction"], ["circleOfConfusionSampler"], options, camera, samplingMode, engine, reusable, null, textureType, "kernelBlur", { varyingCount: 0, depCount: 0 }, true, textureFormat);
        this._blockCompilation = _blockCompilation;
        this._packedFloat = false;
        this._staticDefines = "";
        this._staticDefines = defines;
        this.direction = direction;
        this.onApplyObservable.add((effect) => {
          if (this._outputTexture) {
            effect.setFloat2("delta", 1 / this._outputTexture.width * this.direction.x, 1 / this._outputTexture.height * this.direction.y);
          } else {
            effect.setFloat2("delta", 1 / this.width * this.direction.x, 1 / this.height * this.direction.y);
          }
        });
        this.kernel = kernel;
      }
      _gatherImports(useWebGPU, list) {
        if (useWebGPU) {
          this._webGPUReady = true;
          list.push(Promise.all([import("./kernelBlur.fragment-TWBIYDJT.mjs"), import("./kernelBlur.vertex-7AWC3YSE.mjs")]));
        } else {
          list.push(Promise.all([import("./kernelBlur.fragment-SRXK3MJQ.mjs"), import("./kernelBlur.vertex-QBSTDWFU.mjs")]));
        }
        super._gatherImports(useWebGPU, list);
      }
      /**
       * Updates the effect with the current post process compile time values and recompiles the shader.
       * @param defines Define statements that should be added at the beginning of the shader. (default: null)
       * @param uniforms Set of uniform variables that will be passed to the shader. (default: null)
       * @param samplers Set of Texture2D variables that will be passed to the shader. (default: null)
       * @param indexParameters The index parameters to be used for babylons include syntax "#include<kernelBlurVaryingDeclaration>[0..varyingCount]". (default: undefined) See usage in babylon.blurPostProcess.ts and kernelBlur.vertex.fx
       * @param onCompiled Called when the shader has been compiled.
       * @param onError Called if there is an error when compiling a shader.
       */
      updateEffect(defines = null, uniforms = null, samplers = null, indexParameters, onCompiled, onError) {
        this._updateParameters(onCompiled, onError);
      }
      _updateParameters(onCompiled, onError) {
        const N = this._kernel;
        const centerIndex = (N - 1) / 2;
        let offsets = [];
        let weights = [];
        let totalWeight = 0;
        for (let i = 0; i < N; i++) {
          const u = i / (N - 1);
          const w = this._gaussianWeight(u * 2 - 1);
          offsets[i] = i - centerIndex;
          weights[i] = w;
          totalWeight += w;
        }
        for (let i = 0; i < weights.length; i++) {
          weights[i] /= totalWeight;
        }
        const linearSamplingWeights = [];
        const linearSamplingOffsets = [];
        const linearSamplingMap = [];
        for (let i = 0; i <= centerIndex; i += 2) {
          const j = Math.min(i + 1, Math.floor(centerIndex));
          const singleCenterSample = i === j;
          if (singleCenterSample) {
            linearSamplingMap.push({ o: offsets[i], w: weights[i] });
          } else {
            const sharedCell = j === centerIndex;
            const weightLinear = weights[i] + weights[j] * (sharedCell ? 0.5 : 1);
            const offsetLinear = offsets[i] + 1 / (1 + weights[i] / weights[j]);
            if (offsetLinear === 0) {
              linearSamplingMap.push({ o: offsets[i], w: weights[i] });
              linearSamplingMap.push({ o: offsets[i + 1], w: weights[i + 1] });
            } else {
              linearSamplingMap.push({ o: offsetLinear, w: weightLinear });
              linearSamplingMap.push({ o: -offsetLinear, w: weightLinear });
            }
          }
        }
        for (let i = 0; i < linearSamplingMap.length; i++) {
          linearSamplingOffsets[i] = linearSamplingMap[i].o;
          linearSamplingWeights[i] = linearSamplingMap[i].w;
        }
        offsets = linearSamplingOffsets;
        weights = linearSamplingWeights;
        const maxVaryingRows = this.getEngine().getCaps().maxVaryingVectors - (this.shaderLanguage === 1 ? 1 : 0);
        const freeVaryingVec2 = Math.max(maxVaryingRows, 0) - 1;
        let varyingCount = Math.min(offsets.length, freeVaryingVec2);
        let defines = "";
        defines += this._staticDefines;
        if (this._staticDefines.indexOf("DOF") != -1) {
          defines += `#define CENTER_WEIGHT ${this._glslFloat(weights[varyingCount - 1])}
`;
          varyingCount--;
        }
        for (let i = 0; i < varyingCount; i++) {
          defines += `#define KERNEL_OFFSET${i} ${this._glslFloat(offsets[i])}
`;
          defines += `#define KERNEL_WEIGHT${i} ${this._glslFloat(weights[i])}
`;
        }
        let depCount = 0;
        for (let i = freeVaryingVec2; i < offsets.length; i++) {
          defines += `#define KERNEL_DEP_OFFSET${depCount} ${this._glslFloat(offsets[i])}
`;
          defines += `#define KERNEL_DEP_WEIGHT${depCount} ${this._glslFloat(weights[i])}
`;
          depCount++;
        }
        if (this.packedFloat) {
          defines += `#define PACKEDFLOAT 1`;
        }
        this._blockCompilation = false;
        super.updateEffect(defines, null, null, {
          varyingCount,
          depCount
        }, onCompiled, onError);
      }
      /**
       * Best kernels are odd numbers that when divided by 2, their integer part is even, so 5, 9 or 13.
       * Other odd kernels optimize correctly but require proportionally more samples, even kernels are
       * possible but will produce minor visual artifacts. Since each new kernel requires a new shader we
       * want to minimize kernel changes, having gaps between physical kernels is helpful in that regard.
       * The gaps between physical kernels are compensated for in the weighting of the samples
       * @param idealKernel Ideal blur kernel.
       * @returns Nearest best kernel.
       */
      _nearestBestKernel(idealKernel) {
        const v = Math.round(idealKernel);
        for (const k of [v, v - 1, v + 1, v - 2, v + 2]) {
          if (k % 2 !== 0 && Math.floor(k / 2) % 2 === 0 && k > 0) {
            return Math.max(k, 3);
          }
        }
        return Math.max(v, 3);
      }
      /**
       * Calculates the value of a Gaussian distribution with sigma 3 at a given point.
       * @param x The point on the Gaussian distribution to sample.
       * @returns the value of the Gaussian function at x.
       */
      _gaussianWeight(x) {
        const sigma = 1 / 3;
        const denominator = Math.sqrt(2 * Math.PI) * sigma;
        const exponent = -(x * x / (2 * sigma * sigma));
        const weight = 1 / denominator * Math.exp(exponent);
        return weight;
      }
      /**
       * Generates a string that can be used as a floating point number in GLSL.
       * @param x Value to print.
       * @param decimalFigures Number of decimal places to print the number to (excluding trailing 0s).
       * @returns GLSL float string.
       */
      _glslFloat(x, decimalFigures = 8) {
        return x.toFixed(decimalFigures).replace(/0+$/, "");
      }
      /**
       * @internal
       */
      static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return SerializationHelper.Parse(() => {
          return new _BlurPostProcess(parsedPostProcess.name, parsedPostProcess.direction, parsedPostProcess.kernel, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, scene.getEngine(), parsedPostProcess.reusable, parsedPostProcess.textureType, void 0, false);
        }, parsedPostProcess, scene, rootUrl);
      }
    };
    __decorate([
      serialize("kernel")
    ], BlurPostProcess.prototype, "_kernel", void 0);
    __decorate([
      serialize("packedFloat")
    ], BlurPostProcess.prototype, "_packedFloat", void 0);
    __decorate([
      serializeAsVector2()
    ], BlurPostProcess.prototype, "direction", void 0);
    RegisterClass("BABYLON.BlurPostProcess", BlurPostProcess);
  }
});

// node_modules/@babylonjs/core/Materials/effectFallbacks.js
var EffectFallbacks;
var init_effectFallbacks = __esm({
  "node_modules/@babylonjs/core/Materials/effectFallbacks.js"() {
    "use strict";
    EffectFallbacks = class {
      constructor() {
        this._defines = {};
        this._currentRank = 32;
        this._maxRank = -1;
        this._mesh = null;
      }
      /**
       * Removes the fallback from the bound mesh.
       */
      unBindMesh() {
        this._mesh = null;
      }
      /**
       * Adds a fallback on the specified property.
       * @param rank The rank of the fallback (Lower ranks will be fallbacked to first)
       * @param define The name of the define in the shader
       */
      addFallback(rank, define) {
        if (!this._defines[rank]) {
          if (rank < this._currentRank) {
            this._currentRank = rank;
          }
          if (rank > this._maxRank) {
            this._maxRank = rank;
          }
          this._defines[rank] = new Array();
        }
        this._defines[rank].push(define);
      }
      /**
       * Sets the mesh to use CPU skinning when needing to fallback.
       * @param rank The rank of the fallback (Lower ranks will be fallbacked to first)
       * @param mesh The mesh to use the fallbacks.
       */
      addCPUSkinningFallback(rank, mesh) {
        this._mesh = mesh;
        if (rank < this._currentRank) {
          this._currentRank = rank;
        }
        if (rank > this._maxRank) {
          this._maxRank = rank;
        }
      }
      /**
       * Checks to see if more fallbacks are still available.
       */
      get hasMoreFallbacks() {
        return this._currentRank <= this._maxRank;
      }
      /**
       * Removes the defines that should be removed when falling back.
       * @param currentDefines defines the current define statements for the shader.
       * @param effect defines the current effect we try to compile
       * @returns The resulting defines with defines of the current rank removed.
       */
      reduce(currentDefines, effect) {
        if (this._mesh && this._mesh.computeBonesUsingShaders && this._mesh.numBoneInfluencers > 0) {
          this._mesh.computeBonesUsingShaders = false;
          currentDefines = currentDefines.replace("#define NUM_BONE_INFLUENCERS " + this._mesh.numBoneInfluencers, "#define NUM_BONE_INFLUENCERS 0");
          effect._bonesComputationForcedToCPU = true;
          const scene = this._mesh.getScene();
          for (let index = 0; index < scene.meshes.length; index++) {
            const otherMesh = scene.meshes[index];
            if (!otherMesh.material) {
              if (!this._mesh.material && otherMesh.computeBonesUsingShaders && otherMesh.numBoneInfluencers > 0) {
                otherMesh.computeBonesUsingShaders = false;
              }
              continue;
            }
            if (!otherMesh.computeBonesUsingShaders || otherMesh.numBoneInfluencers === 0) {
              continue;
            }
            if (otherMesh.material.getEffect() === effect) {
              otherMesh.computeBonesUsingShaders = false;
            } else if (otherMesh.subMeshes) {
              for (const subMesh of otherMesh.subMeshes) {
                const subMeshEffect = subMesh.effect;
                if (subMeshEffect === effect) {
                  otherMesh.computeBonesUsingShaders = false;
                  break;
                }
              }
            }
          }
        } else {
          const currentFallbacks = this._defines[this._currentRank];
          if (currentFallbacks) {
            for (let index = 0; index < currentFallbacks.length; index++) {
              currentDefines = currentDefines.replace("#define " + currentFallbacks[index], "");
            }
          }
          this._currentRank++;
        }
        return currentDefines;
      }
    };
  }
});

// node_modules/@babylonjs/core/Layers/effectLayer.js
var EffectLayer;
var init_effectLayer = __esm({
  "node_modules/@babylonjs/core/Layers/effectLayer.js"() {
    "use strict";
    init_tslib_es6();
    init_decorators();
    init_tools();
    init_observable();
    init_math_color();
    init_engineStore();
    init_buffer();
    init_texture();
    init_renderTargetTexture();
    init_material();
    init_devTools();
    init_effectFallbacks();
    init_drawWrapper();
    init_clipPlaneMaterialHelper();
    init_materialHelper_functions();
    init_tools_functions();
    EffectLayer = class _EffectLayer {
      /**
       * Gets the camera attached to the layer.
       */
      get camera() {
        return this._effectLayerOptions.camera;
      }
      /**
       * Gets the rendering group id the layer should render in.
       */
      get renderingGroupId() {
        return this._effectLayerOptions.renderingGroupId;
      }
      set renderingGroupId(renderingGroupId) {
        this._effectLayerOptions.renderingGroupId = renderingGroupId;
      }
      /**
       * Gets the main texture where the effect is rendered
       */
      get mainTexture() {
        return this._mainTexture;
      }
      /**
       * Gets the shader language used in this material.
       */
      get shaderLanguage() {
        return this._shaderLanguage;
      }
      /**
       * Sets a specific material to be used to render a mesh/a list of meshes in the layer
       * @param mesh mesh or array of meshes
       * @param material material to use by the layer when rendering the mesh(es). If undefined is passed, the specific material created by the layer will be used.
       */
      setMaterialForRendering(mesh, material) {
        this._mainTexture.setMaterialForRendering(mesh, material);
        if (Array.isArray(mesh)) {
          for (let i = 0; i < mesh.length; ++i) {
            const currentMesh = mesh[i];
            if (!material) {
              delete this._materialForRendering[currentMesh.uniqueId];
            } else {
              this._materialForRendering[currentMesh.uniqueId] = [currentMesh, material];
            }
          }
        } else {
          if (!material) {
            delete this._materialForRendering[mesh.uniqueId];
          } else {
            this._materialForRendering[mesh.uniqueId] = [mesh, material];
          }
        }
      }
      /**
       * Gets the intensity of the effect for a specific mesh.
       * @param mesh The mesh to get the effect intensity for
       * @returns The intensity of the effect for the mesh
       */
      getEffectIntensity(mesh) {
        var _a;
        return (_a = this._effectIntensity[mesh.uniqueId]) != null ? _a : 1;
      }
      /**
       * Sets the intensity of the effect for a specific mesh.
       * @param mesh The mesh to set the effect intensity for
       * @param intensity The intensity of the effect for the mesh
       */
      setEffectIntensity(mesh, intensity) {
        this._effectIntensity[mesh.uniqueId] = intensity;
      }
      /**
       * Instantiates a new effect Layer and references it in the scene.
       * @param name The name of the layer
       * @param scene The scene to use the layer in
       * @param forceGLSL Use the GLSL code generation for the shader (even on WebGPU). Default is false
       */
      constructor(name, scene, forceGLSL = false) {
        this._vertexBuffers = {};
        this._maxSize = 0;
        this._mainTextureDesiredSize = { width: 0, height: 0 };
        this._shouldRender = true;
        this._postProcesses = [];
        this._textures = [];
        this._emissiveTextureAndColor = { texture: null, color: new Color4() };
        this._effectIntensity = {};
        this.neutralColor = new Color4();
        this.isEnabled = true;
        this.disableBoundingBoxesFromEffectLayer = false;
        this.onDisposeObservable = new Observable();
        this.onBeforeRenderMainTextureObservable = new Observable();
        this.onBeforeComposeObservable = new Observable();
        this.onBeforeRenderMeshToEffect = new Observable();
        this.onAfterRenderMeshToEffect = new Observable();
        this.onAfterComposeObservable = new Observable();
        this.onSizeChangedObservable = new Observable();
        this._shaderLanguage = 0;
        this._materialForRendering = {};
        this._shadersLoaded = false;
        this.name = name;
        this._scene = scene || EngineStore.LastCreatedScene;
        _EffectLayer._SceneComponentInitialization(this._scene);
        const engine = this._scene.getEngine();
        if (engine.isWebGPU && !forceGLSL && !_EffectLayer.ForceGLSL) {
          this._shaderLanguage = 1;
        }
        this._engine = this._scene.getEngine();
        this._maxSize = this._engine.getCaps().maxTextureSize;
        this._scene.effectLayers.push(this);
        this._mergeDrawWrapper = [];
        this._generateIndexBuffer();
        this._generateVertexBuffer();
      }
      /**
       * Number of times _internalRender will be called. Some effect layers need to render the mesh several times, so they should override this method with the number of times the mesh should be rendered
       * @returns Number of times a mesh must be rendered in the layer
       */
      _numInternalDraws() {
        return 1;
      }
      /**
       * Initializes the effect layer with the required options.
       * @param options Sets of none mandatory options to use with the layer (see IEffectLayerOptions for more information)
       */
      _init(options) {
        this._effectLayerOptions = __spreadValues({
          mainTextureRatio: 0.5,
          alphaBlendingMode: 2,
          camera: null,
          renderingGroupId: -1,
          mainTextureType: 0,
          generateStencilBuffer: false
        }, options);
        this._setMainTextureSize();
        this._createMainTexture();
        this._createTextureAndPostProcesses();
      }
      /**
       * Generates the index buffer of the full screen quad blending to the main canvas.
       */
      _generateIndexBuffer() {
        const indices = [];
        indices.push(0);
        indices.push(1);
        indices.push(2);
        indices.push(0);
        indices.push(2);
        indices.push(3);
        this._indexBuffer = this._engine.createIndexBuffer(indices);
      }
      /**
       * Generates the vertex buffer of the full screen quad blending to the main canvas.
       */
      _generateVertexBuffer() {
        const vertices = [];
        vertices.push(1, 1);
        vertices.push(-1, 1);
        vertices.push(-1, -1);
        vertices.push(1, -1);
        const vertexBuffer = new VertexBuffer(this._engine, vertices, VertexBuffer.PositionKind, false, false, 2);
        this._vertexBuffers[VertexBuffer.PositionKind] = vertexBuffer;
      }
      /**
       * Sets the main texture desired size which is the closest power of two
       * of the engine canvas size.
       */
      _setMainTextureSize() {
        if (this._effectLayerOptions.mainTextureFixedSize) {
          this._mainTextureDesiredSize.width = this._effectLayerOptions.mainTextureFixedSize;
          this._mainTextureDesiredSize.height = this._effectLayerOptions.mainTextureFixedSize;
        } else {
          this._mainTextureDesiredSize.width = this._engine.getRenderWidth() * this._effectLayerOptions.mainTextureRatio;
          this._mainTextureDesiredSize.height = this._engine.getRenderHeight() * this._effectLayerOptions.mainTextureRatio;
          this._mainTextureDesiredSize.width = this._engine.needPOTTextures ? GetExponentOfTwo(this._mainTextureDesiredSize.width, this._maxSize) : this._mainTextureDesiredSize.width;
          this._mainTextureDesiredSize.height = this._engine.needPOTTextures ? GetExponentOfTwo(this._mainTextureDesiredSize.height, this._maxSize) : this._mainTextureDesiredSize.height;
        }
        this._mainTextureDesiredSize.width = Math.floor(this._mainTextureDesiredSize.width);
        this._mainTextureDesiredSize.height = Math.floor(this._mainTextureDesiredSize.height);
      }
      /**
       * Creates the main texture for the effect layer.
       */
      _createMainTexture() {
        this._mainTexture = new RenderTargetTexture("EffectLayerMainRTT", {
          width: this._mainTextureDesiredSize.width,
          height: this._mainTextureDesiredSize.height
        }, this._scene, false, true, this._effectLayerOptions.mainTextureType, false, Texture.TRILINEAR_SAMPLINGMODE, true, this._effectLayerOptions.generateStencilBuffer);
        this._mainTexture.activeCamera = this._effectLayerOptions.camera;
        this._mainTexture.wrapU = Texture.CLAMP_ADDRESSMODE;
        this._mainTexture.wrapV = Texture.CLAMP_ADDRESSMODE;
        this._mainTexture.anisotropicFilteringLevel = 1;
        this._mainTexture.updateSamplingMode(Texture.BILINEAR_SAMPLINGMODE);
        this._mainTexture.renderParticles = false;
        this._mainTexture.renderList = null;
        this._mainTexture.ignoreCameraViewport = true;
        for (const id in this._materialForRendering) {
          const [mesh, material] = this._materialForRendering[id];
          this._mainTexture.setMaterialForRendering(mesh, material);
        }
        this._mainTexture.customIsReadyFunction = (mesh, refreshRate, preWarm) => {
          if ((preWarm || refreshRate === 0) && mesh.subMeshes) {
            for (let i = 0; i < mesh.subMeshes.length; ++i) {
              const subMesh = mesh.subMeshes[i];
              const material = subMesh.getMaterial();
              const renderingMesh = subMesh.getRenderingMesh();
              if (!material) {
                continue;
              }
              const batch = renderingMesh._getInstancesRenderList(subMesh._id, !!subMesh.getReplacementMesh());
              const hardwareInstancedRendering = batch.hardwareInstancedRendering[subMesh._id] || renderingMesh.hasThinInstances;
              this._setEmissiveTextureAndColor(renderingMesh, subMesh, material);
              if (!this._isReady(subMesh, hardwareInstancedRendering, this._emissiveTextureAndColor.texture)) {
                return false;
              }
            }
          }
          return true;
        };
        this._mainTexture.customRenderFunction = (opaqueSubMeshes, alphaTestSubMeshes, transparentSubMeshes, depthOnlySubMeshes) => {
          this.onBeforeRenderMainTextureObservable.notifyObservers(this);
          let index;
          const engine = this._scene.getEngine();
          if (depthOnlySubMeshes.length) {
            engine.setColorWrite(false);
            for (index = 0; index < depthOnlySubMeshes.length; index++) {
              this._renderSubMesh(depthOnlySubMeshes.data[index]);
            }
            engine.setColorWrite(true);
          }
          for (index = 0; index < opaqueSubMeshes.length; index++) {
            this._renderSubMesh(opaqueSubMeshes.data[index]);
          }
          for (index = 0; index < alphaTestSubMeshes.length; index++) {
            this._renderSubMesh(alphaTestSubMeshes.data[index]);
          }
          const previousAlphaMode = engine.getAlphaMode();
          for (index = 0; index < transparentSubMeshes.length; index++) {
            const subMesh = transparentSubMeshes.data[index];
            const material = subMesh.getMaterial();
            if (material && material.needDepthPrePass) {
              const engine2 = material.getScene().getEngine();
              engine2.setColorWrite(false);
              this._renderSubMesh(subMesh);
              engine2.setColorWrite(true);
            }
            this._renderSubMesh(subMesh, true);
          }
          engine.setAlphaMode(previousAlphaMode);
        };
        this._mainTexture.onClearObservable.add((engine) => {
          engine.clear(this.neutralColor, true, true, true);
        });
        if (this._scene.getBoundingBoxRenderer) {
          const boundingBoxRendererEnabled = this._scene.getBoundingBoxRenderer().enabled;
          this._mainTexture.onBeforeBindObservable.add(() => {
            this._scene.getBoundingBoxRenderer().enabled = !this.disableBoundingBoxesFromEffectLayer && boundingBoxRendererEnabled;
          });
          this._mainTexture.onAfterUnbindObservable.add(() => {
            this._scene.getBoundingBoxRenderer().enabled = boundingBoxRendererEnabled;
          });
        }
      }
      /**
       * Adds specific effects defines.
       * @param defines The defines to add specifics to.
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      _addCustomEffectDefines(defines) {
      }
      /**
       * Checks for the readiness of the element composing the layer.
       * @param subMesh the mesh to check for
       * @param useInstances specify whether or not to use instances to render the mesh
       * @param emissiveTexture the associated emissive texture used to generate the glow
       * @returns true if ready otherwise, false
       */
      _isReady(subMesh, useInstances, emissiveTexture) {
        var _a;
        const engine = this._scene.getEngine();
        const mesh = subMesh.getMesh();
        const renderingMaterial = (_a = mesh._internalAbstractMeshDataInfo._materialForRenderPass) == null ? void 0 : _a[engine.currentRenderPassId];
        if (renderingMaterial) {
          return renderingMaterial.isReadyForSubMesh(mesh, subMesh, useInstances);
        }
        const material = subMesh.getMaterial();
        if (!material) {
          return false;
        }
        if (this._useMeshMaterial(subMesh.getRenderingMesh())) {
          return material.isReadyForSubMesh(subMesh.getMesh(), subMesh, useInstances);
        }
        const defines = [];
        const attribs = [VertexBuffer.PositionKind];
        let uv1 = false;
        let uv2 = false;
        if (material) {
          const needAlphaTest = material.needAlphaTesting();
          const diffuseTexture = material.getAlphaTestTexture();
          const needAlphaBlendFromDiffuse = diffuseTexture && diffuseTexture.hasAlpha && (material.useAlphaFromDiffuseTexture || material._useAlphaFromAlbedoTexture);
          if (diffuseTexture && (needAlphaTest || needAlphaBlendFromDiffuse)) {
            defines.push("#define DIFFUSE");
            if (mesh.isVerticesDataPresent(VertexBuffer.UV2Kind) && diffuseTexture.coordinatesIndex === 1) {
              defines.push("#define DIFFUSEUV2");
              uv2 = true;
            } else if (mesh.isVerticesDataPresent(VertexBuffer.UVKind)) {
              defines.push("#define DIFFUSEUV1");
              uv1 = true;
            }
            if (needAlphaTest) {
              defines.push("#define ALPHATEST");
              defines.push("#define ALPHATESTVALUE 0.4");
            }
            if (!diffuseTexture.gammaSpace) {
              defines.push("#define DIFFUSE_ISLINEAR");
            }
          }
          const opacityTexture = material.opacityTexture;
          if (opacityTexture) {
            defines.push("#define OPACITY");
            if (mesh.isVerticesDataPresent(VertexBuffer.UV2Kind) && opacityTexture.coordinatesIndex === 1) {
              defines.push("#define OPACITYUV2");
              uv2 = true;
            } else if (mesh.isVerticesDataPresent(VertexBuffer.UVKind)) {
              defines.push("#define OPACITYUV1");
              uv1 = true;
            }
          }
        }
        if (emissiveTexture) {
          defines.push("#define EMISSIVE");
          if (mesh.isVerticesDataPresent(VertexBuffer.UV2Kind) && emissiveTexture.coordinatesIndex === 1) {
            defines.push("#define EMISSIVEUV2");
            uv2 = true;
          } else if (mesh.isVerticesDataPresent(VertexBuffer.UVKind)) {
            defines.push("#define EMISSIVEUV1");
            uv1 = true;
          }
          if (!emissiveTexture.gammaSpace) {
            defines.push("#define EMISSIVE_ISLINEAR");
          }
        }
        if (mesh.useVertexColors && mesh.isVerticesDataPresent(VertexBuffer.ColorKind) && mesh.hasVertexAlpha && material.transparencyMode !== Material.MATERIAL_OPAQUE) {
          attribs.push(VertexBuffer.ColorKind);
          defines.push("#define VERTEXALPHA");
        }
        if (uv1) {
          attribs.push(VertexBuffer.UVKind);
          defines.push("#define UV1");
        }
        if (uv2) {
          attribs.push(VertexBuffer.UV2Kind);
          defines.push("#define UV2");
        }
        const fallbacks = new EffectFallbacks();
        if (mesh.useBones && mesh.computeBonesUsingShaders) {
          attribs.push(VertexBuffer.MatricesIndicesKind);
          attribs.push(VertexBuffer.MatricesWeightsKind);
          if (mesh.numBoneInfluencers > 4) {
            attribs.push(VertexBuffer.MatricesIndicesExtraKind);
            attribs.push(VertexBuffer.MatricesWeightsExtraKind);
          }
          defines.push("#define NUM_BONE_INFLUENCERS " + mesh.numBoneInfluencers);
          const skeleton = mesh.skeleton;
          if (skeleton && skeleton.isUsingTextureForMatrices) {
            defines.push("#define BONETEXTURE");
          } else {
            defines.push("#define BonesPerMesh " + (skeleton ? skeleton.bones.length + 1 : 0));
          }
          if (mesh.numBoneInfluencers > 0) {
            fallbacks.addCPUSkinningFallback(0, mesh);
          }
        } else {
          defines.push("#define NUM_BONE_INFLUENCERS 0");
        }
        const manager = mesh.morphTargetManager;
        let morphInfluencers = 0;
        if (manager) {
          morphInfluencers = manager.numMaxInfluencers || manager.numInfluencers;
          if (morphInfluencers > 0) {
            defines.push("#define MORPHTARGETS");
            defines.push("#define NUM_MORPH_INFLUENCERS " + morphInfluencers);
            if (manager.isUsingTextureForTargets) {
              defines.push("#define MORPHTARGETS_TEXTURE");
            }
            PrepareAttributesForMorphTargetsInfluencers(attribs, mesh, morphInfluencers);
          }
        }
        if (useInstances) {
          defines.push("#define INSTANCES");
          PushAttributesForInstances(attribs);
          if (subMesh.getRenderingMesh().hasThinInstances) {
            defines.push("#define THIN_INSTANCES");
          }
        }
        prepareStringDefinesForClipPlanes(material, this._scene, defines);
        this._addCustomEffectDefines(defines);
        const drawWrapper = subMesh._getDrawWrapper(void 0, true);
        const cachedDefines = drawWrapper.defines;
        const join = defines.join("\n");
        if (cachedDefines !== join) {
          const uniforms = [
            "world",
            "mBones",
            "viewProjection",
            "glowColor",
            "morphTargetInfluences",
            "morphTargetCount",
            "boneTextureWidth",
            "diffuseMatrix",
            "emissiveMatrix",
            "opacityMatrix",
            "opacityIntensity",
            "morphTargetTextureInfo",
            "morphTargetTextureIndices",
            "glowIntensity"
          ];
          addClipPlaneUniforms(uniforms);
          drawWrapper.setEffect(this._engine.createEffect("glowMapGeneration", attribs, uniforms, ["diffuseSampler", "emissiveSampler", "opacitySampler", "boneSampler", "morphTargets"], join, fallbacks, void 0, void 0, { maxSimultaneousMorphTargets: morphInfluencers }, this._shaderLanguage, this._shadersLoaded ? void 0 : () => __async(this, null, function* () {
            yield this._importShadersAsync();
            this._shadersLoaded = true;
          })), join);
        }
        return drawWrapper.effect.isReady();
      }
      _importShadersAsync() {
        return __async(this, null, function* () {
          if (this._shaderLanguage === 1) {
            yield Promise.all([import("./glowMapGeneration.vertex-REXHGWIP.mjs"), import("./glowMapGeneration.fragment-3BGDXRSV.mjs")]);
          } else {
            yield Promise.all([import("./glowMapGeneration.vertex-ZX3Q2DQE.mjs"), import("./glowMapGeneration.fragment-BMK2C62W.mjs")]);
          }
        });
      }
      /**
       * Renders the glowing part of the scene by blending the blurred glowing meshes on top of the rendered scene.
       */
      render() {
        for (let i = 0; i < this._postProcesses.length; i++) {
          if (!this._postProcesses[i].isReady()) {
            return;
          }
        }
        const engine = this._scene.getEngine();
        const numDraws = this._numInternalDraws();
        let isReady = true;
        for (let i = 0; i < numDraws; ++i) {
          let currentEffect = this._mergeDrawWrapper[i];
          if (!currentEffect) {
            currentEffect = this._mergeDrawWrapper[i] = new DrawWrapper(this._engine);
            currentEffect.setEffect(this._createMergeEffect());
          }
          isReady = isReady && currentEffect.effect.isReady();
        }
        if (!isReady) {
          return;
        }
        this.onBeforeComposeObservable.notifyObservers(this);
        const previousAlphaMode = engine.getAlphaMode();
        for (let i = 0; i < numDraws; ++i) {
          const currentEffect = this._mergeDrawWrapper[i];
          engine.enableEffect(currentEffect);
          engine.setState(false);
          engine.bindBuffers(this._vertexBuffers, this._indexBuffer, currentEffect.effect);
          engine.setAlphaMode(this._effectLayerOptions.alphaBlendingMode);
          this._internalRender(currentEffect.effect, i);
        }
        engine.setAlphaMode(previousAlphaMode);
        this.onAfterComposeObservable.notifyObservers(this);
        const size = this._mainTexture.getSize();
        this._setMainTextureSize();
        if ((size.width !== this._mainTextureDesiredSize.width || size.height !== this._mainTextureDesiredSize.height) && this._mainTextureDesiredSize.width !== 0 && this._mainTextureDesiredSize.height !== 0) {
          this.onSizeChangedObservable.notifyObservers(this);
          this._disposeTextureAndPostProcesses();
          this._createMainTexture();
          this._createTextureAndPostProcesses();
        }
      }
      /**
       * Determine if a given mesh will be used in the current effect.
       * @param mesh mesh to test
       * @returns true if the mesh will be used
       */
      hasMesh(mesh) {
        if (this.renderingGroupId === -1 || mesh.renderingGroupId === this.renderingGroupId) {
          return true;
        }
        return false;
      }
      /**
       * Returns true if the layer contains information to display, otherwise false.
       * @returns true if the glow layer should be rendered
       */
      shouldRender() {
        return this.isEnabled && this._shouldRender;
      }
      /**
       * Returns true if the mesh should render, otherwise false.
       * @param mesh The mesh to render
       * @returns true if it should render otherwise false
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      _shouldRenderMesh(mesh) {
        return true;
      }
      /**
       * Returns true if the mesh can be rendered, otherwise false.
       * @param mesh The mesh to render
       * @param material The material used on the mesh
       * @returns true if it can be rendered otherwise false
       */
      _canRenderMesh(mesh, material) {
        return !material.needAlphaBlendingForMesh(mesh);
      }
      /**
       * Returns true if the mesh should render, otherwise false.
       * @returns true if it should render otherwise false
       */
      _shouldRenderEmissiveTextureForMesh() {
        return true;
      }
      /**
       * Renders the submesh passed in parameter to the generation map.
       * @param subMesh
       * @param enableAlphaMode
       */
      _renderSubMesh(subMesh, enableAlphaMode = false) {
        var _a;
        if (!this.shouldRender()) {
          return;
        }
        const material = subMesh.getMaterial();
        const ownerMesh = subMesh.getMesh();
        const replacementMesh = subMesh.getReplacementMesh();
        const renderingMesh = subMesh.getRenderingMesh();
        const effectiveMesh = subMesh.getEffectiveMesh();
        const scene = this._scene;
        const engine = scene.getEngine();
        effectiveMesh._internalAbstractMeshDataInfo._isActiveIntermediate = false;
        if (!material) {
          return;
        }
        if (!this._canRenderMesh(renderingMesh, material)) {
          return;
        }
        let sideOrientation = material._getEffectiveOrientation(renderingMesh);
        const mainDeterminant = effectiveMesh._getWorldMatrixDeterminant();
        if (mainDeterminant < 0) {
          sideOrientation = sideOrientation === Material.ClockWiseSideOrientation ? Material.CounterClockWiseSideOrientation : Material.ClockWiseSideOrientation;
        }
        const reverse = sideOrientation === Material.ClockWiseSideOrientation;
        engine.setState(material.backFaceCulling, material.zOffset, void 0, reverse, material.cullBackFaces, void 0, material.zOffsetUnits);
        const batch = renderingMesh._getInstancesRenderList(subMesh._id, !!replacementMesh);
        if (batch.mustReturn) {
          return;
        }
        if (!this._shouldRenderMesh(renderingMesh)) {
          return;
        }
        const hardwareInstancedRendering = batch.hardwareInstancedRendering[subMesh._id] || renderingMesh.hasThinInstances;
        this._setEmissiveTextureAndColor(renderingMesh, subMesh, material);
        this.onBeforeRenderMeshToEffect.notifyObservers(ownerMesh);
        if (this._useMeshMaterial(renderingMesh)) {
          renderingMesh.render(subMesh, enableAlphaMode, replacementMesh || void 0);
        } else if (this._isReady(subMesh, hardwareInstancedRendering, this._emissiveTextureAndColor.texture)) {
          const renderingMaterial = (_a = effectiveMesh._internalAbstractMeshDataInfo._materialForRenderPass) == null ? void 0 : _a[engine.currentRenderPassId];
          let drawWrapper = subMesh._getDrawWrapper();
          if (!drawWrapper && renderingMaterial) {
            drawWrapper = renderingMaterial._getDrawWrapper();
          }
          if (!drawWrapper) {
            return;
          }
          const effect = drawWrapper.effect;
          engine.enableEffect(drawWrapper);
          if (!hardwareInstancedRendering) {
            renderingMesh._bind(subMesh, effect, material.fillMode);
          }
          if (!renderingMaterial) {
            effect.setMatrix("viewProjection", scene.getTransformMatrix());
            effect.setMatrix("world", effectiveMesh.getWorldMatrix());
            effect.setFloat4("glowColor", this._emissiveTextureAndColor.color.r, this._emissiveTextureAndColor.color.g, this._emissiveTextureAndColor.color.b, this._emissiveTextureAndColor.color.a);
          } else {
            renderingMaterial.bindForSubMesh(effectiveMesh.getWorldMatrix(), effectiveMesh, subMesh);
          }
          if (!renderingMaterial) {
            const needAlphaTest = material.needAlphaTesting();
            const diffuseTexture = material.getAlphaTestTexture();
            const needAlphaBlendFromDiffuse = diffuseTexture && diffuseTexture.hasAlpha && (material.useAlphaFromDiffuseTexture || material._useAlphaFromAlbedoTexture);
            if (diffuseTexture && (needAlphaTest || needAlphaBlendFromDiffuse)) {
              effect.setTexture("diffuseSampler", diffuseTexture);
              const textureMatrix = diffuseTexture.getTextureMatrix();
              if (textureMatrix) {
                effect.setMatrix("diffuseMatrix", textureMatrix);
              }
            }
            const opacityTexture = material.opacityTexture;
            if (opacityTexture) {
              effect.setTexture("opacitySampler", opacityTexture);
              effect.setFloat("opacityIntensity", opacityTexture.level);
              const textureMatrix = opacityTexture.getTextureMatrix();
              if (textureMatrix) {
                effect.setMatrix("opacityMatrix", textureMatrix);
              }
            }
            if (this._emissiveTextureAndColor.texture) {
              effect.setTexture("emissiveSampler", this._emissiveTextureAndColor.texture);
              effect.setMatrix("emissiveMatrix", this._emissiveTextureAndColor.texture.getTextureMatrix());
            }
            if (renderingMesh.useBones && renderingMesh.computeBonesUsingShaders && renderingMesh.skeleton) {
              const skeleton = renderingMesh.skeleton;
              if (skeleton.isUsingTextureForMatrices) {
                const boneTexture = skeleton.getTransformMatrixTexture(renderingMesh);
                if (!boneTexture) {
                  return;
                }
                effect.setTexture("boneSampler", boneTexture);
                effect.setFloat("boneTextureWidth", 4 * (skeleton.bones.length + 1));
              } else {
                effect.setMatrices("mBones", skeleton.getTransformMatrices(renderingMesh));
              }
            }
            BindMorphTargetParameters(renderingMesh, effect);
            if (renderingMesh.morphTargetManager && renderingMesh.morphTargetManager.isUsingTextureForTargets) {
              renderingMesh.morphTargetManager._bind(effect);
            }
            if (enableAlphaMode) {
              engine.setAlphaMode(material.alphaMode);
            }
            effect.setFloat("glowIntensity", this.getEffectIntensity(renderingMesh));
            bindClipPlane(effect, material, scene);
          }
          renderingMesh._processRendering(effectiveMesh, subMesh, effect, material.fillMode, batch, hardwareInstancedRendering, (isInstance, world) => effect.setMatrix("world", world));
        } else {
          this._mainTexture.resetRefreshCounter();
        }
        this.onAfterRenderMeshToEffect.notifyObservers(ownerMesh);
      }
      /**
       * Defines whether the current material of the mesh should be use to render the effect.
       * @param mesh defines the current mesh to render
       * @returns true if the mesh material should be use
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      _useMeshMaterial(mesh) {
        return false;
      }
      /**
       * Rebuild the required buffers.
       * @internal Internal use only.
       */
      _rebuild() {
        const vb = this._vertexBuffers[VertexBuffer.PositionKind];
        if (vb) {
          vb._rebuild();
        }
        this._generateIndexBuffer();
      }
      /**
       * Dispose only the render target textures and post process.
       */
      _disposeTextureAndPostProcesses() {
        this._mainTexture.dispose();
        for (let i = 0; i < this._postProcesses.length; i++) {
          if (this._postProcesses[i]) {
            this._postProcesses[i].dispose();
          }
        }
        this._postProcesses = [];
        for (let i = 0; i < this._textures.length; i++) {
          if (this._textures[i]) {
            this._textures[i].dispose();
          }
        }
        this._textures = [];
      }
      /**
       * Dispose the highlight layer and free resources.
       */
      dispose() {
        const vertexBuffer = this._vertexBuffers[VertexBuffer.PositionKind];
        if (vertexBuffer) {
          vertexBuffer.dispose();
          this._vertexBuffers[VertexBuffer.PositionKind] = null;
        }
        if (this._indexBuffer) {
          this._scene.getEngine()._releaseBuffer(this._indexBuffer);
          this._indexBuffer = null;
        }
        for (const drawWrapper of this._mergeDrawWrapper) {
          drawWrapper.dispose();
        }
        this._mergeDrawWrapper = [];
        this._disposeTextureAndPostProcesses();
        const index = this._scene.effectLayers.indexOf(this, 0);
        if (index > -1) {
          this._scene.effectLayers.splice(index, 1);
        }
        this.onDisposeObservable.notifyObservers(this);
        this.onDisposeObservable.clear();
        this.onBeforeRenderMainTextureObservable.clear();
        this.onBeforeComposeObservable.clear();
        this.onBeforeRenderMeshToEffect.clear();
        this.onAfterRenderMeshToEffect.clear();
        this.onAfterComposeObservable.clear();
        this.onSizeChangedObservable.clear();
      }
      /**
       * Gets the class name of the effect layer
       * @returns the string with the class name of the effect layer
       */
      getClassName() {
        return "EffectLayer";
      }
      /**
       * Creates an effect layer from parsed effect layer data
       * @param parsedEffectLayer defines effect layer data
       * @param scene defines the current scene
       * @param rootUrl defines the root URL containing the effect layer information
       * @returns a parsed effect Layer
       */
      static Parse(parsedEffectLayer, scene, rootUrl) {
        const effectLayerType = Tools.Instantiate(parsedEffectLayer.customType);
        return effectLayerType.Parse(parsedEffectLayer, scene, rootUrl);
      }
    };
    EffectLayer.ForceGLSL = false;
    EffectLayer._SceneComponentInitialization = (_) => {
      throw _WarnImport("EffectLayerSceneComponent");
    };
    __decorate([
      serialize()
    ], EffectLayer.prototype, "name", void 0);
    __decorate([
      serializeAsColor4()
    ], EffectLayer.prototype, "neutralColor", void 0);
    __decorate([
      serialize()
    ], EffectLayer.prototype, "isEnabled", void 0);
    __decorate([
      serializeAsCameraReference()
    ], EffectLayer.prototype, "camera", null);
    __decorate([
      serialize()
    ], EffectLayer.prototype, "renderingGroupId", null);
    __decorate([
      serialize()
    ], EffectLayer.prototype, "disableBoundingBoxesFromEffectLayer", void 0);
  }
});

// node_modules/@babylonjs/core/Layers/effectLayerSceneComponent.js
var EffectLayerSceneComponent;
var init_effectLayerSceneComponent = __esm({
  "node_modules/@babylonjs/core/Layers/effectLayerSceneComponent.js"() {
    "use strict";
    init_camera();
    init_sceneComponent();
    init_effectLayer();
    init_abstractScene();
    init_engineStore();
    AbstractScene.AddParser(SceneComponentConstants.NAME_EFFECTLAYER, (parsedData, scene, container, rootUrl) => {
      if (parsedData.effectLayers) {
        if (!container.effectLayers) {
          container.effectLayers = [];
        }
        for (let index = 0; index < parsedData.effectLayers.length; index++) {
          const effectLayer = EffectLayer.Parse(parsedData.effectLayers[index], scene, rootUrl);
          container.effectLayers.push(effectLayer);
        }
      }
    });
    AbstractScene.prototype.removeEffectLayer = function(toRemove) {
      const index = this.effectLayers.indexOf(toRemove);
      if (index !== -1) {
        this.effectLayers.splice(index, 1);
      }
      return index;
    };
    AbstractScene.prototype.addEffectLayer = function(newEffectLayer) {
      this.effectLayers.push(newEffectLayer);
    };
    EffectLayerSceneComponent = class {
      /**
       * Creates a new instance of the component for the given scene
       * @param scene Defines the scene to register the component in
       */
      constructor(scene) {
        this.name = SceneComponentConstants.NAME_EFFECTLAYER;
        this._renderEffects = false;
        this._needStencil = false;
        this._previousStencilState = false;
        this.scene = scene || EngineStore.LastCreatedScene;
        if (!this.scene) {
          return;
        }
        this._engine = this.scene.getEngine();
        this.scene.effectLayers = [];
      }
      /**
       * Registers the component in a given scene
       */
      register() {
        this.scene._isReadyForMeshStage.registerStep(SceneComponentConstants.STEP_ISREADYFORMESH_EFFECTLAYER, this, this._isReadyForMesh);
        this.scene._cameraDrawRenderTargetStage.registerStep(SceneComponentConstants.STEP_CAMERADRAWRENDERTARGET_EFFECTLAYER, this, this._renderMainTexture);
        this.scene._beforeCameraDrawStage.registerStep(SceneComponentConstants.STEP_BEFORECAMERADRAW_EFFECTLAYER, this, this._setStencil);
        this.scene._afterRenderingGroupDrawStage.registerStep(SceneComponentConstants.STEP_AFTERRENDERINGGROUPDRAW_EFFECTLAYER_DRAW, this, this._drawRenderingGroup);
        this.scene._afterCameraDrawStage.registerStep(SceneComponentConstants.STEP_AFTERCAMERADRAW_EFFECTLAYER, this, this._setStencilBack);
        this.scene._afterCameraDrawStage.registerStep(SceneComponentConstants.STEP_AFTERCAMERADRAW_EFFECTLAYER_DRAW, this, this._drawCamera);
      }
      /**
       * Rebuilds the elements related to this component in case of
       * context lost for instance.
       */
      rebuild() {
        const layers = this.scene.effectLayers;
        for (const effectLayer of layers) {
          effectLayer._rebuild();
        }
      }
      /**
       * Serializes the component data to the specified json object
       * @param serializationObject The object to serialize to
       */
      serialize(serializationObject) {
        serializationObject.effectLayers = [];
        const layers = this.scene.effectLayers;
        for (const effectLayer of layers) {
          if (effectLayer.serialize) {
            serializationObject.effectLayers.push(effectLayer.serialize());
          }
        }
      }
      /**
       * Adds all the elements from the container to the scene
       * @param container the container holding the elements
       */
      addFromContainer(container) {
        if (!container.effectLayers) {
          return;
        }
        container.effectLayers.forEach((o) => {
          this.scene.addEffectLayer(o);
        });
      }
      /**
       * Removes all the elements in the container from the scene
       * @param container contains the elements to remove
       * @param dispose if the removed element should be disposed (default: false)
       */
      removeFromContainer(container, dispose) {
        if (!container.effectLayers) {
          return;
        }
        container.effectLayers.forEach((o) => {
          this.scene.removeEffectLayer(o);
          if (dispose) {
            o.dispose();
          }
        });
      }
      /**
       * Disposes the component and the associated resources.
       */
      dispose() {
        const layers = this.scene.effectLayers;
        while (layers.length) {
          layers[0].dispose();
        }
      }
      _isReadyForMesh(mesh, hardwareInstancedRendering) {
        const currentRenderPassId = this._engine.currentRenderPassId;
        const layers = this.scene.effectLayers;
        for (const layer of layers) {
          if (!layer.hasMesh(mesh)) {
            continue;
          }
          const renderTarget = layer._mainTexture;
          this._engine.currentRenderPassId = renderTarget.renderPassId;
          for (const subMesh of mesh.subMeshes) {
            if (!layer.isReady(subMesh, hardwareInstancedRendering)) {
              this._engine.currentRenderPassId = currentRenderPassId;
              return false;
            }
          }
        }
        this._engine.currentRenderPassId = currentRenderPassId;
        return true;
      }
      _renderMainTexture(camera) {
        this._renderEffects = false;
        this._needStencil = false;
        let needRebind = false;
        const layers = this.scene.effectLayers;
        if (layers && layers.length > 0) {
          this._previousStencilState = this._engine.getStencilBuffer();
          for (const effectLayer of layers) {
            if (effectLayer.shouldRender() && (!effectLayer.camera || effectLayer.camera.cameraRigMode === Camera.RIG_MODE_NONE && camera === effectLayer.camera || effectLayer.camera.cameraRigMode !== Camera.RIG_MODE_NONE && effectLayer.camera._rigCameras.indexOf(camera) > -1)) {
              this._renderEffects = true;
              this._needStencil = this._needStencil || effectLayer.needStencil();
              const renderTarget = effectLayer._mainTexture;
              if (renderTarget._shouldRender()) {
                this.scene.incrementRenderId();
                renderTarget.render(false, false);
                needRebind = true;
              }
            }
          }
          this.scene.incrementRenderId();
        }
        return needRebind;
      }
      _setStencil() {
        if (this._needStencil) {
          this._engine.setStencilBuffer(true);
        }
      }
      _setStencilBack() {
        if (this._needStencil) {
          this._engine.setStencilBuffer(this._previousStencilState);
        }
      }
      _draw(renderingGroupId) {
        if (this._renderEffects) {
          this._engine.setDepthBuffer(false);
          const layers = this.scene.effectLayers;
          for (let i = 0; i < layers.length; i++) {
            const effectLayer = layers[i];
            if (effectLayer.renderingGroupId === renderingGroupId) {
              if (effectLayer.shouldRender()) {
                effectLayer.render();
              }
            }
          }
          this._engine.setDepthBuffer(true);
        }
      }
      _drawCamera() {
        if (this._renderEffects) {
          this._draw(-1);
        }
      }
      _drawRenderingGroup(index) {
        if (!this.scene._isInIntermediateRendering() && this._renderEffects) {
          this._draw(index);
        }
      }
    };
    EffectLayer._SceneComponentInitialization = (scene) => {
      let component = scene._getComponent(SceneComponentConstants.NAME_EFFECTLAYER);
      if (!component) {
        component = new EffectLayerSceneComponent(scene);
        scene._addComponent(component);
      }
    };
  }
});

// node_modules/@babylonjs/core/Layers/glowLayer.js
var GlowLayer;
var init_glowLayer = __esm({
  "node_modules/@babylonjs/core/Layers/glowLayer.js"() {
    "use strict";
    init_tslib_es6();
    init_decorators();
    init_math_vector();
    init_buffer();
    init_texture();
    init_renderTargetTexture();
    init_material();
    init_blurPostProcess();
    init_effectLayer();
    init_abstractScene();
    init_typeStore();
    init_math_color();
    init_effectLayerSceneComponent();
    init_decorators_serialization();
    init_tools_functions();
    AbstractScene.prototype.getGlowLayerByName = function(name) {
      var _a;
      for (let index = 0; index < ((_a = this.effectLayers) == null ? void 0 : _a.length); index++) {
        if (this.effectLayers[index].name === name && this.effectLayers[index].getEffectName() === GlowLayer.EffectName) {
          return this.effectLayers[index];
        }
      }
      return null;
    };
    GlowLayer = class _GlowLayer extends EffectLayer {
      /**
       * Sets the kernel size of the blur.
       */
      set blurKernelSize(value) {
        if (value === this._options.blurKernelSize) {
          return;
        }
        this._options.blurKernelSize = value;
        const effectiveKernel = this._getEffectiveBlurKernelSize();
        this._horizontalBlurPostprocess1.kernel = effectiveKernel;
        this._verticalBlurPostprocess1.kernel = effectiveKernel;
        this._horizontalBlurPostprocess2.kernel = effectiveKernel;
        this._verticalBlurPostprocess2.kernel = effectiveKernel;
      }
      /**
       * Gets the kernel size of the blur.
       */
      get blurKernelSize() {
        return this._options.blurKernelSize;
      }
      /**
       * Sets the glow intensity.
       */
      set intensity(value) {
        this._intensity = value;
      }
      /**
       * Gets the glow intensity.
       */
      get intensity() {
        return this._intensity;
      }
      /**
       * Instantiates a new glow Layer and references it to the scene.
       * @param name The name of the layer
       * @param scene The scene to use the layer in
       * @param options Sets of none mandatory options to use with the layer (see IGlowLayerOptions for more information)
       */
      constructor(name, scene, options) {
        super(name, scene);
        this._intensity = 1;
        this._includedOnlyMeshes = [];
        this._excludedMeshes = [];
        this._meshesUsingTheirOwnMaterials = [];
        this.neutralColor = new Color4(0, 0, 0, 1);
        this._options = __spreadValues({
          mainTextureRatio: _GlowLayer.DefaultTextureRatio,
          blurKernelSize: 32,
          mainTextureFixedSize: void 0,
          camera: null,
          mainTextureSamples: 1,
          renderingGroupId: -1,
          ldrMerge: false,
          alphaBlendingMode: 1,
          mainTextureType: 0,
          generateStencilBuffer: false
        }, options);
        this._init({
          alphaBlendingMode: this._options.alphaBlendingMode,
          camera: this._options.camera,
          mainTextureFixedSize: this._options.mainTextureFixedSize,
          mainTextureRatio: this._options.mainTextureRatio,
          renderingGroupId: this._options.renderingGroupId,
          mainTextureType: this._options.mainTextureType,
          generateStencilBuffer: this._options.generateStencilBuffer
        });
      }
      _importShadersAsync() {
        return __async(this, null, function* () {
          if (this._shaderLanguage === 1) {
            yield Promise.all([
              import("./glowMapMerge.fragment-DGB4TA2R.mjs"),
              import("./glowMapMerge.vertex-GMASIWOR.mjs"),
              import("./glowBlurPostProcess.fragment-3VISBCSB.mjs")
            ]);
          } else {
            yield Promise.all([import("./glowMapMerge.fragment-6D6L2C7X.mjs"), import("./glowMapMerge.vertex-CVAJ7XYR.mjs"), import("./glowBlurPostProcess.fragment-RLSSWGPR.mjs")]);
          }
          yield __superGet(_GlowLayer.prototype, this, "_importShadersAsync").call(this);
        });
      }
      /**
       * Get the effect name of the layer.
       * @returns The effect name
       */
      getEffectName() {
        return _GlowLayer.EffectName;
      }
      /**
       * @internal
       * Create the merge effect. This is the shader use to blit the information back
       * to the main canvas at the end of the scene rendering.
       */
      _createMergeEffect() {
        let defines = "#define EMISSIVE \n";
        if (this._options.ldrMerge) {
          defines += "#define LDR \n";
        }
        return this._engine.createEffect("glowMapMerge", [VertexBuffer.PositionKind], ["offset"], ["textureSampler", "textureSampler2"], defines, void 0, void 0, void 0, void 0, this.shaderLanguage, this._shadersLoaded ? void 0 : () => __async(this, null, function* () {
          yield this._importShadersAsync();
          this._shadersLoaded = true;
        }));
      }
      /**
       * Creates the render target textures and post processes used in the glow layer.
       */
      _createTextureAndPostProcesses() {
        let blurTextureWidth = this._mainTextureDesiredSize.width;
        let blurTextureHeight = this._mainTextureDesiredSize.height;
        blurTextureWidth = this._engine.needPOTTextures ? GetExponentOfTwo(blurTextureWidth, this._maxSize) : blurTextureWidth;
        blurTextureHeight = this._engine.needPOTTextures ? GetExponentOfTwo(blurTextureHeight, this._maxSize) : blurTextureHeight;
        let textureType = 0;
        if (this._engine.getCaps().textureHalfFloatRender) {
          textureType = 2;
        } else {
          textureType = 0;
        }
        this._blurTexture1 = new RenderTargetTexture("GlowLayerBlurRTT", {
          width: blurTextureWidth,
          height: blurTextureHeight
        }, this._scene, false, true, textureType);
        this._blurTexture1.wrapU = Texture.CLAMP_ADDRESSMODE;
        this._blurTexture1.wrapV = Texture.CLAMP_ADDRESSMODE;
        this._blurTexture1.updateSamplingMode(Texture.BILINEAR_SAMPLINGMODE);
        this._blurTexture1.renderParticles = false;
        this._blurTexture1.ignoreCameraViewport = true;
        const blurTextureWidth2 = Math.floor(blurTextureWidth / 2);
        const blurTextureHeight2 = Math.floor(blurTextureHeight / 2);
        this._blurTexture2 = new RenderTargetTexture("GlowLayerBlurRTT2", {
          width: blurTextureWidth2,
          height: blurTextureHeight2
        }, this._scene, false, true, textureType);
        this._blurTexture2.wrapU = Texture.CLAMP_ADDRESSMODE;
        this._blurTexture2.wrapV = Texture.CLAMP_ADDRESSMODE;
        this._blurTexture2.updateSamplingMode(Texture.BILINEAR_SAMPLINGMODE);
        this._blurTexture2.renderParticles = false;
        this._blurTexture2.ignoreCameraViewport = true;
        this._textures = [this._blurTexture1, this._blurTexture2];
        const effectiveKernel = this._getEffectiveBlurKernelSize();
        this._horizontalBlurPostprocess1 = new BlurPostProcess("GlowLayerHBP1", new Vector2(1, 0), effectiveKernel, {
          width: blurTextureWidth,
          height: blurTextureHeight
        }, null, Texture.BILINEAR_SAMPLINGMODE, this._scene.getEngine(), false, textureType);
        this._horizontalBlurPostprocess1.width = blurTextureWidth;
        this._horizontalBlurPostprocess1.height = blurTextureHeight;
        this._horizontalBlurPostprocess1.externalTextureSamplerBinding = true;
        this._horizontalBlurPostprocess1.onApplyObservable.add((effect) => {
          effect.setTexture("textureSampler", this._mainTexture);
        });
        this._verticalBlurPostprocess1 = new BlurPostProcess("GlowLayerVBP1", new Vector2(0, 1), effectiveKernel, {
          width: blurTextureWidth,
          height: blurTextureHeight
        }, null, Texture.BILINEAR_SAMPLINGMODE, this._scene.getEngine(), false, textureType);
        this._horizontalBlurPostprocess2 = new BlurPostProcess("GlowLayerHBP2", new Vector2(1, 0), effectiveKernel, {
          width: blurTextureWidth2,
          height: blurTextureHeight2
        }, null, Texture.BILINEAR_SAMPLINGMODE, this._scene.getEngine(), false, textureType);
        this._horizontalBlurPostprocess2.width = blurTextureWidth2;
        this._horizontalBlurPostprocess2.height = blurTextureHeight2;
        this._horizontalBlurPostprocess2.externalTextureSamplerBinding = true;
        this._horizontalBlurPostprocess2.onApplyObservable.add((effect) => {
          effect.setTexture("textureSampler", this._blurTexture1);
        });
        this._verticalBlurPostprocess2 = new BlurPostProcess("GlowLayerVBP2", new Vector2(0, 1), effectiveKernel, {
          width: blurTextureWidth2,
          height: blurTextureHeight2
        }, null, Texture.BILINEAR_SAMPLINGMODE, this._scene.getEngine(), false, textureType);
        this._postProcesses = [this._horizontalBlurPostprocess1, this._verticalBlurPostprocess1, this._horizontalBlurPostprocess2, this._verticalBlurPostprocess2];
        this._postProcesses1 = [this._horizontalBlurPostprocess1, this._verticalBlurPostprocess1];
        this._postProcesses2 = [this._horizontalBlurPostprocess2, this._verticalBlurPostprocess2];
        this._mainTexture.samples = this._options.mainTextureSamples;
        this._mainTexture.onAfterUnbindObservable.add(() => {
          const internalTexture = this._blurTexture1.renderTarget;
          if (internalTexture) {
            this._scene.postProcessManager.directRender(this._postProcesses1, internalTexture, true);
            const internalTexture2 = this._blurTexture2.renderTarget;
            if (internalTexture2) {
              this._scene.postProcessManager.directRender(this._postProcesses2, internalTexture2, true);
            }
            this._engine.unBindFramebuffer(internalTexture2 != null ? internalTexture2 : internalTexture, true);
          }
        });
        this._postProcesses.map((pp) => {
          pp.autoClear = false;
        });
      }
      /**
       * @returns The blur kernel size used by the glow.
       * Note: The value passed in the options is divided by 2 for back compatibility.
       */
      _getEffectiveBlurKernelSize() {
        return this._options.blurKernelSize / 2;
      }
      /**
       * Checks for the readiness of the element composing the layer.
       * @param subMesh the mesh to check for
       * @param useInstances specify whether or not to use instances to render the mesh
       * @returns true if ready otherwise, false
       */
      isReady(subMesh, useInstances) {
        const material = subMesh.getMaterial();
        const mesh = subMesh.getRenderingMesh();
        if (!material || !mesh) {
          return false;
        }
        const emissiveTexture = material.emissiveTexture;
        return super._isReady(subMesh, useInstances, emissiveTexture);
      }
      /**
       * @returns whether or not the layer needs stencil enabled during the mesh rendering.
       */
      needStencil() {
        return false;
      }
      /**
       * Returns true if the mesh can be rendered, otherwise false.
       * @param mesh The mesh to render
       * @param material The material used on the mesh
       * @returns true if it can be rendered otherwise false
       */
      _canRenderMesh(mesh, material) {
        return true;
      }
      /**
       * Implementation specific of rendering the generating effect on the main canvas.
       * @param effect The effect used to render through
       */
      _internalRender(effect) {
        effect.setTexture("textureSampler", this._blurTexture1);
        effect.setTexture("textureSampler2", this._blurTexture2);
        effect.setFloat("offset", this._intensity);
        const engine = this._engine;
        const previousStencilBuffer = engine.getStencilBuffer();
        engine.setStencilBuffer(false);
        engine.drawElementsType(Material.TriangleFillMode, 0, 6);
        engine.setStencilBuffer(previousStencilBuffer);
      }
      /**
       * Sets the required values for both the emissive texture and and the main color.
       * @param mesh
       * @param subMesh
       * @param material
       */
      _setEmissiveTextureAndColor(mesh, subMesh, material) {
        var _a;
        let textureLevel = 1;
        if (this.customEmissiveTextureSelector) {
          this._emissiveTextureAndColor.texture = this.customEmissiveTextureSelector(mesh, subMesh, material);
        } else {
          if (material) {
            this._emissiveTextureAndColor.texture = material.emissiveTexture;
            if (this._emissiveTextureAndColor.texture) {
              textureLevel = this._emissiveTextureAndColor.texture.level;
            }
          } else {
            this._emissiveTextureAndColor.texture = null;
          }
        }
        if (this.customEmissiveColorSelector) {
          this.customEmissiveColorSelector(mesh, subMesh, material, this._emissiveTextureAndColor.color);
        } else {
          if (material.emissiveColor) {
            const emissiveIntensity = (_a = material.emissiveIntensity) != null ? _a : 1;
            textureLevel *= emissiveIntensity;
            this._emissiveTextureAndColor.color.set(material.emissiveColor.r * textureLevel, material.emissiveColor.g * textureLevel, material.emissiveColor.b * textureLevel, material.alpha);
          } else {
            this._emissiveTextureAndColor.color.set(this.neutralColor.r, this.neutralColor.g, this.neutralColor.b, this.neutralColor.a);
          }
        }
      }
      /**
       * Returns true if the mesh should render, otherwise false.
       * @param mesh The mesh to render
       * @returns true if it should render otherwise false
       */
      _shouldRenderMesh(mesh) {
        return this.hasMesh(mesh);
      }
      /**
       * Adds specific effects defines.
       * @param defines The defines to add specifics to.
       */
      _addCustomEffectDefines(defines) {
        defines.push("#define GLOW");
      }
      /**
       * Add a mesh in the exclusion list to prevent it to impact or being impacted by the glow layer.
       * @param mesh The mesh to exclude from the glow layer
       */
      addExcludedMesh(mesh) {
        if (this._excludedMeshes.indexOf(mesh.uniqueId) === -1) {
          this._excludedMeshes.push(mesh.uniqueId);
        }
      }
      /**
       * Remove a mesh from the exclusion list to let it impact or being impacted by the glow layer.
       * @param mesh The mesh to remove
       */
      removeExcludedMesh(mesh) {
        const index = this._excludedMeshes.indexOf(mesh.uniqueId);
        if (index !== -1) {
          this._excludedMeshes.splice(index, 1);
        }
      }
      /**
       * Add a mesh in the inclusion list to impact or being impacted by the glow layer.
       * @param mesh The mesh to include in the glow layer
       */
      addIncludedOnlyMesh(mesh) {
        if (this._includedOnlyMeshes.indexOf(mesh.uniqueId) === -1) {
          this._includedOnlyMeshes.push(mesh.uniqueId);
        }
      }
      /**
       * Remove a mesh from the Inclusion list to prevent it to impact or being impacted by the glow layer.
       * @param mesh The mesh to remove
       */
      removeIncludedOnlyMesh(mesh) {
        const index = this._includedOnlyMeshes.indexOf(mesh.uniqueId);
        if (index !== -1) {
          this._includedOnlyMeshes.splice(index, 1);
        }
      }
      /**
       * Determine if a given mesh will be used in the glow layer
       * @param mesh The mesh to test
       * @returns true if the mesh will be highlighted by the current glow layer
       */
      hasMesh(mesh) {
        if (!super.hasMesh(mesh)) {
          return false;
        }
        if (this._includedOnlyMeshes.length) {
          return this._includedOnlyMeshes.indexOf(mesh.uniqueId) !== -1;
        }
        if (this._excludedMeshes.length) {
          return this._excludedMeshes.indexOf(mesh.uniqueId) === -1;
        }
        return true;
      }
      /**
       * Defines whether the current material of the mesh should be use to render the effect.
       * @param mesh defines the current mesh to render
       * @returns true if the material of the mesh should be use to render the effect
       */
      _useMeshMaterial(mesh) {
        if (this._meshesUsingTheirOwnMaterials.length == 0) {
          return false;
        }
        return this._meshesUsingTheirOwnMaterials.indexOf(mesh.uniqueId) > -1;
      }
      /**
       * Add a mesh to be rendered through its own material and not with emissive only.
       * @param mesh The mesh for which we need to use its material
       */
      referenceMeshToUseItsOwnMaterial(mesh) {
        mesh.resetDrawCache(this._mainTexture.renderPassId);
        this._meshesUsingTheirOwnMaterials.push(mesh.uniqueId);
        mesh.onDisposeObservable.add(() => {
          this._disposeMesh(mesh);
        });
      }
      /**
       * Remove a mesh from being rendered through its own material and not with emissive only.
       * @param mesh The mesh for which we need to not use its material
       */
      unReferenceMeshFromUsingItsOwnMaterial(mesh) {
        let index = this._meshesUsingTheirOwnMaterials.indexOf(mesh.uniqueId);
        while (index >= 0) {
          this._meshesUsingTheirOwnMaterials.splice(index, 1);
          index = this._meshesUsingTheirOwnMaterials.indexOf(mesh.uniqueId);
        }
        mesh.resetDrawCache(this._mainTexture.renderPassId);
      }
      /**
       * Free any resources and references associated to a mesh.
       * Internal use
       * @param mesh The mesh to free.
       * @internal
       */
      _disposeMesh(mesh) {
        this.removeIncludedOnlyMesh(mesh);
        this.removeExcludedMesh(mesh);
      }
      /**
       * Gets the class name of the effect layer
       * @returns the string with the class name of the effect layer
       */
      getClassName() {
        return "GlowLayer";
      }
      /**
       * Serializes this glow layer
       * @returns a serialized glow layer object
       */
      serialize() {
        const serializationObject = SerializationHelper.Serialize(this);
        serializationObject.customType = "BABYLON.GlowLayer";
        let index;
        serializationObject.includedMeshes = [];
        if (this._includedOnlyMeshes.length) {
          for (index = 0; index < this._includedOnlyMeshes.length; index++) {
            const mesh = this._scene.getMeshByUniqueId(this._includedOnlyMeshes[index]);
            if (mesh) {
              serializationObject.includedMeshes.push(mesh.id);
            }
          }
        }
        serializationObject.excludedMeshes = [];
        if (this._excludedMeshes.length) {
          for (index = 0; index < this._excludedMeshes.length; index++) {
            const mesh = this._scene.getMeshByUniqueId(this._excludedMeshes[index]);
            if (mesh) {
              serializationObject.excludedMeshes.push(mesh.id);
            }
          }
        }
        return serializationObject;
      }
      /**
       * Creates a Glow Layer from parsed glow layer data
       * @param parsedGlowLayer defines glow layer data
       * @param scene defines the current scene
       * @param rootUrl defines the root URL containing the glow layer information
       * @returns a parsed Glow Layer
       */
      static Parse(parsedGlowLayer, scene, rootUrl) {
        const gl = SerializationHelper.Parse(() => new _GlowLayer(parsedGlowLayer.name, scene, parsedGlowLayer.options), parsedGlowLayer, scene, rootUrl);
        let index;
        for (index = 0; index < parsedGlowLayer.excludedMeshes.length; index++) {
          const mesh = scene.getMeshById(parsedGlowLayer.excludedMeshes[index]);
          if (mesh) {
            gl.addExcludedMesh(mesh);
          }
        }
        for (index = 0; index < parsedGlowLayer.includedMeshes.length; index++) {
          const mesh = scene.getMeshById(parsedGlowLayer.includedMeshes[index]);
          if (mesh) {
            gl.addIncludedOnlyMesh(mesh);
          }
        }
        return gl;
      }
    };
    GlowLayer.EffectName = "GlowLayer";
    GlowLayer.DefaultBlurKernelSize = 32;
    GlowLayer.DefaultTextureRatio = 0.5;
    __decorate([
      serialize()
    ], GlowLayer.prototype, "blurKernelSize", null);
    __decorate([
      serialize()
    ], GlowLayer.prototype, "intensity", null);
    __decorate([
      serialize("options")
    ], GlowLayer.prototype, "_options", void 0);
    RegisterClass("BABYLON.GlowLayer", GlowLayer);
  }
});

// node_modules/@babylonjs/core/PostProcesses/sharpenPostProcess.js
var SharpenPostProcess;
var init_sharpenPostProcess = __esm({
  "node_modules/@babylonjs/core/PostProcesses/sharpenPostProcess.js"() {
    "use strict";
    init_tslib_es6();
    init_postProcess();
    init_sharpen_fragment();
    init_typeStore();
    init_decorators();
    init_decorators_serialization();
    SharpenPostProcess = class _SharpenPostProcess extends PostProcess {
      /**
       * Gets a string identifying the name of the class
       * @returns "SharpenPostProcess" string
       */
      getClassName() {
        return "SharpenPostProcess";
      }
      /**
       * Creates a new instance ConvolutionPostProcess
       * @param name The name of the effect.
       * @param options The required width/height ratio to downsize to before computing the render pass.
       * @param camera The camera to apply the render pass to.
       * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
       * @param engine The engine which the post process will be applied. (default: current engine)
       * @param reusable If the post process can be reused on the same frame. (default: false)
       * @param textureType Type of textures used when performing the post process. (default: 0)
       * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
       */
      constructor(name, options, camera, samplingMode, engine, reusable, textureType = 0, blockCompilation = false) {
        super(name, "sharpen", ["sharpnessAmounts", "screenSize"], null, options, camera, samplingMode, engine, reusable, null, textureType, void 0, null, blockCompilation);
        this.colorAmount = 1;
        this.edgeAmount = 0.3;
        this.onApply = (effect) => {
          effect.setFloat2("screenSize", this.width, this.height);
          effect.setFloat2("sharpnessAmounts", this.edgeAmount, this.colorAmount);
        };
      }
      _gatherImports(useWebGPU, list) {
        if (useWebGPU) {
          this._webGPUReady = true;
          list.push(Promise.all([import("./sharpen.fragment-GCKR2YDO.mjs")]));
        } else {
          list.push(Promise.all([import("./sharpen.fragment-VZZGNRXD.mjs")]));
        }
        super._gatherImports(useWebGPU, list);
      }
      /**
       * @internal
       */
      static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return SerializationHelper.Parse(() => {
          return new _SharpenPostProcess(parsedPostProcess.name, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, scene.getEngine(), parsedPostProcess.textureType, parsedPostProcess.reusable);
        }, parsedPostProcess, scene, rootUrl);
      }
    };
    __decorate([
      serialize()
    ], SharpenPostProcess.prototype, "colorAmount", void 0);
    __decorate([
      serialize()
    ], SharpenPostProcess.prototype, "edgeAmount", void 0);
    RegisterClass("BABYLON.SharpenPostProcess", SharpenPostProcess);
  }
});

// node_modules/@babylonjs/core/PostProcesses/imageProcessingPostProcess.js
var ImageProcessingPostProcess;
var init_imageProcessingPostProcess = __esm({
  "node_modules/@babylonjs/core/PostProcesses/imageProcessingPostProcess.js"() {
    "use strict";
    init_tslib_es6();
    init_decorators();
    init_imageProcessingConfiguration();
    init_postProcess();
    init_engineStore();
    ImageProcessingPostProcess = class extends PostProcess {
      /**
       * Gets the image processing configuration used either in this material.
       */
      get imageProcessingConfiguration() {
        return this._imageProcessingConfiguration;
      }
      /**
       * Sets the Default image processing configuration used either in the this material.
       *
       * If sets to null, the scene one is in use.
       */
      set imageProcessingConfiguration(value) {
        value.applyByPostProcess = true;
        this._attachImageProcessingConfiguration(value);
      }
      /**
       * Attaches a new image processing configuration to the PBR Material.
       * @param configuration
       * @param doNotBuild
       */
      _attachImageProcessingConfiguration(configuration, doNotBuild = false) {
        if (configuration === this._imageProcessingConfiguration) {
          return;
        }
        if (this._imageProcessingConfiguration && this._imageProcessingObserver) {
          this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
        }
        if (!configuration) {
          let scene = null;
          const engine = this.getEngine();
          const camera = this.getCamera();
          if (camera) {
            scene = camera.getScene();
          } else if (engine && engine.scenes) {
            const scenes = engine.scenes;
            scene = scenes[scenes.length - 1];
          } else {
            scene = EngineStore.LastCreatedScene;
          }
          if (scene) {
            this._imageProcessingConfiguration = scene.imageProcessingConfiguration;
          } else {
            this._imageProcessingConfiguration = new ImageProcessingConfiguration();
          }
        } else {
          this._imageProcessingConfiguration = configuration;
        }
        if (this._imageProcessingConfiguration) {
          this._imageProcessingObserver = this._imageProcessingConfiguration.onUpdateParameters.add(() => {
            this._updateParameters();
          });
        }
        if (!doNotBuild) {
          this._updateParameters();
        }
      }
      /**
       * If the post process is supported.
       */
      get isSupported() {
        const effect = this.getEffect();
        return !effect || effect.isSupported;
      }
      /**
       * Gets Color curves setup used in the effect if colorCurvesEnabled is set to true .
       */
      get colorCurves() {
        return this.imageProcessingConfiguration.colorCurves;
      }
      /**
       * Sets Color curves setup used in the effect if colorCurvesEnabled is set to true .
       */
      set colorCurves(value) {
        this.imageProcessingConfiguration.colorCurves = value;
      }
      /**
       * Gets whether the color curves effect is enabled.
       */
      get colorCurvesEnabled() {
        return this.imageProcessingConfiguration.colorCurvesEnabled;
      }
      /**
       * Sets whether the color curves effect is enabled.
       */
      set colorCurvesEnabled(value) {
        this.imageProcessingConfiguration.colorCurvesEnabled = value;
      }
      /**
       * Gets Color grading LUT texture used in the effect if colorGradingEnabled is set to true.
       */
      get colorGradingTexture() {
        return this.imageProcessingConfiguration.colorGradingTexture;
      }
      /**
       * Sets Color grading LUT texture used in the effect if colorGradingEnabled is set to true.
       */
      set colorGradingTexture(value) {
        this.imageProcessingConfiguration.colorGradingTexture = value;
      }
      /**
       * Gets whether the color grading effect is enabled.
       */
      get colorGradingEnabled() {
        return this.imageProcessingConfiguration.colorGradingEnabled;
      }
      /**
       * Gets whether the color grading effect is enabled.
       */
      set colorGradingEnabled(value) {
        this.imageProcessingConfiguration.colorGradingEnabled = value;
      }
      /**
       * Gets exposure used in the effect.
       */
      get exposure() {
        return this.imageProcessingConfiguration.exposure;
      }
      /**
       * Sets exposure used in the effect.
       */
      set exposure(value) {
        this.imageProcessingConfiguration.exposure = value;
      }
      /**
       * Gets whether tonemapping is enabled or not.
       */
      get toneMappingEnabled() {
        return this._imageProcessingConfiguration.toneMappingEnabled;
      }
      /**
       * Sets whether tonemapping is enabled or not
       */
      set toneMappingEnabled(value) {
        this._imageProcessingConfiguration.toneMappingEnabled = value;
      }
      /**
       * Gets the type of tone mapping effect.
       */
      get toneMappingType() {
        return this._imageProcessingConfiguration.toneMappingType;
      }
      /**
       * Sets the type of tone mapping effect.
       */
      set toneMappingType(value) {
        this._imageProcessingConfiguration.toneMappingType = value;
      }
      /**
       * Gets contrast used in the effect.
       */
      get contrast() {
        return this.imageProcessingConfiguration.contrast;
      }
      /**
       * Sets contrast used in the effect.
       */
      set contrast(value) {
        this.imageProcessingConfiguration.contrast = value;
      }
      /**
       * Gets Vignette stretch size.
       */
      get vignetteStretch() {
        return this.imageProcessingConfiguration.vignetteStretch;
      }
      /**
       * Sets Vignette stretch size.
       */
      set vignetteStretch(value) {
        this.imageProcessingConfiguration.vignetteStretch = value;
      }
      /**
       * Gets Vignette center X Offset.
       * @deprecated use vignetteCenterX instead
       */
      get vignetteCentreX() {
        return this.imageProcessingConfiguration.vignetteCenterX;
      }
      /**
       * Sets Vignette center X Offset.
       * @deprecated use vignetteCenterX instead
       */
      set vignetteCentreX(value) {
        this.imageProcessingConfiguration.vignetteCenterX = value;
      }
      /**
       * Gets Vignette center Y Offset.
       * @deprecated use vignetteCenterY instead
       */
      get vignetteCentreY() {
        return this.imageProcessingConfiguration.vignetteCenterY;
      }
      /**
       * Sets Vignette center Y Offset.
       * @deprecated use vignetteCenterY instead
       */
      set vignetteCentreY(value) {
        this.imageProcessingConfiguration.vignetteCenterY = value;
      }
      /**
       * Vignette center Y Offset.
       */
      get vignetteCenterY() {
        return this.imageProcessingConfiguration.vignetteCenterY;
      }
      set vignetteCenterY(value) {
        this.imageProcessingConfiguration.vignetteCenterY = value;
      }
      /**
       * Vignette center X Offset.
       */
      get vignetteCenterX() {
        return this.imageProcessingConfiguration.vignetteCenterX;
      }
      set vignetteCenterX(value) {
        this.imageProcessingConfiguration.vignetteCenterX = value;
      }
      /**
       * Gets Vignette weight or intensity of the vignette effect.
       */
      get vignetteWeight() {
        return this.imageProcessingConfiguration.vignetteWeight;
      }
      /**
       * Sets Vignette weight or intensity of the vignette effect.
       */
      set vignetteWeight(value) {
        this.imageProcessingConfiguration.vignetteWeight = value;
      }
      /**
       * Gets Color of the vignette applied on the screen through the chosen blend mode (vignetteBlendMode)
       * if vignetteEnabled is set to true.
       */
      get vignetteColor() {
        return this.imageProcessingConfiguration.vignetteColor;
      }
      /**
       * Sets Color of the vignette applied on the screen through the chosen blend mode (vignetteBlendMode)
       * if vignetteEnabled is set to true.
       */
      set vignetteColor(value) {
        this.imageProcessingConfiguration.vignetteColor = value;
      }
      /**
       * Gets Camera field of view used by the Vignette effect.
       */
      get vignetteCameraFov() {
        return this.imageProcessingConfiguration.vignetteCameraFov;
      }
      /**
       * Sets Camera field of view used by the Vignette effect.
       */
      set vignetteCameraFov(value) {
        this.imageProcessingConfiguration.vignetteCameraFov = value;
      }
      /**
       * Gets the vignette blend mode allowing different kind of effect.
       */
      get vignetteBlendMode() {
        return this.imageProcessingConfiguration.vignetteBlendMode;
      }
      /**
       * Sets the vignette blend mode allowing different kind of effect.
       */
      set vignetteBlendMode(value) {
        this.imageProcessingConfiguration.vignetteBlendMode = value;
      }
      /**
       * Gets whether the vignette effect is enabled.
       */
      get vignetteEnabled() {
        return this.imageProcessingConfiguration.vignetteEnabled;
      }
      /**
       * Sets whether the vignette effect is enabled.
       */
      set vignetteEnabled(value) {
        this.imageProcessingConfiguration.vignetteEnabled = value;
      }
      /**
       * Gets intensity of the dithering effect.
       */
      get ditheringIntensity() {
        return this.imageProcessingConfiguration.ditheringIntensity;
      }
      /**
       * Sets intensity of the dithering effect.
       */
      set ditheringIntensity(value) {
        this.imageProcessingConfiguration.ditheringIntensity = value;
      }
      /**
       * Gets whether the dithering effect is enabled.
       */
      get ditheringEnabled() {
        return this.imageProcessingConfiguration.ditheringEnabled;
      }
      /**
       * Sets whether the dithering effect is enabled.
       */
      set ditheringEnabled(value) {
        this.imageProcessingConfiguration.ditheringEnabled = value;
      }
      /**
       * Gets whether the input of the processing is in Gamma or Linear Space.
       */
      get fromLinearSpace() {
        return this._fromLinearSpace;
      }
      /**
       * Sets whether the input of the processing is in Gamma or Linear Space.
       */
      set fromLinearSpace(value) {
        if (this._fromLinearSpace === value) {
          return;
        }
        this._fromLinearSpace = value;
        this._updateParameters();
      }
      constructor(name, options, camera = null, samplingMode, engine, reusable, textureType = 0, imageProcessingConfiguration) {
        super(name, "imageProcessing", [], [], options, camera, samplingMode, engine, reusable, null, textureType, "postprocess", null, true);
        this._fromLinearSpace = true;
        this._defines = {
          IMAGEPROCESSING: false,
          VIGNETTE: false,
          VIGNETTEBLENDMODEMULTIPLY: false,
          VIGNETTEBLENDMODEOPAQUE: false,
          TONEMAPPING: 0,
          CONTRAST: false,
          COLORCURVES: false,
          COLORGRADING: false,
          COLORGRADING3D: false,
          FROMLINEARSPACE: false,
          SAMPLER3DGREENDEPTH: false,
          SAMPLER3DBGRMAP: false,
          DITHER: false,
          IMAGEPROCESSINGPOSTPROCESS: false,
          EXPOSURE: false,
          SKIPFINALCOLORCLAMP: false
        };
        if (imageProcessingConfiguration) {
          imageProcessingConfiguration.applyByPostProcess = true;
          this._attachImageProcessingConfiguration(imageProcessingConfiguration, true);
          this._updateParameters();
        } else {
          this._attachImageProcessingConfiguration(null, true);
          this.imageProcessingConfiguration.applyByPostProcess = true;
        }
        this.onApply = (effect) => {
          this.imageProcessingConfiguration.bind(effect, this.aspectRatio);
        };
      }
      _gatherImports(useWebGPU, list) {
        if (useWebGPU) {
          this._webGPUReady = true;
          list.push(import("./imageProcessing.fragment-4GBSYHGT.mjs"));
        } else {
          list.push(import("./imageProcessing.fragment-RESKY74H.mjs"));
        }
        super._gatherImports(useWebGPU, list);
      }
      /**
       *  "ImageProcessingPostProcess"
       * @returns "ImageProcessingPostProcess"
       */
      getClassName() {
        return "ImageProcessingPostProcess";
      }
      /**
       * @internal
       */
      _updateParameters() {
        this._defines.FROMLINEARSPACE = this._fromLinearSpace;
        this.imageProcessingConfiguration.prepareDefines(this._defines, true);
        let defines = "";
        for (const prop in this._defines) {
          const value = this._defines[prop];
          const type = typeof value;
          switch (type) {
            case "number":
            case "string":
              defines += `#define ${prop} ${value};
`;
              break;
            default:
              if (value) {
                defines += `#define ${prop};
`;
              }
              break;
          }
        }
        const samplers = ["textureSampler"];
        const uniforms = ["scale"];
        if (ImageProcessingConfiguration) {
          ImageProcessingConfiguration.PrepareSamplers(samplers, this._defines);
          ImageProcessingConfiguration.PrepareUniforms(uniforms, this._defines);
        }
        this.updateEffect(defines, uniforms, samplers);
      }
      dispose(camera) {
        super.dispose(camera);
        if (this._imageProcessingConfiguration && this._imageProcessingObserver) {
          this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
        }
        if (this._imageProcessingConfiguration) {
          this.imageProcessingConfiguration.applyByPostProcess = false;
        }
      }
    };
    __decorate([
      serialize()
    ], ImageProcessingPostProcess.prototype, "_fromLinearSpace", void 0);
  }
});

// node_modules/@babylonjs/core/PostProcesses/chromaticAberrationPostProcess.js
var ChromaticAberrationPostProcess;
var init_chromaticAberrationPostProcess = __esm({
  "node_modules/@babylonjs/core/PostProcesses/chromaticAberrationPostProcess.js"() {
    "use strict";
    init_tslib_es6();
    init_math_vector();
    init_postProcess();
    init_typeStore();
    init_decorators();
    init_decorators_serialization();
    ChromaticAberrationPostProcess = class _ChromaticAberrationPostProcess extends PostProcess {
      /**
       * Gets a string identifying the name of the class
       * @returns "ChromaticAberrationPostProcess" string
       */
      getClassName() {
        return "ChromaticAberrationPostProcess";
      }
      /**
       * Creates a new instance ChromaticAberrationPostProcess
       * @param name The name of the effect.
       * @param screenWidth The width of the screen to apply the effect on.
       * @param screenHeight The height of the screen to apply the effect on.
       * @param options The required width/height ratio to downsize to before computing the render pass.
       * @param camera The camera to apply the render pass to.
       * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
       * @param engine The engine which the post process will be applied. (default: current engine)
       * @param reusable If the post process can be reused on the same frame. (default: false)
       * @param textureType Type of textures used when performing the post process. (default: 0)
       * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
       */
      constructor(name, screenWidth, screenHeight, options, camera, samplingMode, engine, reusable, textureType = 0, blockCompilation = false) {
        super(name, "chromaticAberration", ["chromatic_aberration", "screen_width", "screen_height", "direction", "radialIntensity", "centerPosition"], [], options, camera, samplingMode, engine, reusable, null, textureType, void 0, null, blockCompilation);
        this.aberrationAmount = 30;
        this.radialIntensity = 0;
        this.direction = new Vector2(0.707, 0.707);
        this.centerPosition = new Vector2(0.5, 0.5);
        this.screenWidth = screenWidth;
        this.screenHeight = screenHeight;
        this.onApplyObservable.add((effect) => {
          effect.setFloat("chromatic_aberration", this.aberrationAmount);
          effect.setFloat("screen_width", screenWidth);
          effect.setFloat("screen_height", screenHeight);
          effect.setFloat("radialIntensity", this.radialIntensity);
          effect.setFloat2("direction", this.direction.x, this.direction.y);
          effect.setFloat2("centerPosition", this.centerPosition.x, this.centerPosition.y);
        });
      }
      _gatherImports(useWebGPU, list) {
        if (useWebGPU) {
          this._webGPUReady = true;
          list.push(Promise.all([import("./chromaticAberration.fragment-STBVMWT3.mjs")]));
        } else {
          list.push(Promise.all([import("./chromaticAberration.fragment-3CRKEEBB.mjs")]));
        }
        super._gatherImports(useWebGPU, list);
      }
      /**
       * @internal
       */
      static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return SerializationHelper.Parse(() => {
          return new _ChromaticAberrationPostProcess(parsedPostProcess.name, parsedPostProcess.screenWidth, parsedPostProcess.screenHeight, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, scene.getEngine(), parsedPostProcess.reusable, parsedPostProcess.textureType, false);
        }, parsedPostProcess, scene, rootUrl);
      }
    };
    __decorate([
      serialize()
    ], ChromaticAberrationPostProcess.prototype, "aberrationAmount", void 0);
    __decorate([
      serialize()
    ], ChromaticAberrationPostProcess.prototype, "radialIntensity", void 0);
    __decorate([
      serialize()
    ], ChromaticAberrationPostProcess.prototype, "direction", void 0);
    __decorate([
      serialize()
    ], ChromaticAberrationPostProcess.prototype, "centerPosition", void 0);
    __decorate([
      serialize()
    ], ChromaticAberrationPostProcess.prototype, "screenWidth", void 0);
    __decorate([
      serialize()
    ], ChromaticAberrationPostProcess.prototype, "screenHeight", void 0);
    RegisterClass("BABYLON.ChromaticAberrationPostProcess", ChromaticAberrationPostProcess);
  }
});

// node_modules/@babylonjs/core/PostProcesses/grainPostProcess.js
var GrainPostProcess;
var init_grainPostProcess = __esm({
  "node_modules/@babylonjs/core/PostProcesses/grainPostProcess.js"() {
    "use strict";
    init_tslib_es6();
    init_postProcess();
    init_typeStore();
    init_decorators();
    init_decorators_serialization();
    GrainPostProcess = class _GrainPostProcess extends PostProcess {
      /**
       * Gets a string identifying the name of the class
       * @returns "GrainPostProcess" string
       */
      getClassName() {
        return "GrainPostProcess";
      }
      /**
       * Creates a new instance of @see GrainPostProcess
       * @param name The name of the effect.
       * @param options The required width/height ratio to downsize to before computing the render pass.
       * @param camera The camera to apply the render pass to.
       * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
       * @param engine The engine which the post process will be applied. (default: current engine)
       * @param reusable If the post process can be reused on the same frame. (default: false)
       * @param textureType Type of textures used when performing the post process. (default: 0)
       * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
       */
      constructor(name, options, camera, samplingMode, engine, reusable, textureType = 0, blockCompilation = false) {
        super(name, "grain", ["intensity", "animatedSeed"], [], options, camera, samplingMode, engine, reusable, null, textureType, void 0, null, blockCompilation);
        this.intensity = 30;
        this.animated = false;
        this.onApplyObservable.add((effect) => {
          effect.setFloat("intensity", this.intensity);
          effect.setFloat("animatedSeed", this.animated ? Math.random() + 1 : 1);
        });
      }
      _gatherImports(useWebGPU, list) {
        if (useWebGPU) {
          this._webGPUReady = true;
          list.push(Promise.all([import("./grain.fragment-O3OMGEEB.mjs")]));
        } else {
          list.push(Promise.all([import("./grain.fragment-2PAOSD2W.mjs")]));
        }
        super._gatherImports(useWebGPU, list);
      }
      /**
       * @internal
       */
      static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return SerializationHelper.Parse(() => {
          return new _GrainPostProcess(parsedPostProcess.name, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, scene.getEngine(), parsedPostProcess.reusable);
        }, parsedPostProcess, scene, rootUrl);
      }
    };
    __decorate([
      serialize()
    ], GrainPostProcess.prototype, "intensity", void 0);
    __decorate([
      serialize()
    ], GrainPostProcess.prototype, "animated", void 0);
    RegisterClass("BABYLON.GrainPostProcess", GrainPostProcess);
  }
});

// node_modules/@babylonjs/core/PostProcesses/fxaaPostProcess.js
var FxaaPostProcess;
var init_fxaaPostProcess = __esm({
  "node_modules/@babylonjs/core/PostProcesses/fxaaPostProcess.js"() {
    "use strict";
    init_texture();
    init_postProcess();
    init_typeStore();
    init_decorators_serialization();
    FxaaPostProcess = class _FxaaPostProcess extends PostProcess {
      /**
       * Gets a string identifying the name of the class
       * @returns "FxaaPostProcess" string
       */
      getClassName() {
        return "FxaaPostProcess";
      }
      constructor(name, options, camera = null, samplingMode, engine, reusable, textureType = 0) {
        super(name, "fxaa", ["texelSize"], null, options, camera, samplingMode || Texture.BILINEAR_SAMPLINGMODE, engine, reusable, null, textureType, "fxaa", void 0, true);
        const defines = this._getDefines();
        this.updateEffect(defines);
        this.onApplyObservable.add((effect) => {
          const texelSize = this.texelSize;
          effect.setFloat2("texelSize", texelSize.x, texelSize.y);
        });
      }
      _gatherImports(useWebGPU, list) {
        if (useWebGPU) {
          this._webGPUReady = true;
          list.push(Promise.all([import("./fxaa.fragment-LEBLSWBK.mjs"), import("./fxaa.vertex-DH2VIC2U.mjs")]));
        } else {
          list.push(Promise.all([import("./fxaa.fragment-73HWLPXG.mjs"), import("./fxaa.vertex-U6P62X2L.mjs")]));
        }
        super._gatherImports(useWebGPU, list);
      }
      _getDefines() {
        const engine = this.getEngine();
        if (!engine) {
          return null;
        }
        const driverInfo = engine.extractDriverInfo();
        if (driverInfo.toLowerCase().indexOf("mali") > -1) {
          return "#define MALI 1\n";
        }
        return null;
      }
      /**
       * @internal
       */
      static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return SerializationHelper.Parse(() => {
          return new _FxaaPostProcess(parsedPostProcess.name, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, scene.getEngine(), parsedPostProcess.reusable);
        }, parsedPostProcess, scene, rootUrl);
      }
    };
    RegisterClass("BABYLON.FxaaPostProcess", FxaaPostProcess);
  }
});

// node_modules/@babylonjs/core/PostProcesses/RenderPipeline/postProcessRenderPipeline.js
var PostProcessRenderPipeline;
var init_postProcessRenderPipeline = __esm({
  "node_modules/@babylonjs/core/PostProcesses/RenderPipeline/postProcessRenderPipeline.js"() {
    "use strict";
    init_tslib_es6();
    init_tools();
    init_decorators();
    PostProcessRenderPipeline = class {
      /**
       * Gets pipeline name
       */
      get name() {
        return this._name;
      }
      /** Gets the list of attached cameras */
      get cameras() {
        return this._cameras;
      }
      /**
       * Gets the active engine
       */
      get engine() {
        return this._engine;
      }
      /**
       * Initializes a PostProcessRenderPipeline
       * @param _engine engine to add the pipeline to
       * @param name name of the pipeline
       */
      constructor(_engine, name) {
        this._engine = _engine;
        this._name = name;
        this._renderEffects = {};
        this._renderEffectsForIsolatedPass = new Array();
        this._cameras = [];
      }
      /**
       * Gets the class name
       * @returns "PostProcessRenderPipeline"
       */
      getClassName() {
        return "PostProcessRenderPipeline";
      }
      /**
       * If all the render effects in the pipeline are supported
       */
      get isSupported() {
        for (const renderEffectName in this._renderEffects) {
          if (Object.prototype.hasOwnProperty.call(this._renderEffects, renderEffectName)) {
            if (!this._renderEffects[renderEffectName].isSupported) {
              return false;
            }
          }
        }
        return true;
      }
      /**
       * Adds an effect to the pipeline
       * @param renderEffect the effect to add
       */
      addEffect(renderEffect) {
        this._renderEffects[renderEffect._name] = renderEffect;
      }
      // private
      /** @internal */
      _rebuild() {
      }
      /**
       * @internal
       */
      _enableEffect(renderEffectName, cameras) {
        const renderEffects = this._renderEffects[renderEffectName];
        if (!renderEffects) {
          return;
        }
        renderEffects._enable(Tools.MakeArray(cameras || this._cameras));
      }
      /**
       * @internal
       */
      _disableEffect(renderEffectName, cameras) {
        const renderEffects = this._renderEffects[renderEffectName];
        if (!renderEffects) {
          return;
        }
        renderEffects._disable(Tools.MakeArray(cameras || this._cameras));
      }
      /**
       * @internal
       */
      _attachCameras(cameras, unique) {
        const cams = Tools.MakeArray(cameras || this._cameras);
        if (!cams) {
          return;
        }
        const indicesToDelete = [];
        let i;
        for (i = 0; i < cams.length; i++) {
          const camera = cams[i];
          if (!camera) {
            continue;
          }
          if (this._cameras.indexOf(camera) === -1) {
            this._cameras.push(camera);
          } else if (unique) {
            indicesToDelete.push(i);
          }
        }
        for (i = 0; i < indicesToDelete.length; i++) {
          cams.splice(indicesToDelete[i], 1);
        }
        for (const renderEffectName in this._renderEffects) {
          if (Object.prototype.hasOwnProperty.call(this._renderEffects, renderEffectName)) {
            this._renderEffects[renderEffectName]._attachCameras(cams);
          }
        }
      }
      /**
       * @internal
       */
      _detachCameras(cameras) {
        const cams = Tools.MakeArray(cameras || this._cameras);
        if (!cams) {
          return;
        }
        for (const renderEffectName in this._renderEffects) {
          if (Object.prototype.hasOwnProperty.call(this._renderEffects, renderEffectName)) {
            this._renderEffects[renderEffectName]._detachCameras(cams);
          }
        }
        for (let i = 0; i < cams.length; i++) {
          this._cameras.splice(this._cameras.indexOf(cams[i]), 1);
        }
      }
      /** @internal */
      _update() {
        for (const renderEffectName in this._renderEffects) {
          if (Object.prototype.hasOwnProperty.call(this._renderEffects, renderEffectName)) {
            this._renderEffects[renderEffectName]._update();
          }
        }
        for (let i = 0; i < this._cameras.length; i++) {
          if (!this._cameras[i]) {
            continue;
          }
          const cameraName = this._cameras[i].name;
          if (this._renderEffectsForIsolatedPass[cameraName]) {
            this._renderEffectsForIsolatedPass[cameraName]._update();
          }
        }
      }
      /** @internal */
      _reset() {
        this._renderEffects = {};
        this._renderEffectsForIsolatedPass = new Array();
      }
      _enableMSAAOnFirstPostProcess(sampleCount) {
        if (!this._engine._features.supportMSAA) {
          return false;
        }
        const effectKeys = Object.keys(this._renderEffects);
        if (effectKeys.length > 0) {
          const postProcesses = this._renderEffects[effectKeys[0]].getPostProcesses();
          if (postProcesses) {
            postProcesses[0].samples = sampleCount;
          }
        }
        return true;
      }
      /**
       * Ensures that all post processes in the pipeline are the correct size according to the
       * the viewport's required size
       */
      _adaptPostProcessesToViewPort() {
        const effectKeys = Object.keys(this._renderEffects);
        for (const effectKey of effectKeys) {
          const postProcesses = this._renderEffects[effectKey].getPostProcesses();
          if (postProcesses) {
            for (const postProcess of postProcesses) {
              postProcess.adaptScaleToCurrentViewport = true;
            }
          }
        }
      }
      /**
       * Sets the required values to the prepass renderer.
       * @param prePassRenderer defines the prepass renderer to setup.
       * @returns true if the pre pass is needed.
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      setPrePassRenderer(prePassRenderer) {
        return false;
      }
      /**
       * Disposes of the pipeline
       */
      dispose() {
      }
    };
    __decorate([
      serialize()
    ], PostProcessRenderPipeline.prototype, "_name", void 0);
  }
});

// node_modules/@babylonjs/core/PostProcesses/RenderPipeline/postProcessRenderEffect.js
var PostProcessRenderEffect;
var init_postProcessRenderEffect = __esm({
  "node_modules/@babylonjs/core/PostProcesses/RenderPipeline/postProcessRenderEffect.js"() {
    "use strict";
    init_tools();
    PostProcessRenderEffect = class {
      /**
       * Instantiates a post process render effect.
       * A post process can be used to apply a shader to a texture after it is rendered.
       * @param engine The engine the effect is tied to
       * @param name The name of the effect
       * @param getPostProcesses A function that returns a set of post processes which the effect will run in order to be run.
       * @param singleInstance False if this post process can be run on multiple cameras. (default: true)
       */
      constructor(engine, name, getPostProcesses, singleInstance) {
        this._name = name;
        this._singleInstance = singleInstance || true;
        this._getPostProcesses = getPostProcesses;
        this._cameras = {};
        this._indicesForCamera = {};
        this._postProcesses = {};
      }
      /**
       * Checks if all the post processes in the effect are supported.
       */
      get isSupported() {
        for (const index in this._postProcesses) {
          if (Object.prototype.hasOwnProperty.call(this._postProcesses, index)) {
            const pps = this._postProcesses[index];
            for (let ppIndex = 0; ppIndex < pps.length; ppIndex++) {
              if (!pps[ppIndex].isSupported) {
                return false;
              }
            }
          }
        }
        return true;
      }
      /**
       * Updates the current state of the effect
       * @internal
       */
      _update() {
      }
      /**
       * Attaches the effect on cameras
       * @param cameras The camera to attach to.
       * @internal
       */
      _attachCameras(cameras) {
        let cameraKey;
        const cams = Tools.MakeArray(cameras || this._cameras);
        if (!cams) {
          return;
        }
        for (let i = 0; i < cams.length; i++) {
          const camera = cams[i];
          if (!camera) {
            continue;
          }
          const cameraName = camera.name;
          if (this._singleInstance) {
            cameraKey = 0;
          } else {
            cameraKey = cameraName;
          }
          if (!this._postProcesses[cameraKey]) {
            const postProcess = this._getPostProcesses();
            if (postProcess) {
              this._postProcesses[cameraKey] = Array.isArray(postProcess) ? postProcess : [postProcess];
            }
          }
          if (!this._indicesForCamera[cameraName]) {
            this._indicesForCamera[cameraName] = [];
          }
          this._postProcesses[cameraKey].forEach((postProcess) => {
            const index = camera.attachPostProcess(postProcess);
            this._indicesForCamera[cameraName].push(index);
          });
          if (!this._cameras[cameraName]) {
            this._cameras[cameraName] = camera;
          }
        }
      }
      /**
       * Detaches the effect on cameras
       * @param cameras The camera to detach from.
       * @internal
       */
      _detachCameras(cameras) {
        const cams = Tools.MakeArray(cameras || this._cameras);
        if (!cams) {
          return;
        }
        for (let i = 0; i < cams.length; i++) {
          const camera = cams[i];
          const cameraName = camera.name;
          const postProcesses = this._postProcesses[this._singleInstance ? 0 : cameraName];
          if (postProcesses) {
            postProcesses.forEach((postProcess) => {
              camera.detachPostProcess(postProcess);
            });
          }
          if (this._cameras[cameraName]) {
            this._cameras[cameraName] = null;
          }
          delete this._indicesForCamera[cameraName];
        }
      }
      /**
       * Enables the effect on given cameras
       * @param cameras The camera to enable.
       * @internal
       */
      _enable(cameras) {
        const cams = Tools.MakeArray(cameras || this._cameras);
        if (!cams) {
          return;
        }
        for (let i = 0; i < cams.length; i++) {
          const camera = cams[i];
          const cameraName = camera.name;
          const cameraKey = this._singleInstance ? 0 : cameraName;
          for (let j = 0; j < this._indicesForCamera[cameraName].length; j++) {
            const index = this._indicesForCamera[cameraName][j];
            const postProcess = camera._postProcesses[index];
            if (postProcess === void 0 || postProcess === null) {
              cams[i].attachPostProcess(this._postProcesses[cameraKey][j], index);
            }
          }
        }
      }
      /**
       * Disables the effect on the given cameras
       * @param cameras The camera to disable.
       * @internal
       */
      _disable(cameras) {
        const cams = Tools.MakeArray(cameras || this._cameras);
        if (!cams) {
          return;
        }
        for (let i = 0; i < cams.length; i++) {
          const camera = cams[i];
          const cameraName = camera.name;
          this._postProcesses[this._singleInstance ? 0 : cameraName].forEach((postProcess) => {
            camera.detachPostProcess(postProcess);
          });
        }
      }
      /**
       * Gets a list of the post processes contained in the effect.
       * @param camera The camera to get the post processes on.
       * @returns The list of the post processes in the effect.
       */
      getPostProcesses(camera) {
        if (this._singleInstance) {
          return this._postProcesses[0];
        } else {
          if (!camera) {
            return null;
          }
          return this._postProcesses[camera.name];
        }
      }
    };
  }
});

// node_modules/@babylonjs/core/PostProcesses/circleOfConfusionPostProcess.js
var CircleOfConfusionPostProcess;
var init_circleOfConfusionPostProcess = __esm({
  "node_modules/@babylonjs/core/PostProcesses/circleOfConfusionPostProcess.js"() {
    "use strict";
    init_tslib_es6();
    init_postProcess();
    init_logger();
    init_typeStore();
    init_decorators();
    CircleOfConfusionPostProcess = class extends PostProcess {
      /**
       * Gets a string identifying the name of the class
       * @returns "CircleOfConfusionPostProcess" string
       */
      getClassName() {
        return "CircleOfConfusionPostProcess";
      }
      /**
       * Creates a new instance CircleOfConfusionPostProcess
       * @param name The name of the effect.
       * @param depthTexture The depth texture of the scene to compute the circle of confusion. This must be set in order for this to function but may be set after initialization if needed.
       * @param options The required width/height ratio to downsize to before computing the render pass.
       * @param camera The camera to apply the render pass to.
       * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
       * @param engine The engine which the post process will be applied. (default: current engine)
       * @param reusable If the post process can be reused on the same frame. (default: false)
       * @param textureType Type of textures used when performing the post process. (default: 0)
       * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
       */
      constructor(name, depthTexture, options, camera, samplingMode, engine, reusable, textureType = 0, blockCompilation = false) {
        super(name, "circleOfConfusion", ["cameraMinMaxZ", "focusDistance", "cocPrecalculation"], ["depthSampler"], options, camera, samplingMode, engine, reusable, null, textureType, void 0, null, blockCompilation);
        this.lensSize = 50;
        this.fStop = 1.4;
        this.focusDistance = 2e3;
        this.focalLength = 50;
        this._depthTexture = null;
        this._depthTexture = depthTexture;
        this.onApplyObservable.add((effect) => {
          if (!this._depthTexture) {
            Logger.Warn("No depth texture set on CircleOfConfusionPostProcess");
            return;
          }
          effect.setTexture("depthSampler", this._depthTexture);
          const aperture = this.lensSize / this.fStop;
          const cocPrecalculation = aperture * this.focalLength / (this.focusDistance - this.focalLength);
          effect.setFloat("focusDistance", this.focusDistance);
          effect.setFloat("cocPrecalculation", cocPrecalculation);
          const activeCamera = this._depthTexture.activeCamera;
          effect.setFloat2("cameraMinMaxZ", activeCamera.minZ, activeCamera.maxZ - activeCamera.minZ);
        });
      }
      _gatherImports(useWebGPU, list) {
        if (useWebGPU) {
          this._webGPUReady = true;
          list.push(import("./circleOfConfusion.fragment-KGDA6RSP.mjs"));
        } else {
          list.push(import("./circleOfConfusion.fragment-N7VFMSUT.mjs"));
        }
        super._gatherImports(useWebGPU, list);
      }
      /**
       * Depth texture to be used to compute the circle of confusion. This must be set here or in the constructor in order for the post process to function.
       */
      set depthTexture(value) {
        this._depthTexture = value;
      }
    };
    __decorate([
      serialize()
    ], CircleOfConfusionPostProcess.prototype, "lensSize", void 0);
    __decorate([
      serialize()
    ], CircleOfConfusionPostProcess.prototype, "fStop", void 0);
    __decorate([
      serialize()
    ], CircleOfConfusionPostProcess.prototype, "focusDistance", void 0);
    __decorate([
      serialize()
    ], CircleOfConfusionPostProcess.prototype, "focalLength", void 0);
    RegisterClass("BABYLON.CircleOfConfusionPostProcess", CircleOfConfusionPostProcess);
  }
});

// node_modules/@babylonjs/core/PostProcesses/depthOfFieldBlurPostProcess.js
var DepthOfFieldBlurPostProcess;
var init_depthOfFieldBlurPostProcess = __esm({
  "node_modules/@babylonjs/core/PostProcesses/depthOfFieldBlurPostProcess.js"() {
    "use strict";
    init_tslib_es6();
    init_texture();
    init_blurPostProcess();
    init_typeStore();
    init_decorators();
    DepthOfFieldBlurPostProcess = class extends BlurPostProcess {
      /**
       * Gets a string identifying the name of the class
       * @returns "DepthOfFieldBlurPostProcess" string
       */
      getClassName() {
        return "DepthOfFieldBlurPostProcess";
      }
      /**
       * Creates a new instance DepthOfFieldBlurPostProcess
       * @param name The name of the effect.
       * @param scene The scene the effect belongs to.
       * @param direction The direction the blur should be applied.
       * @param kernel The size of the kernel used to blur.
       * @param options The required width/height ratio to downsize to before computing the render pass.
       * @param camera The camera to apply the render pass to.
       * @param circleOfConfusion The circle of confusion + depth map to be used to avoid blurring across edges
       * @param imageToBlur The image to apply the blur to (default: Current rendered frame)
       * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
       * @param engine The engine which the post process will be applied. (default: current engine)
       * @param reusable If the post process can be reused on the same frame. (default: false)
       * @param textureType Type of textures used when performing the post process. (default: 0)
       * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
       * @param textureFormat Format of textures used when performing the post process. (default: TEXTUREFORMAT_RGBA)
       */
      constructor(name, scene, direction, kernel, options, camera, circleOfConfusion, imageToBlur = null, samplingMode = Texture.BILINEAR_SAMPLINGMODE, engine, reusable, textureType = 0, blockCompilation = false, textureFormat = 5) {
        super(
          name,
          direction,
          kernel,
          options,
          camera,
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          samplingMode = 2,
          engine,
          reusable,
          textureType,
          `#define DOF 1
`,
          blockCompilation,
          textureFormat
        );
        this.direction = direction;
        this.externalTextureSamplerBinding = !!imageToBlur;
        this.onApplyObservable.add((effect) => {
          if (imageToBlur != null) {
            effect.setTextureFromPostProcess("textureSampler", imageToBlur);
          }
          effect.setTextureFromPostProcessOutput("circleOfConfusionSampler", circleOfConfusion);
        });
      }
    };
    __decorate([
      serialize()
    ], DepthOfFieldBlurPostProcess.prototype, "direction", void 0);
    RegisterClass("BABYLON.DepthOfFieldBlurPostProcess", DepthOfFieldBlurPostProcess);
  }
});

// node_modules/@babylonjs/core/PostProcesses/depthOfFieldMergePostProcess.js
var DepthOfFieldMergePostProcess;
var init_depthOfFieldMergePostProcess = __esm({
  "node_modules/@babylonjs/core/PostProcesses/depthOfFieldMergePostProcess.js"() {
    "use strict";
    init_postProcess();
    DepthOfFieldMergePostProcess = class extends PostProcess {
      /**
       * Gets a string identifying the name of the class
       * @returns "DepthOfFieldMergePostProcess" string
       */
      getClassName() {
        return "DepthOfFieldMergePostProcess";
      }
      /**
       * Creates a new instance of DepthOfFieldMergePostProcess
       * @param name The name of the effect.
       * @param originalFromInput Post process which's input will be used for the merge.
       * @param circleOfConfusion Circle of confusion post process which's output will be used to blur each pixel.
       * @param _blurSteps Blur post processes from low to high which will be mixed with the original image.
       * @param options The required width/height ratio to downsize to before computing the render pass.
       * @param camera The camera to apply the render pass to.
       * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
       * @param engine The engine which the post process will be applied. (default: current engine)
       * @param reusable If the post process can be reused on the same frame. (default: false)
       * @param textureType Type of textures used when performing the post process. (default: 0)
       * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
       */
      constructor(name, originalFromInput, circleOfConfusion, _blurSteps, options, camera, samplingMode, engine, reusable, textureType = 0, blockCompilation = false) {
        super(name, "depthOfFieldMerge", [], ["circleOfConfusionSampler", "blurStep0", "blurStep1", "blurStep2"], options, camera, samplingMode, engine, reusable, null, textureType, void 0, null, true);
        this._blurSteps = _blurSteps;
        this.externalTextureSamplerBinding = true;
        this.onApplyObservable.add((effect) => {
          effect.setTextureFromPostProcess("textureSampler", originalFromInput);
          effect.setTextureFromPostProcessOutput("circleOfConfusionSampler", circleOfConfusion);
          _blurSteps.forEach((step, index) => {
            effect.setTextureFromPostProcessOutput("blurStep" + (_blurSteps.length - index - 1), step);
          });
        });
        if (!blockCompilation) {
          this.updateEffect();
        }
      }
      _gatherImports(useWebGPU, list) {
        if (useWebGPU) {
          this._webGPUReady = true;
          list.push(import("./depthOfFieldMerge.fragment-ILHATAW3.mjs"));
        } else {
          list.push(import("./depthOfFieldMerge.fragment-CWP2BYNX.mjs"));
        }
        super._gatherImports(useWebGPU, list);
      }
      /**
       * Updates the effect with the current post process compile time values and recompiles the shader.
       * @param defines Define statements that should be added at the beginning of the shader. (default: null)
       * @param uniforms Set of uniform variables that will be passed to the shader. (default: null)
       * @param samplers Set of Texture2D variables that will be passed to the shader. (default: null)
       * @param indexParameters The index parameters to be used for babylons include syntax "#include<kernelBlurVaryingDeclaration>[0..varyingCount]". (default: undefined) See usage in babylon.blurPostProcess.ts and kernelBlur.vertex.fx
       * @param onCompiled Called when the shader has been compiled.
       * @param onError Called if there is an error when compiling a shader.
       */
      updateEffect(defines = null, uniforms = null, samplers = null, indexParameters, onCompiled, onError) {
        if (!defines) {
          defines = "";
          defines += "#define BLUR_LEVEL " + (this._blurSteps.length - 1) + "\n";
        }
        super.updateEffect(defines, uniforms, samplers, indexParameters, onCompiled, onError);
      }
    };
  }
});

// node_modules/@babylonjs/core/PostProcesses/depthOfFieldEffect.js
var DepthOfFieldEffectBlurLevel, DepthOfFieldEffect;
var init_depthOfFieldEffect = __esm({
  "node_modules/@babylonjs/core/PostProcesses/depthOfFieldEffect.js"() {
    "use strict";
    init_math_vector();
    init_texture();
    init_postProcessRenderEffect();
    init_circleOfConfusionPostProcess();
    init_depthOfFieldBlurPostProcess();
    init_depthOfFieldMergePostProcess();
    (function(DepthOfFieldEffectBlurLevel2) {
      DepthOfFieldEffectBlurLevel2[DepthOfFieldEffectBlurLevel2["Low"] = 0] = "Low";
      DepthOfFieldEffectBlurLevel2[DepthOfFieldEffectBlurLevel2["Medium"] = 1] = "Medium";
      DepthOfFieldEffectBlurLevel2[DepthOfFieldEffectBlurLevel2["High"] = 2] = "High";
    })(DepthOfFieldEffectBlurLevel || (DepthOfFieldEffectBlurLevel = {}));
    DepthOfFieldEffect = class extends PostProcessRenderEffect {
      /**
       * The focal the length of the camera used in the effect in scene units/1000 (eg. millimeter)
       */
      set focalLength(value) {
        this._circleOfConfusion.focalLength = value;
      }
      get focalLength() {
        return this._circleOfConfusion.focalLength;
      }
      /**
       * F-Stop of the effect's camera. The diameter of the resulting aperture can be computed by lensSize/fStop. (default: 1.4)
       */
      set fStop(value) {
        this._circleOfConfusion.fStop = value;
      }
      get fStop() {
        return this._circleOfConfusion.fStop;
      }
      /**
       * Distance away from the camera to focus on in scene units/1000 (eg. millimeter). (default: 2000)
       */
      set focusDistance(value) {
        this._circleOfConfusion.focusDistance = value;
      }
      get focusDistance() {
        return this._circleOfConfusion.focusDistance;
      }
      /**
       * Max lens size in scene units/1000 (eg. millimeter). Standard cameras are 50mm. (default: 50) The diameter of the resulting aperture can be computed by lensSize/fStop.
       */
      set lensSize(value) {
        this._circleOfConfusion.lensSize = value;
      }
      get lensSize() {
        return this._circleOfConfusion.lensSize;
      }
      /**
       * Creates a new instance DepthOfFieldEffect
       * @param scene The scene the effect belongs to.
       * @param depthTexture The depth texture of the scene to compute the circle of confusion.This must be set in order for this to function but may be set after initialization if needed.
       * @param blurLevel
       * @param pipelineTextureType The type of texture to be used when performing the post processing.
       * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
       */
      constructor(scene, depthTexture, blurLevel = 0, pipelineTextureType = 0, blockCompilation = false) {
        super(scene.getEngine(), "depth of field", () => {
          return this._effects;
        }, true);
        this._effects = [];
        const engine = scene.getEngine();
        const circleOfConfusionTextureFormat = engine.isWebGPU || engine.version > 1 ? 6 : 5;
        this._circleOfConfusion = new CircleOfConfusionPostProcess("circleOfConfusion", depthTexture, 1, null, Texture.BILINEAR_SAMPLINGMODE, engine, false, pipelineTextureType, blockCompilation);
        this._depthOfFieldBlurY = [];
        this._depthOfFieldBlurX = [];
        let blurCount = 1;
        let kernelSize = 15;
        switch (blurLevel) {
          case 2: {
            blurCount = 3;
            kernelSize = 51;
            break;
          }
          case 1: {
            blurCount = 2;
            kernelSize = 31;
            break;
          }
          default: {
            kernelSize = 15;
            blurCount = 1;
            break;
          }
        }
        const adjustedKernelSize = kernelSize / Math.pow(2, blurCount - 1);
        let ratio = 1;
        for (let i = 0; i < blurCount; i++) {
          const blurY = new DepthOfFieldBlurPostProcess("vertical blur", scene, new Vector2(0, 1), adjustedKernelSize, ratio, null, this._circleOfConfusion, i == 0 ? this._circleOfConfusion : null, Texture.BILINEAR_SAMPLINGMODE, engine, false, pipelineTextureType, blockCompilation, i == 0 ? circleOfConfusionTextureFormat : 5);
          blurY.autoClear = false;
          ratio = 0.75 / Math.pow(2, i);
          const blurX = new DepthOfFieldBlurPostProcess("horizontal blur", scene, new Vector2(1, 0), adjustedKernelSize, ratio, null, this._circleOfConfusion, null, Texture.BILINEAR_SAMPLINGMODE, engine, false, pipelineTextureType, blockCompilation);
          blurX.autoClear = false;
          this._depthOfFieldBlurY.push(blurY);
          this._depthOfFieldBlurX.push(blurX);
        }
        this._effects = [this._circleOfConfusion];
        for (let i = 0; i < this._depthOfFieldBlurX.length; i++) {
          this._effects.push(this._depthOfFieldBlurY[i]);
          this._effects.push(this._depthOfFieldBlurX[i]);
        }
        this._dofMerge = new DepthOfFieldMergePostProcess("dofMerge", this._circleOfConfusion, this._circleOfConfusion, this._depthOfFieldBlurX, ratio, null, Texture.BILINEAR_SAMPLINGMODE, engine, false, pipelineTextureType, blockCompilation);
        this._dofMerge.autoClear = false;
        this._effects.push(this._dofMerge);
      }
      /**
       * Get the current class name of the current effect
       * @returns "DepthOfFieldEffect"
       */
      getClassName() {
        return "DepthOfFieldEffect";
      }
      /**
       * Depth texture to be used to compute the circle of confusion. This must be set here or in the constructor in order for the post process to function.
       */
      set depthTexture(value) {
        this._circleOfConfusion.depthTexture = value;
      }
      /**
       * Disposes each of the internal effects for a given camera.
       * @param camera The camera to dispose the effect on.
       */
      disposeEffects(camera) {
        for (let effectIndex = 0; effectIndex < this._effects.length; effectIndex++) {
          this._effects[effectIndex].dispose(camera);
        }
      }
      /**
       * @internal Internal
       */
      _updateEffects() {
        for (let effectIndex = 0; effectIndex < this._effects.length; effectIndex++) {
          this._effects[effectIndex].updateEffect();
        }
      }
      /**
       * Internal
       * @returns if all the contained post processes are ready.
       * @internal
       */
      _isReady() {
        for (let effectIndex = 0; effectIndex < this._effects.length; effectIndex++) {
          if (!this._effects[effectIndex].isReady()) {
            return false;
          }
        }
        return true;
      }
    };
  }
});

// node_modules/@babylonjs/core/PostProcesses/extractHighlightsPostProcess.js
var ExtractHighlightsPostProcess;
var init_extractHighlightsPostProcess = __esm({
  "node_modules/@babylonjs/core/PostProcesses/extractHighlightsPostProcess.js"() {
    "use strict";
    init_tslib_es6();
    init_postProcess();
    init_math_constants();
    init_decorators();
    init_typeStore();
    ExtractHighlightsPostProcess = class extends PostProcess {
      /**
       * Gets a string identifying the name of the class
       * @returns "ExtractHighlightsPostProcess" string
       */
      getClassName() {
        return "ExtractHighlightsPostProcess";
      }
      constructor(name, options, camera, samplingMode, engine, reusable, textureType = 0, blockCompilation = false) {
        super(name, "extractHighlights", ["threshold", "exposure"], null, options, camera, samplingMode, engine, reusable, null, textureType, void 0, null, blockCompilation);
        this.threshold = 0.9;
        this._exposure = 1;
        this._inputPostProcess = null;
        this.onApplyObservable.add((effect) => {
          this.externalTextureSamplerBinding = !!this._inputPostProcess;
          if (this._inputPostProcess) {
            effect.setTextureFromPostProcess("textureSampler", this._inputPostProcess);
          }
          effect.setFloat("threshold", Math.pow(this.threshold, ToGammaSpace));
          effect.setFloat("exposure", this._exposure);
        });
      }
      _gatherImports(useWebGPU, list) {
        if (useWebGPU) {
          this._webGPUReady = true;
          list.push(import("./extractHighlights.fragment-CD7HG2A7.mjs"));
        } else {
          list.push(import("./extractHighlights.fragment-355SQOWB.mjs"));
        }
        super._gatherImports(useWebGPU, list);
      }
    };
    __decorate([
      serialize()
    ], ExtractHighlightsPostProcess.prototype, "threshold", void 0);
    RegisterClass("BABYLON.ExtractHighlightsPostProcess", ExtractHighlightsPostProcess);
  }
});

// node_modules/@babylonjs/core/PostProcesses/bloomMergePostProcess.js
var BloomMergePostProcess;
var init_bloomMergePostProcess = __esm({
  "node_modules/@babylonjs/core/PostProcesses/bloomMergePostProcess.js"() {
    "use strict";
    init_tslib_es6();
    init_postProcess();
    init_typeStore();
    init_decorators();
    BloomMergePostProcess = class extends PostProcess {
      /**
       * Gets a string identifying the name of the class
       * @returns "BloomMergePostProcess" string
       */
      getClassName() {
        return "BloomMergePostProcess";
      }
      /**
       * Creates a new instance of @see BloomMergePostProcess
       * @param name The name of the effect.
       * @param originalFromInput Post process which's input will be used for the merge.
       * @param blurred Blurred highlights post process which's output will be used.
       * @param weight Weight of the bloom to be added to the original input.
       * @param options The required width/height ratio to downsize to before computing the render pass.
       * @param camera The camera to apply the render pass to.
       * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
       * @param engine The engine which the post process will be applied. (default: current engine)
       * @param reusable If the post process can be reused on the same frame. (default: false)
       * @param textureType Type of textures used when performing the post process. (default: 0)
       * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
       */
      constructor(name, originalFromInput, blurred, weight, options, camera, samplingMode, engine, reusable, textureType = 0, blockCompilation = false) {
        super(name, "bloomMerge", ["bloomWeight"], ["bloomBlur"], options, camera, samplingMode, engine, reusable, null, textureType, void 0, null, true);
        this.weight = 1;
        this.weight = weight;
        this.externalTextureSamplerBinding = true;
        this.onApplyObservable.add((effect) => {
          effect.setTextureFromPostProcess("textureSampler", originalFromInput);
          effect.setTextureFromPostProcessOutput("bloomBlur", blurred);
          effect.setFloat("bloomWeight", this.weight);
        });
        if (!blockCompilation) {
          this.updateEffect();
        }
      }
      _gatherImports(useWebGPU, list) {
        if (useWebGPU) {
          this._webGPUReady = true;
          list.push(import("./bloomMerge.fragment-USO6QBKZ.mjs"));
        } else {
          list.push(import("./bloomMerge.fragment-LYGGOQ7B.mjs"));
        }
        super._gatherImports(useWebGPU, list);
      }
    };
    __decorate([
      serialize()
    ], BloomMergePostProcess.prototype, "weight", void 0);
    RegisterClass("BABYLON.BloomMergePostProcess", BloomMergePostProcess);
  }
});

// node_modules/@babylonjs/core/PostProcesses/bloomEffect.js
var BloomEffect;
var init_bloomEffect = __esm({
  "node_modules/@babylonjs/core/PostProcesses/bloomEffect.js"() {
    "use strict";
    init_postProcessRenderEffect();
    init_extractHighlightsPostProcess();
    init_blurPostProcess();
    init_bloomMergePostProcess();
    init_math_vector();
    init_texture();
    BloomEffect = class extends PostProcessRenderEffect {
      /**
       * The luminance threshold to find bright areas of the image to bloom.
       */
      get threshold() {
        return this._downscale.threshold;
      }
      set threshold(value) {
        this._downscale.threshold = value;
      }
      /**
       * The strength of the bloom.
       */
      get weight() {
        return this._merge.weight;
      }
      set weight(value) {
        this._merge.weight = value;
      }
      /**
       * Specifies the size of the bloom blur kernel, relative to the final output size
       */
      get kernel() {
        return this._blurX.kernel / this._bloomScale;
      }
      set kernel(value) {
        this._blurX.kernel = value * this._bloomScale;
        this._blurY.kernel = value * this._bloomScale;
      }
      /**
       * Creates a new instance of @see BloomEffect
       * @param scene The scene the effect belongs to.
       * @param _bloomScale The ratio of the blur texture to the input texture that should be used to compute the bloom.
       * @param bloomWeight The strength of bloom.
       * @param bloomKernel The size of the kernel to be used when applying the blur.
       * @param pipelineTextureType The type of texture to be used when performing the post processing.
       * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
       */
      constructor(scene, _bloomScale, bloomWeight, bloomKernel, pipelineTextureType = 0, blockCompilation = false) {
        super(scene.getEngine(), "bloom", () => {
          return this._effects;
        }, true);
        this._bloomScale = _bloomScale;
        this._effects = [];
        this._downscale = new ExtractHighlightsPostProcess("highlights", 1, null, Texture.BILINEAR_SAMPLINGMODE, scene.getEngine(), false, pipelineTextureType, blockCompilation);
        this._blurX = new BlurPostProcess("horizontal blur", new Vector2(1, 0), 10, _bloomScale, null, Texture.BILINEAR_SAMPLINGMODE, scene.getEngine(), false, pipelineTextureType, void 0, blockCompilation);
        this._blurX.alwaysForcePOT = true;
        this._blurX.autoClear = false;
        this._blurY = new BlurPostProcess("vertical blur", new Vector2(0, 1), 10, _bloomScale, null, Texture.BILINEAR_SAMPLINGMODE, scene.getEngine(), false, pipelineTextureType, void 0, blockCompilation);
        this._blurY.alwaysForcePOT = true;
        this._blurY.autoClear = false;
        this.kernel = bloomKernel;
        this._effects = [this._downscale, this._blurX, this._blurY];
        this._merge = new BloomMergePostProcess("bloomMerge", this._downscale, this._blurY, bloomWeight, _bloomScale, null, Texture.BILINEAR_SAMPLINGMODE, scene.getEngine(), false, pipelineTextureType, blockCompilation);
        this._merge.autoClear = false;
        this._effects.push(this._merge);
      }
      /**
       * Disposes each of the internal effects for a given camera.
       * @param camera The camera to dispose the effect on.
       */
      disposeEffects(camera) {
        for (let effectIndex = 0; effectIndex < this._effects.length; effectIndex++) {
          this._effects[effectIndex].dispose(camera);
        }
      }
      /**
       * @internal Internal
       */
      _updateEffects() {
        for (let effectIndex = 0; effectIndex < this._effects.length; effectIndex++) {
          this._effects[effectIndex].updateEffect();
        }
      }
      /**
       * Internal
       * @returns if all the contained post processes are ready.
       * @internal
       */
      _isReady() {
        for (let effectIndex = 0; effectIndex < this._effects.length; effectIndex++) {
          if (!this._effects[effectIndex].isReady()) {
            return false;
          }
        }
        return true;
      }
    };
  }
});

// node_modules/@babylonjs/core/PostProcesses/RenderPipeline/postProcessRenderPipelineManager.js
var PostProcessRenderPipelineManager;
var init_postProcessRenderPipelineManager = __esm({
  "node_modules/@babylonjs/core/PostProcesses/RenderPipeline/postProcessRenderPipelineManager.js"() {
    "use strict";
    PostProcessRenderPipelineManager = class {
      /**
       * Initializes a PostProcessRenderPipelineManager
       * @see https://doc.babylonjs.com/features/featuresDeepDive/postProcesses/postProcessRenderPipeline
       */
      constructor() {
        this._renderPipelines = {};
      }
      /**
       * Gets the list of supported render pipelines
       */
      get supportedPipelines() {
        const result = [];
        for (const renderPipelineName in this._renderPipelines) {
          if (Object.prototype.hasOwnProperty.call(this._renderPipelines, renderPipelineName)) {
            const pipeline = this._renderPipelines[renderPipelineName];
            if (pipeline.isSupported) {
              result.push(pipeline);
            }
          }
        }
        return result;
      }
      /**
       * Adds a pipeline to the manager
       * @param renderPipeline The pipeline to add
       */
      addPipeline(renderPipeline) {
        this._renderPipelines[renderPipeline._name] = renderPipeline;
      }
      /**
       * Remove the pipeline from the manager
       * @param renderPipelineName the name of the pipeline to remove
       */
      removePipeline(renderPipelineName) {
        delete this._renderPipelines[renderPipelineName];
      }
      /**
       * Attaches a camera to the pipeline
       * @param renderPipelineName The name of the pipeline to attach to
       * @param cameras the camera to attach
       * @param unique if the camera can be attached multiple times to the pipeline
       */
      attachCamerasToRenderPipeline(renderPipelineName, cameras, unique = false) {
        const renderPipeline = this._renderPipelines[renderPipelineName];
        if (!renderPipeline) {
          return;
        }
        renderPipeline._attachCameras(cameras, unique);
      }
      /**
       * Detaches a camera from the pipeline
       * @param renderPipelineName The name of the pipeline to detach from
       * @param cameras the camera to detach
       */
      detachCamerasFromRenderPipeline(renderPipelineName, cameras) {
        const renderPipeline = this._renderPipelines[renderPipelineName];
        if (!renderPipeline) {
          return;
        }
        renderPipeline._detachCameras(cameras);
      }
      /**
       * Enables an effect by name on a pipeline
       * @param renderPipelineName the name of the pipeline to enable the effect in
       * @param renderEffectName the name of the effect to enable
       * @param cameras the cameras that the effect should be enabled on
       */
      enableEffectInPipeline(renderPipelineName, renderEffectName, cameras) {
        const renderPipeline = this._renderPipelines[renderPipelineName];
        if (!renderPipeline) {
          return;
        }
        renderPipeline._enableEffect(renderEffectName, cameras);
      }
      /**
       * Disables an effect by name on a pipeline
       * @param renderPipelineName the name of the pipeline to disable the effect in
       * @param renderEffectName the name of the effect to disable
       * @param cameras the cameras that the effect should be disabled on
       */
      disableEffectInPipeline(renderPipelineName, renderEffectName, cameras) {
        const renderPipeline = this._renderPipelines[renderPipelineName];
        if (!renderPipeline) {
          return;
        }
        renderPipeline._disableEffect(renderEffectName, cameras);
      }
      /**
       * Updates the state of all contained render pipelines and disposes of any non supported pipelines
       */
      update() {
        for (const renderPipelineName in this._renderPipelines) {
          if (Object.prototype.hasOwnProperty.call(this._renderPipelines, renderPipelineName)) {
            const pipeline = this._renderPipelines[renderPipelineName];
            if (!pipeline.isSupported) {
              pipeline.dispose();
              delete this._renderPipelines[renderPipelineName];
            } else {
              pipeline._update();
            }
          }
        }
      }
      /** @internal */
      _rebuild() {
        for (const renderPipelineName in this._renderPipelines) {
          if (Object.prototype.hasOwnProperty.call(this._renderPipelines, renderPipelineName)) {
            const pipeline = this._renderPipelines[renderPipelineName];
            pipeline._rebuild();
          }
        }
      }
      /**
       * Disposes of the manager and pipelines
       */
      dispose() {
        for (const renderPipelineName in this._renderPipelines) {
          if (Object.prototype.hasOwnProperty.call(this._renderPipelines, renderPipelineName)) {
            const pipeline = this._renderPipelines[renderPipelineName];
            pipeline.dispose();
          }
        }
      }
    };
  }
});

// node_modules/@babylonjs/core/PostProcesses/RenderPipeline/postProcessRenderPipelineManagerSceneComponent.js
var PostProcessRenderPipelineManagerSceneComponent;
var init_postProcessRenderPipelineManagerSceneComponent = __esm({
  "node_modules/@babylonjs/core/PostProcesses/RenderPipeline/postProcessRenderPipelineManagerSceneComponent.js"() {
    "use strict";
    init_sceneComponent();
    init_postProcessRenderPipelineManager();
    init_scene();
    Object.defineProperty(Scene.prototype, "postProcessRenderPipelineManager", {
      get: function() {
        if (!this._postProcessRenderPipelineManager) {
          let component = this._getComponent(SceneComponentConstants.NAME_POSTPROCESSRENDERPIPELINEMANAGER);
          if (!component) {
            component = new PostProcessRenderPipelineManagerSceneComponent(this);
            this._addComponent(component);
          }
          this._postProcessRenderPipelineManager = new PostProcessRenderPipelineManager();
        }
        return this._postProcessRenderPipelineManager;
      },
      enumerable: true,
      configurable: true
    });
    PostProcessRenderPipelineManagerSceneComponent = class {
      /**
       * Creates a new instance of the component for the given scene
       * @param scene Defines the scene to register the component in
       */
      constructor(scene) {
        this.name = SceneComponentConstants.NAME_POSTPROCESSRENDERPIPELINEMANAGER;
        this.scene = scene;
      }
      /**
       * Registers the component in a given scene
       */
      register() {
        this.scene._gatherRenderTargetsStage.registerStep(SceneComponentConstants.STEP_GATHERRENDERTARGETS_POSTPROCESSRENDERPIPELINEMANAGER, this, this._gatherRenderTargets);
      }
      /**
       * Rebuilds the elements related to this component in case of
       * context lost for instance.
       */
      rebuild() {
        if (this.scene._postProcessRenderPipelineManager) {
          this.scene._postProcessRenderPipelineManager._rebuild();
        }
      }
      /**
       * Disposes the component and the associated resources
       */
      dispose() {
        if (this.scene._postProcessRenderPipelineManager) {
          this.scene._postProcessRenderPipelineManager.dispose();
        }
      }
      _gatherRenderTargets() {
        if (this.scene._postProcessRenderPipelineManager) {
          this.scene._postProcessRenderPipelineManager.update();
        }
      }
    };
  }
});

// node_modules/@babylonjs/core/PostProcesses/RenderPipeline/Pipelines/defaultRenderingPipeline.js
var DefaultRenderingPipeline;
var init_defaultRenderingPipeline = __esm({
  "node_modules/@babylonjs/core/PostProcesses/RenderPipeline/Pipelines/defaultRenderingPipeline.js"() {
    "use strict";
    init_tslib_es6();
    init_decorators();
    init_decorators_serialization();
    init_observable();
    init_logger();
    init_texture();
    init_glowLayer();
    init_sharpenPostProcess();
    init_imageProcessingPostProcess();
    init_chromaticAberrationPostProcess();
    init_grainPostProcess();
    init_fxaaPostProcess();
    init_postProcessRenderPipeline();
    init_postProcessRenderEffect();
    init_depthOfFieldEffect();
    init_bloomEffect();
    init_typeStore();
    init_engineStore();
    init_tools();
    init_postProcessRenderPipelineManagerSceneComponent();
    DefaultRenderingPipeline = class _DefaultRenderingPipeline extends PostProcessRenderPipeline {
      /**
       * Enable or disable automatic building of the pipeline when effects are enabled and disabled.
       * If false, you will have to manually call prepare() to update the pipeline.
       */
      get automaticBuild() {
        return this._buildAllowed;
      }
      set automaticBuild(value) {
        this._buildAllowed = value;
      }
      /**
       * Gets active scene
       */
      get scene() {
        return this._scene;
      }
      /**
       * Enable or disable the sharpen process from the pipeline
       */
      set sharpenEnabled(enabled) {
        if (this._sharpenEnabled === enabled) {
          return;
        }
        this._sharpenEnabled = enabled;
        this._buildPipeline();
      }
      get sharpenEnabled() {
        return this._sharpenEnabled;
      }
      /**
       * Specifies the size of the bloom blur kernel, relative to the final output size
       */
      get bloomKernel() {
        return this._bloomKernel;
      }
      set bloomKernel(value) {
        this._bloomKernel = value;
        this.bloom.kernel = value / this._hardwareScaleLevel;
      }
      /**
       * The strength of the bloom.
       */
      set bloomWeight(value) {
        if (this._bloomWeight === value) {
          return;
        }
        this.bloom.weight = value;
        this._bloomWeight = value;
      }
      get bloomWeight() {
        return this._bloomWeight;
      }
      /**
       * The luminance threshold to find bright areas of the image to bloom.
       */
      set bloomThreshold(value) {
        if (this._bloomThreshold === value) {
          return;
        }
        this.bloom.threshold = value;
        this._bloomThreshold = value;
      }
      get bloomThreshold() {
        return this._bloomThreshold;
      }
      /**
       * The scale of the bloom, lower value will provide better performance.
       */
      set bloomScale(value) {
        if (this._bloomScale === value) {
          return;
        }
        this._bloomScale = value;
        this._rebuildBloom();
        this._buildPipeline();
      }
      get bloomScale() {
        return this._bloomScale;
      }
      /**
       * Enable or disable the bloom from the pipeline
       */
      set bloomEnabled(enabled) {
        if (this._bloomEnabled === enabled) {
          return;
        }
        this._bloomEnabled = enabled;
        this._buildPipeline();
      }
      get bloomEnabled() {
        return this._bloomEnabled;
      }
      _rebuildBloom() {
        const oldBloom = this.bloom;
        this.bloom = new BloomEffect(this._scene, this.bloomScale, this._bloomWeight, this.bloomKernel / this._hardwareScaleLevel, this._defaultPipelineTextureType, false);
        this.bloom.threshold = oldBloom.threshold;
        for (let i = 0; i < this._cameras.length; i++) {
          oldBloom.disposeEffects(this._cameras[i]);
        }
      }
      /**
       * If the depth of field is enabled.
       */
      get depthOfFieldEnabled() {
        return this._depthOfFieldEnabled;
      }
      set depthOfFieldEnabled(enabled) {
        if (this._depthOfFieldEnabled === enabled) {
          return;
        }
        this._depthOfFieldEnabled = enabled;
        this._buildPipeline();
      }
      /**
       * Blur level of the depth of field effect. (Higher blur will effect performance)
       */
      get depthOfFieldBlurLevel() {
        return this._depthOfFieldBlurLevel;
      }
      set depthOfFieldBlurLevel(value) {
        if (this._depthOfFieldBlurLevel === value) {
          return;
        }
        this._depthOfFieldBlurLevel = value;
        const oldDof = this.depthOfField;
        this.depthOfField = new DepthOfFieldEffect(this._scene, null, this._depthOfFieldBlurLevel, this._defaultPipelineTextureType, false);
        this.depthOfField.focalLength = oldDof.focalLength;
        this.depthOfField.focusDistance = oldDof.focusDistance;
        this.depthOfField.fStop = oldDof.fStop;
        this.depthOfField.lensSize = oldDof.lensSize;
        for (let i = 0; i < this._cameras.length; i++) {
          oldDof.disposeEffects(this._cameras[i]);
        }
        this._buildPipeline();
      }
      /**
       * If the anti aliasing is enabled.
       */
      set fxaaEnabled(enabled) {
        if (this._fxaaEnabled === enabled) {
          return;
        }
        this._fxaaEnabled = enabled;
        this._buildPipeline();
      }
      get fxaaEnabled() {
        return this._fxaaEnabled;
      }
      /**
       * MSAA sample count, setting this to 4 will provide 4x anti aliasing. (default: 1)
       */
      set samples(sampleCount) {
        if (this._samples === sampleCount) {
          return;
        }
        this._samples = sampleCount;
        this._buildPipeline();
      }
      get samples() {
        return this._samples;
      }
      /**
       * If image processing is enabled.
       */
      set imageProcessingEnabled(enabled) {
        if (this._imageProcessingEnabled === enabled) {
          return;
        }
        this._scene.imageProcessingConfiguration.isEnabled = enabled;
      }
      get imageProcessingEnabled() {
        return this._imageProcessingEnabled;
      }
      /**
       * If glow layer is enabled. (Adds a glow effect to emmissive materials)
       */
      set glowLayerEnabled(enabled) {
        if (enabled && !this._glowLayer) {
          this._glowLayer = new GlowLayer("", this._scene);
        } else if (!enabled && this._glowLayer) {
          this._glowLayer.dispose();
          this._glowLayer = null;
        }
      }
      get glowLayerEnabled() {
        return this._glowLayer != null;
      }
      /**
       * Gets the glow layer (or null if not defined)
       */
      get glowLayer() {
        return this._glowLayer;
      }
      /**
       * Enable or disable the chromaticAberration process from the pipeline
       */
      set chromaticAberrationEnabled(enabled) {
        if (this._chromaticAberrationEnabled === enabled) {
          return;
        }
        this._chromaticAberrationEnabled = enabled;
        this._buildPipeline();
      }
      get chromaticAberrationEnabled() {
        return this._chromaticAberrationEnabled;
      }
      /**
       * Enable or disable the grain process from the pipeline
       */
      set grainEnabled(enabled) {
        if (this._grainEnabled === enabled) {
          return;
        }
        this._grainEnabled = enabled;
        this._buildPipeline();
      }
      get grainEnabled() {
        return this._grainEnabled;
      }
      /**
       * Instantiates a DefaultRenderingPipeline.
       * @param name The rendering pipeline name (default: "")
       * @param hdr If high dynamic range textures should be used (default: true)
       * @param scene The scene linked to this pipeline (default: the last created scene)
       * @param cameras The array of cameras that the rendering pipeline will be attached to (default: scene.cameras)
       * @param automaticBuild If false, you will have to manually call prepare() to update the pipeline (default: true)
       */
      constructor(name = "", hdr = true, scene = EngineStore.LastCreatedScene, cameras, automaticBuild = true) {
        super(scene.getEngine(), name);
        this._camerasToBeAttached = [];
        this.SharpenPostProcessId = "SharpenPostProcessEffect";
        this.ImageProcessingPostProcessId = "ImageProcessingPostProcessEffect";
        this.FxaaPostProcessId = "FxaaPostProcessEffect";
        this.ChromaticAberrationPostProcessId = "ChromaticAberrationPostProcessEffect";
        this.GrainPostProcessId = "GrainPostProcessEffect";
        this._glowLayer = null;
        this.animations = [];
        this._imageProcessingConfigurationObserver = null;
        this._sharpenEnabled = false;
        this._bloomEnabled = false;
        this._depthOfFieldEnabled = false;
        this._depthOfFieldBlurLevel = 0;
        this._fxaaEnabled = false;
        this._imageProcessingEnabled = true;
        this._bloomScale = 0.5;
        this._chromaticAberrationEnabled = false;
        this._grainEnabled = false;
        this._buildAllowed = true;
        this.onBuildObservable = new Observable();
        this._resizeObserver = null;
        this._hardwareScaleLevel = 1;
        this._bloomKernel = 64;
        this._bloomWeight = 0.15;
        this._bloomThreshold = 0.9;
        this._samples = 1;
        this._hasCleared = false;
        this._prevPostProcess = null;
        this._prevPrevPostProcess = null;
        this._depthOfFieldSceneObserver = null;
        this._activeCameraChangedObserver = null;
        this._activeCamerasChangedObserver = null;
        this._cameras = cameras || scene.cameras;
        this._cameras = this._cameras.slice();
        this._camerasToBeAttached = this._cameras.slice();
        this._buildAllowed = automaticBuild;
        this._scene = scene;
        const caps = this._scene.getEngine().getCaps();
        this._hdr = hdr && (caps.textureHalfFloatRender || caps.textureFloatRender);
        if (this._hdr) {
          if (caps.textureHalfFloatRender) {
            this._defaultPipelineTextureType = 2;
          } else if (caps.textureFloatRender) {
            this._defaultPipelineTextureType = 1;
          }
        } else {
          this._defaultPipelineTextureType = 0;
        }
        scene.postProcessRenderPipelineManager.addPipeline(this);
        const engine = this._scene.getEngine();
        this.sharpen = new SharpenPostProcess("sharpen", 1, null, Texture.BILINEAR_SAMPLINGMODE, engine, false, this._defaultPipelineTextureType, true);
        this._sharpenEffect = new PostProcessRenderEffect(engine, this.SharpenPostProcessId, () => {
          return this.sharpen;
        }, true);
        this.depthOfField = new DepthOfFieldEffect(this._scene, null, this._depthOfFieldBlurLevel, this._defaultPipelineTextureType, true);
        this._hardwareScaleLevel = engine.getHardwareScalingLevel();
        this._resizeObserver = engine.onResizeObservable.add(() => {
          this._hardwareScaleLevel = engine.getHardwareScalingLevel();
          this.bloomKernel = this._bloomKernel;
        });
        this.bloom = new BloomEffect(this._scene, this._bloomScale, this._bloomWeight, this.bloomKernel / this._hardwareScaleLevel, this._defaultPipelineTextureType, true);
        this.chromaticAberration = new ChromaticAberrationPostProcess("ChromaticAberration", engine.getRenderWidth(), engine.getRenderHeight(), 1, null, Texture.BILINEAR_SAMPLINGMODE, engine, false, this._defaultPipelineTextureType, true);
        this._chromaticAberrationEffect = new PostProcessRenderEffect(engine, this.ChromaticAberrationPostProcessId, () => {
          return this.chromaticAberration;
        }, true);
        this.grain = new GrainPostProcess("Grain", 1, null, Texture.BILINEAR_SAMPLINGMODE, engine, false, this._defaultPipelineTextureType, true);
        this._grainEffect = new PostProcessRenderEffect(engine, this.GrainPostProcessId, () => {
          return this.grain;
        }, true);
        let avoidReentrancyAtConstructionTime = true;
        this._imageProcessingConfigurationObserver = this._scene.imageProcessingConfiguration.onUpdateParameters.add(() => {
          this.bloom._downscale._exposure = this._scene.imageProcessingConfiguration.exposure;
          if (this.imageProcessingEnabled !== this._scene.imageProcessingConfiguration.isEnabled) {
            this._imageProcessingEnabled = this._scene.imageProcessingConfiguration.isEnabled;
            if (avoidReentrancyAtConstructionTime) {
              Tools.SetImmediate(() => {
                this._buildPipeline();
              });
            } else {
              this._buildPipeline();
            }
          }
        });
        this._buildPipeline();
        avoidReentrancyAtConstructionTime = false;
      }
      /**
       * Get the class name
       * @returns "DefaultRenderingPipeline"
       */
      getClassName() {
        return "DefaultRenderingPipeline";
      }
      /**
       * Force the compilation of the entire pipeline.
       */
      prepare() {
        const previousState = this._buildAllowed;
        this._buildAllowed = true;
        this._buildPipeline();
        this._buildAllowed = previousState;
      }
      _setAutoClearAndTextureSharing(postProcess, skipTextureSharing = false) {
        if (this._hasCleared) {
          postProcess.autoClear = false;
        } else {
          postProcess.autoClear = true;
          this._scene.autoClear = false;
          this._hasCleared = true;
        }
        if (!skipTextureSharing) {
          if (this._prevPrevPostProcess) {
            postProcess.shareOutputWith(this._prevPrevPostProcess);
          } else {
            postProcess.useOwnOutput();
          }
          if (this._prevPostProcess) {
            this._prevPrevPostProcess = this._prevPostProcess;
          }
          this._prevPostProcess = postProcess;
        }
      }
      _buildPipeline() {
        if (!this._buildAllowed) {
          return;
        }
        this._scene.autoClear = true;
        const engine = this._scene.getEngine();
        this._disposePostProcesses();
        if (this._cameras !== null) {
          this._scene.postProcessRenderPipelineManager.detachCamerasFromRenderPipeline(this._name, this._cameras);
          this._cameras = this._camerasToBeAttached.slice();
        }
        this._reset();
        this._prevPostProcess = null;
        this._prevPrevPostProcess = null;
        this._hasCleared = false;
        if (this.depthOfFieldEnabled) {
          if (this._cameras.length > 1) {
            for (const camera of this._cameras) {
              const depthRenderer = this._scene.enableDepthRenderer(camera);
              depthRenderer.useOnlyInActiveCamera = true;
            }
            this._depthOfFieldSceneObserver = this._scene.onAfterRenderTargetsRenderObservable.add((scene) => {
              if (this._cameras.indexOf(scene.activeCamera) > -1) {
                this.depthOfField.depthTexture = scene.enableDepthRenderer(scene.activeCamera).getDepthMap();
              }
            });
          } else {
            this._scene.onAfterRenderTargetsRenderObservable.remove(this._depthOfFieldSceneObserver);
            const depthRenderer = this._scene.enableDepthRenderer(this._cameras[0]);
            this.depthOfField.depthTexture = depthRenderer.getDepthMap();
          }
          if (!this.depthOfField._isReady()) {
            this.depthOfField._updateEffects();
          }
          this.addEffect(this.depthOfField);
          this._setAutoClearAndTextureSharing(this.depthOfField._effects[0], true);
        } else {
          this._scene.onAfterRenderTargetsRenderObservable.remove(this._depthOfFieldSceneObserver);
        }
        if (this.bloomEnabled) {
          if (!this.bloom._isReady()) {
            this.bloom._updateEffects();
          }
          this.addEffect(this.bloom);
          this._setAutoClearAndTextureSharing(this.bloom._effects[0], true);
        }
        if (this._imageProcessingEnabled) {
          this.imageProcessing = new ImageProcessingPostProcess("imageProcessing", 1, null, Texture.BILINEAR_SAMPLINGMODE, engine, false, this._defaultPipelineTextureType, this.scene.imageProcessingConfiguration);
          if (this._hdr) {
            this.addEffect(new PostProcessRenderEffect(engine, this.ImageProcessingPostProcessId, () => {
              return this.imageProcessing;
            }, true));
            this._setAutoClearAndTextureSharing(this.imageProcessing);
          } else {
            this._scene.imageProcessingConfiguration.applyByPostProcess = false;
          }
          if (!this._cameras || this._cameras.length === 0) {
            this._scene.imageProcessingConfiguration.applyByPostProcess = false;
          }
          if (!this.imageProcessing.getEffect()) {
            this.imageProcessing._updateParameters();
          }
        }
        if (this.sharpenEnabled) {
          if (!this.sharpen.isReady()) {
            this.sharpen.updateEffect();
          }
          this.addEffect(this._sharpenEffect);
          this._setAutoClearAndTextureSharing(this.sharpen);
        }
        if (this.grainEnabled) {
          if (!this.grain.isReady()) {
            this.grain.updateEffect();
          }
          this.addEffect(this._grainEffect);
          this._setAutoClearAndTextureSharing(this.grain);
        }
        if (this.chromaticAberrationEnabled) {
          if (!this.chromaticAberration.isReady()) {
            this.chromaticAberration.updateEffect();
          }
          this.addEffect(this._chromaticAberrationEffect);
          this._setAutoClearAndTextureSharing(this.chromaticAberration);
        }
        if (this.fxaaEnabled) {
          this.fxaa = new FxaaPostProcess("fxaa", 1, null, Texture.BILINEAR_SAMPLINGMODE, engine, false, this._defaultPipelineTextureType);
          this.addEffect(new PostProcessRenderEffect(engine, this.FxaaPostProcessId, () => {
            return this.fxaa;
          }, true));
          this._setAutoClearAndTextureSharing(this.fxaa, true);
        }
        if (this._cameras !== null) {
          this._scene.postProcessRenderPipelineManager.attachCamerasToRenderPipeline(this._name, this._cameras);
        }
        if (this._scene.activeCameras && this._scene.activeCameras.length > 1 || this._scene.activeCamera && this._cameras.indexOf(this._scene.activeCamera) === -1) {
          this._scene.autoClear = true;
        }
        if (!this._activeCameraChangedObserver) {
          this._activeCameraChangedObserver = this._scene.onActiveCameraChanged.add(() => {
            if (this._scene.activeCamera && this._cameras.indexOf(this._scene.activeCamera) === -1) {
              this._scene.autoClear = true;
            }
          });
        }
        if (!this._activeCamerasChangedObserver) {
          this._activeCamerasChangedObserver = this._scene.onActiveCamerasChanged.add(() => {
            if (this._scene.activeCameras && this._scene.activeCameras.length > 1) {
              this._scene.autoClear = true;
            }
          });
        }
        this._adaptPostProcessesToViewPort();
        if (!this._enableMSAAOnFirstPostProcess(this.samples) && this.samples > 1) {
          Logger.Warn("MSAA failed to enable, MSAA is only supported in browsers that support webGL >= 2.0");
        }
        this.onBuildObservable.notifyObservers(this);
      }
      _disposePostProcesses(disposeNonRecreated = false) {
        for (let i = 0; i < this._cameras.length; i++) {
          const camera = this._cameras[i];
          if (this.imageProcessing) {
            this.imageProcessing.dispose(camera);
          }
          if (this.fxaa) {
            this.fxaa.dispose(camera);
          }
          if (disposeNonRecreated) {
            if (this.sharpen) {
              this.sharpen.dispose(camera);
            }
            if (this.depthOfField) {
              this._scene.onAfterRenderTargetsRenderObservable.remove(this._depthOfFieldSceneObserver);
              this.depthOfField.disposeEffects(camera);
            }
            if (this.bloom) {
              this.bloom.disposeEffects(camera);
            }
            if (this.chromaticAberration) {
              this.chromaticAberration.dispose(camera);
            }
            if (this.grain) {
              this.grain.dispose(camera);
            }
            if (this._glowLayer) {
              this._glowLayer.dispose();
            }
          }
        }
        this.imageProcessing = null;
        this.fxaa = null;
        if (disposeNonRecreated) {
          this.sharpen = null;
          this._sharpenEffect = null;
          this.depthOfField = null;
          this.bloom = null;
          this.chromaticAberration = null;
          this._chromaticAberrationEffect = null;
          this.grain = null;
          this._grainEffect = null;
          this._glowLayer = null;
        }
      }
      /**
       * Adds a camera to the pipeline
       * @param camera the camera to be added
       */
      addCamera(camera) {
        this._camerasToBeAttached.push(camera);
        this._buildPipeline();
      }
      /**
       * Removes a camera from the pipeline
       * @param camera the camera to remove
       */
      removeCamera(camera) {
        const index = this._camerasToBeAttached.indexOf(camera);
        this._camerasToBeAttached.splice(index, 1);
        this._buildPipeline();
      }
      /**
       * Dispose of the pipeline and stop all post processes
       */
      dispose() {
        this._buildAllowed = false;
        this.onBuildObservable.clear();
        this._disposePostProcesses(true);
        this._scene.postProcessRenderPipelineManager.detachCamerasFromRenderPipeline(this._name, this._cameras);
        this._scene._postProcessRenderPipelineManager.removePipeline(this.name);
        this._scene.autoClear = true;
        if (this._resizeObserver) {
          this._scene.getEngine().onResizeObservable.remove(this._resizeObserver);
          this._resizeObserver = null;
        }
        this._scene.onActiveCameraChanged.remove(this._activeCameraChangedObserver);
        this._scene.onActiveCamerasChanged.remove(this._activeCamerasChangedObserver);
        this._scene.imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingConfigurationObserver);
        super.dispose();
      }
      /**
       * Serialize the rendering pipeline (Used when exporting)
       * @returns the serialized object
       */
      serialize() {
        const serializationObject = SerializationHelper.Serialize(this);
        serializationObject.customType = "DefaultRenderingPipeline";
        return serializationObject;
      }
      /**
       * Parse the serialized pipeline
       * @param source Source pipeline.
       * @param scene The scene to load the pipeline to.
       * @param rootUrl The URL of the serialized pipeline.
       * @returns An instantiated pipeline from the serialized object.
       */
      static Parse(source, scene, rootUrl) {
        return SerializationHelper.Parse(() => new _DefaultRenderingPipeline(source._name, source._name._hdr, scene), source, scene, rootUrl);
      }
    };
    __decorate([
      serialize()
    ], DefaultRenderingPipeline.prototype, "sharpenEnabled", null);
    __decorate([
      serialize()
    ], DefaultRenderingPipeline.prototype, "bloomKernel", null);
    __decorate([
      serialize()
    ], DefaultRenderingPipeline.prototype, "_bloomWeight", void 0);
    __decorate([
      serialize()
    ], DefaultRenderingPipeline.prototype, "_bloomThreshold", void 0);
    __decorate([
      serialize()
    ], DefaultRenderingPipeline.prototype, "_hdr", void 0);
    __decorate([
      serialize()
    ], DefaultRenderingPipeline.prototype, "bloomWeight", null);
    __decorate([
      serialize()
    ], DefaultRenderingPipeline.prototype, "bloomThreshold", null);
    __decorate([
      serialize()
    ], DefaultRenderingPipeline.prototype, "bloomScale", null);
    __decorate([
      serialize()
    ], DefaultRenderingPipeline.prototype, "bloomEnabled", null);
    __decorate([
      serialize()
    ], DefaultRenderingPipeline.prototype, "depthOfFieldEnabled", null);
    __decorate([
      serialize()
    ], DefaultRenderingPipeline.prototype, "depthOfFieldBlurLevel", null);
    __decorate([
      serialize()
    ], DefaultRenderingPipeline.prototype, "fxaaEnabled", null);
    __decorate([
      serialize()
    ], DefaultRenderingPipeline.prototype, "samples", null);
    __decorate([
      serialize()
    ], DefaultRenderingPipeline.prototype, "imageProcessingEnabled", null);
    __decorate([
      serialize()
    ], DefaultRenderingPipeline.prototype, "glowLayerEnabled", null);
    __decorate([
      serialize()
    ], DefaultRenderingPipeline.prototype, "chromaticAberrationEnabled", null);
    __decorate([
      serialize()
    ], DefaultRenderingPipeline.prototype, "grainEnabled", null);
    RegisterClass("BABYLON.DefaultRenderingPipeline", DefaultRenderingPipeline);
  }
});

export {
  BoundingBox,
  init_boundingBox,
  IntersectionInfo,
  init_intersectionInfo,
  BoundingSphere,
  init_boundingSphere,
  BoundingInfo,
  init_boundingInfo,
  SubMesh,
  init_subMesh,
  Material,
  init_material,
  FxaaPostProcess,
  init_fxaaPostProcess,
  Camera,
  init_camera,
  EffectFallbacks,
  init_effectFallbacks,
  BlurPostProcess,
  init_blurPostProcess,
  EffectLayer,
  init_effectLayer,
  EffectLayerSceneComponent,
  init_effectLayerSceneComponent,
  GlowLayer,
  init_glowLayer,
  PostProcessRenderEffect,
  init_postProcessRenderEffect,
  ExtractHighlightsPostProcess,
  init_extractHighlightsPostProcess,
  BloomMergePostProcess,
  init_bloomMergePostProcess,
  BloomEffect,
  init_bloomEffect,
  ChromaticAberrationPostProcess,
  init_chromaticAberrationPostProcess,
  CircleOfConfusionPostProcess,
  init_circleOfConfusionPostProcess,
  DepthOfFieldBlurPostProcess,
  init_depthOfFieldBlurPostProcess,
  DepthOfFieldMergePostProcess,
  init_depthOfFieldMergePostProcess,
  DepthOfFieldEffectBlurLevel,
  DepthOfFieldEffect,
  init_depthOfFieldEffect,
  GrainPostProcess,
  init_grainPostProcess,
  ImageProcessingPostProcess,
  init_imageProcessingPostProcess,
  SharpenPostProcess,
  init_sharpenPostProcess,
  PostProcessRenderPipeline,
  init_postProcessRenderPipeline,
  PostProcessRenderPipelineManager,
  init_postProcessRenderPipelineManager,
  PostProcessRenderPipelineManagerSceneComponent,
  init_postProcessRenderPipelineManagerSceneComponent,
  DefaultRenderingPipeline,
  init_defaultRenderingPipeline
};
